webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(160);




/* harmony default export */ __webpack_exports__["a"] = ({ api: __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */], C: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* default */], M: __WEBPACK_IMPORTED_MODULE_2__common__["a" /* default */] });

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(931),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ddce87ea",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(804)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(898),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-211513a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var ls = window.localStorage;

/* harmony default export */ __webpack_exports__["a"] = ({
    getItem: function getItem(key) {
        try {
            return JSON.parse(ls.getItem(key));
        } catch (err) {
            return null;
        }
    },
    setItem: function setItem(key, val) {
        ls.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(val));
    },
    clear: function clear() {
        ls.clear();
    },
    keys: function keys() {
        return ls.keys();
    },
    removeItem: function removeItem(key) {
        ls.removeItem(key);
    }
});

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(830)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(918),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b8f2a5e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(805)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(899),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21cd2b2b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
    adminHost: 'https://services.leemma.com/',
    APIhost: 'https://services.leemma.com/api/base' };
if (false) {
    config.api = '/api/private/';
} else if (false) {
    config.api = '/api/private/';
} else if (true) {
    config.api = 'https://services.leemma.com/api/private/';
}
/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAYAAAAJKR1YAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTM4IDc5LjE1OTgyNCwgMjAxNi8wOS8xNC0wMTowOTowMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkQxODlCOTFCQTVDNzExRTdCQ0ZCQzRDNTMxM0VDNTI1IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkQxODlCOTFDQTVDNzExRTdCQ0ZCQzRDNTMxM0VDNTI1Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RDE4OUI5MTlBNUM3MTFFN0JDRkJDNEM1MzEzRUM1MjUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RDE4OUI5MUFBNUM3MTFFN0JDRkJDNEM1MzEzRUM1MjUiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7TKXffAAABK0lEQVR42mL8//8/w2ACLGz1fwaVg5gYBhmgpoMsgLgciBkHi4NYgLgDiDcDsfBgijJvID4HDbFBk4bkgPgQEBeSGoW0TNSsQNwHxOuAWICUeIcBQQodwItDPACI9YE4DIjPkOKgdzQMLUUgPgLEJUA8ZbCUQ+xAPBmIVwEx32AqGEOhUWcwmEpqVSA+DsRpg6nq4ADimUC8BIh5sCXqgQLRQMwNxIGDpXJdCsSxgyHKfgBxOhDHAPGXgY6y29CC8sJgSNSrgdgEm2Po7aCfQJwLDZlPxFQdQlRooG3DIXefnLrsPYUO+oxDfAMQJwLxh4FufvwG4iIgDiLWMbTMZY+AOByITwyGFuNWIDYixzHUdhCog1cBxL5A/JaSngK1wAlyQ2VQdxQBAgwAGvAw5eby+N4AAAAASUVORK5CYII="

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(839)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(926),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e5499f0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(912),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4114cd08",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LSstore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);







var device = localStorage.getItem('deviceInfo');

var common = {
  load: function load(url, params, callback, type) {
    var startTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(),
        endTime = void 0,
        timeInfo = void 0,
        _this = this;
    __WEBPACK_IMPORTED_MODULE_2_axios___default()({
      method: type ? type : 'POST',
      baseURL: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].APIhost,
      url: url,
      data: params,
      params: type === 'get' || type === 'GET' ? params : ''
    }).then(function (res) {
      callback(res.data);
      endTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()();

      if (!device || !device.name) {
        try {
          device = JSON.parse(localStorage.getItem('deviceInfo'));
        } catch (error) {
          device = {};
        }
      }
      timeInfo = {
        payload: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([{
          diff: endTime.diff(startTime, 'ms'),
          params: params,
          status: res.data.status_code,
          url: url,
          deviceId: device.device_sn,
          name: device.name,
          date: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
          is_connected: params.is_cache ? params.is_cache : false

        }])
      };
      if (params.auth_token) {
        timeInfo.auth_token = params.auth_token;
      } else {
        timeInfo.customer_token = params.customer_token;
      }
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__config__["a" /* default */].APIhost + '/statistics/api_timeout', timeInfo);
      localStorage.setItem('timeInfo', timeInfo);

      if (res.data && res.data.status_code !== 'SUCCEEDED') {}
    }).catch(function (err) {
      if (err.response) {
        console.error(err);
        var status = err.response.status;
        if (status === 401) {
          location.href = "/error?error=401";
        } else if (status === 404) {
          location.href = "/error?error=404";
        }
      } else {
        console.error(err);
      }
    });
  },

  ls: __WEBPACK_IMPORTED_MODULE_4__LSstore__["a" /* default */],
  guid: function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  },
  isJson: function isJson(obj) {
    var isjson = (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) == "object" && Object.prototype.toString.call(obj).toLowerCase() == "[object object]" && !obj.length;
    return isjson;
  },
  selectInputFoc: function selectInputFoc() {
    var inputSelect = document.getElementsByClassName('el-input__inner');
    for (var i = 0; i < inputSelect.length; i++) {
      inputSelect[i].onfocus = function () {
        this.blur();
      };
    }
  },
  getMax: function getMax(numA, numB) {
    if ((numA < 0 || numA > 2000) && (numB < 0 || numB > 2000)) {
      return 0;
    }
    if (numB < 0 || numB > 2000) {
      return numA;
    } else if (numA < 0 || numA > 2000) {
      return numB;
    }
    if (numB < numA) {
      return numA;
    }
    return numB;
  },
  getPrecision: function getPrecision(a) {
    if (!isFinite(a)) return 0;
    var e = 1,
        p = 0;
    while (Math.round(a * e) / e !== a) {
      e *= 10;p++;
    }
    return p;
  },
  creatAliasMeun: function creatAliasMeun(MaxAlias) {
    var sys_alias = [];
    for (var i = 0; i < MaxAlias; i++) {
      sys_alias.push({
        val: '' + (i + 1),
        label: i + 1 + '\u53F7\u7A91'
      });
    }
    return sys_alias;
  },
  isWeChat: function isWeChat() {
    var ua = window.navigator.userAgent.toLowerCase();

    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
    } else {
      return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA+gAAAEsBAMAAACia4RcAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAtUExURUxpcf///////////////5eXl/7+/v7+/v////X19WpoaPX19f///6Oiov///1CRmdwAAAAOdFJOUwDAQYDYEiip8Jk/dmB9J4GYtAAAESFJREFUeNrs3c9rW9kVB3BF1g87UoRnMWUWU2O6GLoSKV10U4wLbWkH8lDapGVMIrRoSxdFqBRKN/Pwot2EYrwplKGIFOqSGhK8mc0shP8CkU02gQQ/S5bl2H5/Q2V7Mo3vPffec+59ZSzr+90MY55k6X107zvnvhs5l0MQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQ5Nqm9C15lrVn+Zn8SYjXYju8ZXoD7AeVhK/G+aCPHKc2b3hcI4CrlpLZkz3LjVQe/VfU5U9CvBbb4R2Tiu1Bt9nv1ARRsDwmcZzatuFxO0BnopveViUb9F0hHAe9a3jcKtCZ6Ps+r5+PbppI+gHokeFxI6Az0Y8Mr7+ZDbpp9MX+6MYLzwDoTPSh4fXXs0E3jb4Nf/QF6VsBupaWfCgK0I8NBXjqjz4vfStA55ZaUTboiXC0MtDN52QT6Ez0jrxjE6Cn8o7NhR6LCwigq1mXd2wS9GVxx+ZC3xB3IkDnlVo3skLfFHdsDvSq+YGHQGeiD+QdmwR9VV4m2tHL5geOgc5ET+QdmwR9JO7YHOhN8bUE6Mzl8Tgr9BNxx+ZA73us/wGdNTyirNAPxR2bA932cTwAOhO9I+7YJOhjccdmRy+JpxWgM0utSmbo5ETS9EeviKcVoDNLrXJ26LelHZsdvSCvT4DOWx6vZYe+Ki4TE58dFBfZAToP/VDcsYnQD6Qdmx19xWNVAOisR3SzQz8Rl4mJzw4K+51coDNKrSg7dGIimfNHL8kvVUDnLY87Tq0IfSgtxqzoC+JfBnTmhbCSITqxtaHpj14Q/zKgMy+E5SzRd4QdmxW9Lp61gM4stWpZoi8KOzYreiyetYDOLLXqWaLvCTs2K/qGeNYCOnN5vJsl+r60TLSg51PxBxjozOonyhL9SNix2dBdxYb3PorZQ78tHIoy9KH01CR+OygsN4qB7i61qpmiaxNJ0x+973z7HaDz0A+kk6gMfVf4phL/4t20uRfozlJrPlv0jlDOjF50v/0ToPPQD6W/VYa+LiwTE78dFEHl++yhD4UdmxB9X1gmJt6LsGdpXD304Xctuc1FH1iexANdLbWibNEHwuGaeO6goCuIK4CeyJ6lnslrcZ6oHdlQFKIPhXOg+Rz1GOiLQOehd2QdmxBdmXGb/ugRA30EdB76nqxjk6LvyuqUxHMHxUWOgc5D35d1bFL0jqzXTjx3UBgWAIHOWR6vZ42+Kpujk5Di3XMfxQyiD2UdmxR9JJujk5Di3XMfxQyiXx4dUdbox7IFlsR/EVafV4DOKrUYa51C9CTgcMkOioDyfRbRO6KOTYqeMk4v4xzlWebGb8YDumV5vJw9+rKoTEx8d1AElO+ziD4SdWxi9E1RmWg6R9QLizLaRzGL6ANZjSxFXxWViYlgB8W3M9pHMYvo776slezRR6JVtURQvJcz2kcxi+jvLo9H2aOfiG6JJ/wdFIdVxp4QoDtLraL7oslA3zDtbCh7o1O+x8WM9lHMBnpiug4q5zb2Qx9f/j/j2V3in6Mb5HUjymYfxWygH5lKLWUo9vzQE9OK3+V3lAjQ22SFuJLNPorZQB9EhlJLaYzqfugD0wMud2xHAvQe2Qu2synf/6/o4/csWeSiJ5YnYaIfxoblceUs1vzQ900TyeXP2okAnW7Jqeb94IqhC/Yy8JavrEuetmv6iqH4ufzzxBN9ZGBQOrYRH53q9cZ0YXgMdAN63fCwywxHnuh7G3QXpXRsq3z0BbpOz2ezEDsj6E26Z1N6oH3Pa/reEj2RKAOzw0cv0P1/MZt9FDOCXqCXx5WRc+CLvkKPPeUSvMNHbxsu3tQz7ACdRi/TpZb6Y0/0UZ0ee8qPl/noXcOafs+x1g/0d85shV4eVyaAjif6fpMeewpdjo8eGUZ023HTEOjvnNk8vTyunMNdX/QC3TpHCi8bPW+6dlPX+iOg0+g5esFamS1bvuhl8q2V1Du6bPSyqUovZ1K+zwp6RC6PLyk/9UWfI+98VdWfstHnTXdW8vb7R0C/dFxMlVpF9bT6oufJCVcb/2z0uukeKtmzdYBOH9ejIPPq2pYvepGccOfVKpuNHhvPF/UU60Cnj1NKtkVqKI680dVqu0W9n002umU890xzAND142rU8nhBHTHe6DF1u7OrXnq56OS+7B3jqs0h0OnjblCDo62OJW/0HjUqleHfYKOXzautVM82bgCdPG6OKrV66ljyRm8TV9mSdqHnojfNjRn5edgFOnlcnjqFS+pY8kafJxbJqtrnjIveMy/B5LMo32cFvUhNlqnavHujl9V1GH1Q7vPRI0u1lhpuxQCdOC7Sy6K8Vg95oh+rV4+E6NgO2Ojkbvl1Szd3AnT6uK4+I+rD0xN9oM26xNtZZaNXbFN4L4OF2JlBr+sDp6BNoN7o6j8sXs5RHzMmesFWrLXNlT3Q1eOaeqnV1l6QP3qsPybSPgdMdNK1YftE7ACdPK6gXwZ72iqdP7r+XEVdjYnetc3g5PcPrQKdPG5BX8XSR6c/ut6oE01iykOPyFrRdqt9BHTyOMJAn3/90fVGnVgO4qE7WFNzEw909Thtti3px/ijl7WBSSz88tDL9gk8Di/fZwd9SR3Xef3s+6NXtasHcYuHhz5vX3TrhZfvs4O+olIu6Kto/uj6QntbH6o8dPJFLNtr+02gk8fV1fqamH/90fVbaj2dhYce299owbZeB/TLx82rv76mn7cA9FgdmbE+VFnoxQ3iqHdumS+klpV5oF8+Ttsm09avmgHofXVgR/riCgu9mto6NkNxfwh08riKehr7+qpWAHpTvXoQ9TULvexqxKmZYAx08riSOja6egEcgK5caveoDbIs9KZryS22Lc1//ehX52+46CNkqG16D0NXLrX7FeKiy0Lvu6rzvr2l+7rRr863SxEjpEVcFQPQlZE9KOttOg89sndshp7tAOgkujJCPiJKpQB09R9OFIj5mXOOyB0UY+ed1xOgk+jKCPkHUSoFoKv/cKpGzM+cc1RxFucLweX7DKErI+SnxPJGCLqy4tcj5mfOOXKPY/pLwVtAp9CVq+yQqIRC0JXHEm06C51xxaZ6NtE+ihlCt3+f/04oes327MMcF73r6tgMPdsq0Cl0+1cyt0LRrWsVR2z0yD2M+67lG6D/bxEnsqiMc6Hoczb0fS46/cn8waVvTIyMrwHoGnrXonIYjG6dSA646Kw/wWe+gABdRbct8x4Ho1v/vNIqF33eF11Svs8SetNyykbh6LHl6Te56HVv9E2gU+i2P2S5Ho7eszz9Mhc99kZfBTqFbrtedsLR25anb3DRN7zR94FOoeddbXoYuuVynOSY6FVvc8lC7Fv05Pu/afzid9+51ug5ZxkUhG75gy0DLnrZH30sRv/wYv7JPVi6zuhLrjPWC0GvOqde9zlq+qMLvk7uAv2PF/8zkS/F1xh9xTU3roSgWxr1PS56PwC9I0P/Ri5X/Pf3fv+HX5+99KXri952tOlh6JYVv0UuehyAfiBC/+tkato+e8Xvfzi5tFU3ri36vKNND0Q3i91mopcCzAX7KCbow1bu53fupcNX24+3tycz/K+uLXrZ0aYHovddl1vnOaqEoB9K0H88Gdyb3Ttba0+3Xm1vrTVKkePZ96YVveK6Hoahm6uwHBO9EILO/7N8tXTYyHXHTz++/58o/dtG+ucvio17WaFfrd2wttlzNwv0gqNNd6O3g9B3+Og/yt1NT/Nrf5886uUZ1OfOoc5GFz6Lx7qzDN283tXKAn3B0aa70VeC0NkLsbVxqxilj3I3t7df/enl+f3+Yu631xU9dtyXDEPPu1ZInehREDp7H0XtZDIrffp47emrl1v3185HwueN6nVF7ztqoDD0ouututCDinfBn+WrLeY++KJx80x7/M3i07P/njYaS9cUve3odsLQjQN1kYm+EIbO3kdRa1U+e7h18duO7r54ePafhqOgmF70gmNiDERfsbfpTvSw4p2/j2Iht3bzzoO7549582z84p+TWaLh+MhNL3rZUQIFotcdq+Iu9HogOncfRSl3v7vz6bOLZjVOh4976ekDx8VletGrjmXrQPSa41W60ONAdP4+iifJrTcX6NtnF/Rb6em/bPejphq9aG/TQ9Fda1Qu9I1AdHb5fjN99OzN6/NL+vmk/vz16ZNl+92e6UU3lVqtbNDn7G26Cz0faM5fiP1l+jy6QH90Pt6Pb50+69jv604xetde9gail+xtugu9HIrO3UdRrI0fphfoLy6GwfPPnq3bFacYvW4fIYHohvl5j4neDEVn76Pon967QD/9smQ/LfZG9n+uMcXoTWubHoweW9t0F3o/GJ27jyKeVHHn6Juvv5wjHkcn9g16U4xesBdAoeg9a5tecqDHwejrTPSl9+Nz9ONbbx/5vHts79mmGH3O3uqEoretk27ejl4MNmfvo4hebKRnLdvz12+rga0ng2uLnrfPiqHo8/JfnmSzg0JWvkeT7vz0SfrxVwP99JOFgf1TN8XoOWubHoxetrI60OlLz/g9Mh/Q54O5j+InTycdeuF07asLyl9ebw+sW8SnGn3JumYdim7/tkcHOn1tMHyVe8W+yuTIDz+ZfJq2/9ve/bs2EcZxHE9DEo1tBbeKDvUfCC6uRWcxnOANBhvqJg5BcbbUwV8Bg05OShADGgjo6iB1cit2KGg1g1hrgiR/g3fJmbbJ83zvHu8Q+/h+rc2Fu/vk7r7f53mSNj6OttsoPjxr75W+ILXpsUPPiWViSOhv5SZ/bPi8LzcKsusX+p0nzvOdnZjt3/5i7TM95B/Uxg1dOeK3EjH0olFBXowxEJttL242Shs7b1H1Orhn9oZ+UKx5Y4e+LJWJcug5s9Zb3d9FW0eRdQ81PxeDGRdfo9jvOdb26cpSazu50FXjK6+ihZ43e0oX5AHlkAl1f+3rz9Gx9Lyz8sOxdkROWQCdTi70slQmyqFnzOrxsjx1JJv2Q+80f29Uf9r3F0XbOvauvIleSy70jDQLIodeMbt0NZ+RiOsoLg6OOygdq/5Nxgu9bGvoqjmR1eRCz0tlohy6+iGt/dEozb042jqK7CD03vBguiW/j/3mWjufrjy3S8mFnpZqKzn0mlk5rqn7Iq6jmK0F9Zt3iddfDIZnHFtXzihLra1UcqFnpRjE0NOmV27NZCxnnLPo5131OvWvGy+D252ta+SUj85ugqErrpaVaKEfMOvYdI+DqMugr5bWa14pN3ezMVj27u9G3t7QM9KYV/zQF4TYxNA1X6PWL4tYM91g78rIN26p1f6QLX0afTQr9oY+eUV9TzL0gr5Nl0NfM51BKZveGvZw+3fbzWarHgzFdpZCFsPu79BnpMdm/NAPC2WiGLr6bi182VvTs0VdRzE82d1g0uVO6A9b7evQs1JrGz/0KX2bLoaumeEShlU1PVvUn5NLD0feH7jr/k54N5QrFoc+OVMxn2To0/o2XQx9xrgD05T7BsugB841Wq9veafA3u+nK1dBO0mGnhOuVSn0KfOxlpppFTDmxPD19zcd102lEvslin8y9ILQ5MQPfSKK7WihV8xHVZfNZmgmvR/u69YpN/Un8kfMTc73XzZ/E8W+hL3u/Nifju362zvVtquhR3p81wse6Q8zp9r2aHDZqY9PasA0m5yMHtulx3P3ztyYT+H/4nIKAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgL/qFwR5ItokVk3fAAAAAElFTkSuQmCC"

/***/ }),
/* 369 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 370 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(824)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(913),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44b855ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(930),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d7aa5c76",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(798)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(893),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10631b1c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(840)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(927),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-70f067e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(800)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(895),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-16fa4804",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_demo_vue__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_demo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_demo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_login_vue__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_logout_vue__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_logout_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_error_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_error_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_user_setting_vue__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_user_setting_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_user_setting_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_user_msgList_vue__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_user_msgList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_user_msgList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_user_deviceList_vue__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_user_deviceList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_user_deviceList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_tempControl_index_vue__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_tempControl_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_tempControl_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_tempControl_realData_vue__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_tempControl_realData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_tempControl_realData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_tempControl_historyData_vue__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_tempControl_historyData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_tempControl_historyData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_tempControl_standardSet_vue__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_tempControl_standardSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_tempControl_standardSet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_tempControl_controlSet_vue__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_tempControl_controlSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_tempControl_controlSet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_tempControl_deviceConf_vue__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_tempControl_deviceConf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_tempControl_deviceConf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_tempControl_autoVal_vue__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_tempControl_autoVal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_tempControl_autoVal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_mobileTemp_index_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_mobileTemp_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_mobileTemp_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_mobileTemp_realData_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_mobileTemp_realData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_mobileTemp_realData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_mobileTemp_historyData_vue__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_mobileTemp_historyData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_mobileTemp_historyData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_mobileTemp_standardSet_vue__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_mobileTemp_standardSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_mobileTemp_standardSet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_mobileTemp_controlSet_vue__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_mobileTemp_controlSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_mobileTemp_controlSet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_mobileTemp_deviceConf_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_mobileTemp_deviceConf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_mobileTemp_deviceConf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_mobileTemp_autoVal_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_mobileTemp_autoVal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_mobileTemp_autoVal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_allocateWater_realData_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_allocateWater_realData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_allocateWater_realData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_allocateWater_index_vue__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_allocateWater_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_allocateWater_index_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_allocateWater_controlConf_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_allocateWater_controlConf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_allocateWater_controlConf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_allocateWater_standConf_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_allocateWater_standConf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_allocateWater_standConf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_allocateWater_outputData_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_allocateWater_outputData_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_allocateWater_outputData_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_allocateWater_deviceConf_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_allocateWater_deviceConf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_allocateWater_deviceConf_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_allocateWater_autoVal_vue__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_allocateWater_autoVal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_allocateWater_autoVal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_tempControl_chartsPlayer_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_tempControl_chartsPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_tempControl_chartsPlayer_vue__);






































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: "history",
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },

    routes: [{
        path: '',
        redirect: '/login'
    }, {
        path: '/login',
        name: '登陆',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_login_vue___default.a
    }, {
        path: '/error',
        name: '错误啦',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_error_vue___default.a
    }, {
        path: '/chartsPlayer',
        name: '播放',
        component: __WEBPACK_IMPORTED_MODULE_30__components_tempControl_chartsPlayer_vue___default.a

    }, {
        path: '/tempControl/',
        component: __WEBPACK_IMPORTED_MODULE_9__pages_tempControl_index_vue___default.a,
        children: [{
            path: '',
            redirect: '/tempControl/realData'
        }, {
            path: 'realData',
            name: '工艺曲线',
            component: __WEBPACK_IMPORTED_MODULE_10__pages_tempControl_realData_vue___default.a
        }, {
            path: 'historyData',
            name: '产量报表',
            component: __WEBPACK_IMPORTED_MODULE_11__pages_tempControl_historyData_vue___default.a
        }, {
            path: 'standardSet',
            name: '标准参数',
            component: __WEBPACK_IMPORTED_MODULE_12__pages_tempControl_standardSet_vue___default.a
        }, {
            path: 'controlSet',
            name: '控制参数',
            component: __WEBPACK_IMPORTED_MODULE_13__pages_tempControl_controlSet_vue___default.a
        }, {
            path: 'autoVal',
            name: '控制变量',
            component: __WEBPACK_IMPORTED_MODULE_15__pages_tempControl_autoVal_vue___default.a
        }, {
            path: 'deviceConf',
            name: '设备配置',
            component: __WEBPACK_IMPORTED_MODULE_14__pages_tempControl_deviceConf_vue___default.a
        }]
    }, {
        path: '/MtempControl/',
        component: __WEBPACK_IMPORTED_MODULE_16__pages_mobileTemp_index_vue___default.a,
        children: [{
            path: '',
            redirect: '/MtempControl/realData'
        }, {
            path: 'realData',
            name: '工艺曲线',
            component: __WEBPACK_IMPORTED_MODULE_17__pages_mobileTemp_realData_vue___default.a
        }, {
            path: 'historyData',
            name: '产量报表',
            component: __WEBPACK_IMPORTED_MODULE_18__pages_mobileTemp_historyData_vue___default.a
        }, {
            path: 'standardSet',
            name: '标准参数',
            component: __WEBPACK_IMPORTED_MODULE_19__pages_mobileTemp_standardSet_vue___default.a
        }, {
            path: 'controlSet',
            name: '控制参数',
            component: __WEBPACK_IMPORTED_MODULE_20__pages_mobileTemp_controlSet_vue___default.a
        }, {
            path: 'autoVal',
            name: '控制变量',
            component: __WEBPACK_IMPORTED_MODULE_22__pages_mobileTemp_autoVal_vue___default.a
        }, {
            path: 'deviceConf',
            name: '设备配置',
            component: __WEBPACK_IMPORTED_MODULE_21__pages_mobileTemp_deviceConf_vue___default.a
        }]
    }, {
        path: '/allocate/',
        component: __WEBPACK_IMPORTED_MODULE_24__pages_allocateWater_index_vue___default.a,
        children: [{ path: '', redirect: 'realData' }, { path: 'realData', name: '实时数据', component: __WEBPACK_IMPORTED_MODULE_23__pages_allocateWater_realData_vue___default.a }, { path: 'outputData', name: '统计数据', component: __WEBPACK_IMPORTED_MODULE_27__pages_allocateWater_outputData_vue___default.a }, { path: 'standConf', name: '标准参数', component: __WEBPACK_IMPORTED_MODULE_26__pages_allocateWater_standConf_vue___default.a }, { path: 'controlConf', name: '控制参数', component: __WEBPACK_IMPORTED_MODULE_25__pages_allocateWater_controlConf_vue___default.a }, {
            path: 'autoVal',
            name: '控制变量',
            component: __WEBPACK_IMPORTED_MODULE_29__pages_allocateWater_autoVal_vue___default.a
        }, {
            path: 'deviceConf',
            name: '设备配置',
            component: __WEBPACK_IMPORTED_MODULE_28__pages_allocateWater_deviceConf_vue___default.a
        }]
    }, {
        path: '/user/',
        component: __WEBPACK_IMPORTED_MODULE_9__pages_tempControl_index_vue___default.a,
        children: [{ path: '', redirect: 'deviceList' }, { path: 'setting', name: '账户设置', component: __WEBPACK_IMPORTED_MODULE_6__pages_user_setting_vue___default.a }, { path: 'msgList', name: '消息列表', component: __WEBPACK_IMPORTED_MODULE_7__pages_user_msgList_vue___default.a }, { path: 'deviceList', name: '设备列表', component: __WEBPACK_IMPORTED_MODULE_8__pages_user_deviceList_vue___default.a }]
    }, {
        path: '/demo/',
        name: 'demo',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_demo_vue___default.a
    }, {
        path: '/logout',
        name: 'logout',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_logout_vue___default.a
    }, {
        path: '*',
        name: 'error',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_error_vue___default.a
    }]
}));

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__states__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__action__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(486);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__states__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_3__action__["a" /* default */]
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ElButton',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: String,
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: Boolean,
    disabled: Boolean,
    plain: Boolean,
    autofocus: Boolean
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _name$components$crea;

/* harmony default export */ __webpack_exports__["default"] = (_name$components$crea = {
  name: "app",
  components: {},
  created: function created() {},
  mounted: function mounted() {},
  data: function data() {
    return {
      showMe: true
    };
  },


  computed: {
    isLoading: function isLoading() {
      return this.$store.state.isLoading;
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, "created", function created() {
  this.checkMobile();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, "mounted", function mounted() {
  document.getElementById("first-loading").style.display = "none";
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, "methods", {
  checkMobile: function checkMobile() {
    var isMobile = false;
    var browser = {
      versions: function () {
        var u = navigator.userAgent,
            app = navigator.appVersion;
        return {
          trident: u.indexOf("Trident") > -1,
          presto: u.indexOf("Presto") > -1,
          webKit: u.indexOf("AppleWebKit") > -1,
          gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1,
          mobile: !!u.match(/AppleWebKit.*Mobile.*/),
          ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
          android: u.indexOf("Android") > -1,
          iPhone: u.indexOf("iPhone") > -1,
          iPad: u.indexOf("iPad") > -1,
          webApp: u.indexOf("Safari") === -1,
          weixin: u.indexOf("MicroMessenger") > -1 };
      }(),
      language: (navigator.browserLanguage || navigator.language).toLowerCase()
    };
    if (browser.versions.mobile || browser.versions.ios || browser.versions.android || browser.versions.iPhone || browser.versions.iPad) {
      isMobile = true;
    }
    this.$store.dispatch("setIsMobile", isMobile);
  },
  initREM: function initREM() {
    var win = window;

    var flex = function flex(baseFontSize, fontscale) {
      var _baseFontSize = baseFontSize || 100;
      var _fontscale = fontscale || 2;
      var doc = win.document;
      var ua = navigator.userAgent;
      var matches = ua.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i);
      var UCversion = ua.match(/U3\/((\d+|\.){5,})/i);
      var isUCHd = UCversion && parseInt(UCversion[1].split(".").join(""), 10) >= 80;
      var isIos = navigator.appVersion.match(/(iphone|ipad|ipod)/gi);
      var dpr = win.devicePixelRatio || 1;
      if (!isIos && !(matches && matches[1] > 534) && !isUCHd) {
        dpr = 1;
      }
      var scale = 1 / dpr;
      var metaEl = doc.querySelector('meta[name="viewport"]');
      if (!metaEl) {
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        doc.head.appendChild(metaEl);
      }
      metaEl.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + scale + ",maximum-scale=" + scale + ",minimum-scale=" + scale);
      doc.documentElement.style.fontSize = _baseFontSize / 2 * dpr * _fontscale + "px";
      console.log(doc.documentElement.style.fontSize);
    };
    flex(100, 1);
  }
}), _name$components$crea);

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

var moment = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['time', 'type'],
  data: function data() {
    return {
      showType: {
        year: true,
        month: true,
        day: true,
        hour: true,
        minute: true
      },
      inputTime: moment().format("YYYY-MM-DD"),

      cellHeight: 40,

      isShow: false,

      year: [2014, 2015, 2016, 2017, 2018, 2019],
      month: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      day: [],
      hour: [],
      minute: [],
      touchArgv: {
        month: { top: '', num: 0 },
        year: { top: '', num: 0 },
        day: { top: '', num: 0 },
        hour: { top: '', num: 0 },
        minute: { top: '', num: 0 }
      },

      selected: {
        type: '',
        start: '',
        end: '',
        month: '',
        year: '',
        day: '',
        hour: '',
        minute: ''
      }
    };
  },
  created: function created() {
    this.reloadDayList();
    this.initDataArr();
  },
  mounted: function mounted() {
    this.initTime();
  },

  computed: {
    deltaY: function deltaY() {
      return this.selected.start - this.selected.end;
    }
  },
  methods: {
    initShowType: function initShowType() {
      this.isShow = true;
      if (this.type === 'year') {
        for (var one in this.showType) {
          if (one !== 'year') {
            this.showType[one] = false;
          }
        }
      } else if (this.type === 'month') {
        for (var _one in this.showType) {
          if (_one !== 'year' && _one !== 'month') {
            this.showType[_one] = false;
          }
        }
      } else if (this.type === 'day') {
        for (var _one2 in this.showType) {
          if (_one2 === 'hour' || _one2 === 'minute') {
            this.showType[_one2] = false;
          }
        }
      } else {
        for (var _one3 in this.showType) {

          this.showType[_one3] = true;
        }
      }
    },
    initDataArr: function initDataArr() {
      for (var i = 0; i < 24; i++) {
        if (i < 10) {
          this.hour[i] = '0' + i;
        } else {
          this.hour[i] = i;
        }
      }
      for (var _i = 0; _i < 60; _i++) {
        if (_i < 10) {
          this.minute[_i] = '0' + _i;
        } else {
          this.minute[_i] = _i;
        }
      }
    },
    touchStart: function touchStart(type, e) {
      this.selected.start = e.targetTouches[0].pageY;
    },
    touchMove: function touchMove(type, e) {
      if (event.targetTouches.length > 1 || event.scale && event.scale !== 1) return;

      this.selected.end = e.targetTouches[0].pageY;

      this.touchArgv['' + type].top = this.touchArgv['' + type].num - this.deltaY + 'px';
    },
    touchend: function touchend(type, e) {
      var num = this.touchArgv['' + type].num;
      num = num - this.deltaY;
      this.moveSelected(type, num);
    },
    moveSelected: function moveSelected(type, num) {
      var yu = Math.abs(num % this.cellHeight);
      if (yu > this.cellHeight / 2) {
        num = num > 0 ? num - yu + this.cellHeight : num + yu - this.cellHeight;
      } else {
        num = num > 0 ? num - yu : num + yu;
      }

      var maxTop = void 0,
          minTop = void 0,
          length = void 0,
          cellHeight = this.cellHeight;
      length = this['' + type].length;
      minTop = -(length - 3) * cellHeight;
      maxTop = 2 * cellHeight;
      if (num > maxTop) {
        num = maxTop;
      } else if (num < minTop) {
        num = minTop;
      }

      this.touchArgv['' + type].top = num + 'px';
      this.touchArgv['' + type].num = num;

      var n = (num - 2 * cellHeight) / 40;
      this.selected['' + type] = this['' + type][Math.abs(n)];
      if (type === 'month') {
        this.reloadDayList(this.selected['' + type]);
      }
    },
    reloadDayList: function reloadDayList(month) {
      if (!month) {
        month = 1;
      }
      var len = moment(month, 'M').daysInMonth();
      this.day = [];
      for (var i = 0; i < len; i++) {
        if (i < 9) {
          this.day[i] = '0' + (i + 1);
        } else {
          this.day[i] = i + 1;
        }
      }
    },
    dateFormat: function dateFormat() {
      var select = this.selected,
          showType = this.showType,
          time = void 0;
      if (!select.year) {
        time = moment().format('YYYY-MM-DD HH:mm');
      } else {
        time = moment(select.year + select.month + select.day + select.hour + select.minute, 'YYYYMMDDHHmm').format('YYYY-MM-DD HH:mm');
      }
      if (this.type === 'year') {
        time = moment(time).format('YYYY');
      } else if (this.type === 'day') {
        time = moment(time).format('YYYY-MM-DD');
      } else if (this.type === 'month') {
        time = moment(time).format('YYYY-MM');
      }
      return time;
    },
    sureDate: function sureDate() {
      var select = this.selected;
      var time = void 0;
      time = this.dateFormat();
      this.$emit('input', time);
      this.inputTime = time;
      this.isShow = false;
    },
    initTime: function initTime() {
      var height = this.cellHeight,
          now = moment().format('YYYYMMDDHHmm');
      this.selected.year = now.slice(0, 4);
      this.selected.month = now.slice(4, 6);
      this.selected.day = now.slice(6, 8);
      this.selected.hour = now.slice(8, 10);
      this.selected.minute = now.slice(10, 12);
      this.touchArgv.year.top = (2016 - now.slice(0, 4)) * height + 'px';
      this.touchArgv.month.top = (3 - now.slice(4, 6)) * height + 'px';
      this.touchArgv.day.top = (3 - now.slice(6, 8)) * height + 'px';
      this.touchArgv.hour.top = (2 - now.slice(8, 10)) * height + 'px';
      this.touchArgv.minute.top = (2 - now.slice(10, 12)) * height + 'px';
    }
  }

});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'indexSlider',
    props: {
        percentage: Number
    },
    data: function data() {
        return {};
    },

    computed: {},
    mounted: function mounted() {},

    methods: {},
    components: {}
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loading',
  data: function data() {
    return {};
  },

  computed: {},
  mounted: function mounted() {},

  methods: {},
  components: {}
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Mconfirm',
    data: function data() {
        return {};
    },

    props: {
        show: Boolean,
        loading: Boolean
    },
    methods: {
        clickCancel: function clickCancel() {
            this.$emit('cancel');
        },
        clickDefine: function clickDefine() {
            this.$emit('define');
        }
    }

});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
    name: "pageHead",
    components: {
        msgMenu: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue___default.a
    },
    data: function data() {
        return {
            activeIndex: "timeCharts",
            msgMenu: {
                show: false
            },
            clientWidth: document.body.clientWidth,
            router: "",
            msgTool: {
                show: false,
                msg: "",
                sys_alias: "1",
                loading: false
            }
        };
    },

    watch: {
        $route: "showRouteName"
    },
    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        isOpen: function isOpen(state) {
            return state.siderbarOpen;
        }
    }), {
        dtuID: function dtuID() {
            return this.deviceInfo.device_sn.split('LMSZ')[1];
        }
    }),
    mounted: function mounted() {

        this.showRouteName();
    },

    methods: {
        goTodevicesList: function goTodevicesList() {
            this.$router.push('/user/deviceList?sider=true');
        },
        showRouteName: function showRouteName() {
            if (this.$route.path.search("user") === -1) {
                this.router = "temp";
            } else {
                this.router = "user";
            }
        },
        toggleSide: function toggleSide() {
            this.$store.dispatch("toggleSide");
        },
        toggleMsgTool: function toggleMsgTool() {
            var msgTool = this.msgTool;
            msgTool.show = !msgTool.show;
        },
        setDeviceMsg: function setDeviceMsg() {
            var _this = this;

            this.msgTool.loading = true;
            var params = {
                payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    msg: this.msgTool.msg,
                    devNo: this.msgTool.sys_alias * 1
                }),
                sys_alias: this.msgTool.sys_alias,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_3__lib_lib__["a" /* default */].api.setDeviceMsg(params, function (data) {
                _this.msgTool.loading = false;
                _this.msgTool.show = false;
                if (data.status_code === "SUCCEEDED") {
                    _this.$message.success("发送成功");
                } else {
                    _this.$message.error("操作失败");
                }
            });
        }
    }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib__ = __webpack_require__(7);



var image_logo = __webpack_require__(368);
var image_logo_64 = __webpack_require__(369);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: "pageSide",
    data: function data() {
        return {
            image_logo: image_logo,
            image_logo_64: image_logo_64,
            activeIndex: "",
            router: this.$route.hash,
            isshow: true,
            scrolled: "",
            msgTool: {
                show: false,
                msg: "",
                sys_alias: "1",
                loading: false
            },
            sideList: {
                user: [{ path: "/user/deviceList", name: "设备列表", Mname: '设备', icon: "icon-all" }],
                tempControl: [{
                    path: "/tempControl/realData",
                    name: "工艺曲线", Mname: '工艺',
                    icon: "icon-shishibaobiao"
                }, {
                    path: "/tempControl/historyData",
                    name: "产量统计", Mname: '产量',
                    icon: "icon-xiangxi"
                }, {
                    path: "/tempControl/controlSet",
                    name: "控制参数", Mname: '控制',
                    icon: "icon-xitongcanshushezhi"
                }, {
                    path: "/tempControl/standardSet",
                    name: "标准参数", Mname: '标准',
                    icon: "icon-leijianzhuxiulix"
                }, {
                    path: "/tempControl/autoVal",
                    name: "控制变量", Mname: '变量',
                    icon: "icon-text",
                    identity: "USER"
                }, {
                    path: "/tempControl/deviceConf",
                    name: "设备配置", Mname: '配置',
                    icon: "icon-sitting",
                    identity: "USER"
                }],
                MtempControl: [{
                    path: "/MtempControl/realData",
                    name: "工艺曲线", Mname: '工艺',
                    icon: "icon-shishibaobiao"
                }, {
                    path: "/MtempControl/historyData",
                    name: "产量统计", Mname: '产量',
                    icon: "icon-xiangxi"
                }, {
                    path: "/MtempControl/controlSet",
                    name: "控制参数", Mname: '控制',
                    icon: "icon-xitongcanshushezhi"
                }, {
                    path: "/MtempControl/standardSet",
                    name: "标准参数", Mname: '标准',
                    icon: "icon-leijianzhuxiulix"
                }, {
                    path: "/MtempControl/autoVal",
                    name: "控制变量", Mname: '变量',
                    icon: "icon-text",
                    identity: "USER"
                }, {
                    path: "/MtempControl/deviceConf",
                    name: "设备配置", Mname: '配置',
                    icon: "icon-sitting",
                    identity: "USER"
                }, {
                    path: "message",
                    name: "发送消息", Mname: '消息',
                    icon: "icon-youjian"
                }],
                allocateWater: [{
                    path: "/allocate/realData",
                    name: "实时数据", Mname: '实时',
                    icon: "icon-shishibaobiao"
                }, {
                    path: "/allocate/outputData",
                    name: "统计报告", Mname: '统计',
                    icon: "icon-xiangxi"
                }, {
                    path: "/allocate/controlConf",
                    name: "控制参数", Mname: '控制',
                    icon: "icon-xitongcanshushezhi"
                }, {
                    path: "/allocate/standConf",
                    name: "标准参数", Mname: '标准',
                    icon: "icon-leijianzhuxiulix"
                }, {
                    path: "/allocate/autoVal",
                    name: "控制变量", Mname: '变量',
                    icon: "icon-text",
                    identity: "USER"
                }, {
                    path: "/allocate/deviceConf",
                    name: "设备配置", Mname: '配置',
                    icon: "icon-sitting",
                    identity: "USER"
                }, {
                    path: "message",
                    name: "发送消息", Mname: '消息',
                    icon: "icon-youjian"
                }],
                bottom: [{
                    path: "/user?sider=true",
                    name: "返回列表", Mname: '列表',
                    icon: "icon-undo",
                    identity: "CUSTOMER"
                }, {
                    path: "/logout/",
                    name: "退出登录", Mname: '退出',
                    icon: "icon-tuichu",
                    identity: "CUSTOMER"
                }, {
                    path: "services.leemma.com",
                    name: "返回管理后台", Mname: '返回',
                    icon: "icon-tuichu",
                    identity: "USER"
                }]
            }
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isOpen: function isOpen(state) {
            return state.siderbarOpen;
        },
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        devceInfo: function devceInfo(state) {
            return state.deviceInfo;
        }
    }),
    created: function created() {
        this.showRouteName();
    },
    mounted: function mounted() {},

    watch: {
        $route: "showRouteName"
    },
    methods: {
        handleScroll: function handleScroll() {
            this.scrolled = window.scrollY;
            console.log(window.scrollY);
        },
        listenScoll: function listenScoll() {},
        handleSelect: function handleSelect(keyPath, ele) {
            if (keyPath === "logout") {
                this.logout();
            } else if (keyPath === "services.leemma.com") {
                location.href = "https://services.leemma.com";
            } else if (keyPath === "message") {
                this.toggleMsgTool();
            } else {
                this.$router.push(keyPath);
            }

            if (this.isMobile) {
                this.$store.dispatch("toggleSide");
            }
        },
        toggleMsgTool: function toggleMsgTool() {
            var msgTool = this.msgTool;
            msgTool.show = !msgTool.show;
            var msgObj = this.sideList.MtempControl[6];
            if (this.router === "WATER" && this.sideList.allocateWater.length >= 7) {
                msgObj = this.sideList.allocateWater[6];
            }
            if (msgTool.show) {
                msgObj.name = "关闭";
            } else {
                msgObj.name = "发送消息";
            }
        },
        setDeviceMsg: function setDeviceMsg() {
            var _this = this;

            this.msgTool.loading = true;
            var params = {
                payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                    msg: this.msgTool.msg,
                    devNo: this.msgTool.sys_alias * 1
                }),
                sys_alias: this.msgTool.sys_alias,
                device_id: this.devceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib__["a" /* default */].api.setDeviceMsg(params, function (data) {
                _this.msgTool.loading = false;
                _this.msgTool.show = false;
                if (data.status_code === "SUCCEEDED") {
                    _this.$message.success("发送成功");
                } else {
                    _this.$message.error("操作失败");
                }
                _this.toggleMsgTool();
            });
        },
        checkIdentity: function checkIdentity(arr) {
            var _this2 = this;

            arr.forEach(function (item) {
                if (item.identity === "USER" && _this2.userInfo.identity !== "USER") {
                    item.show = false;
                } else {
                    item.show = true;
                }

                if (item.identity === "ONLYCUSTOMER" && _this2.userInfo.identity !== "CUSTOMER") {
                    item.show = false;
                }
                if (_this2.devceInfo.category === '配煤' && item.name === '控制参数') {
                    item.show = false;
                }
                if (_this2.devceInfo.category === '配水' && item.name === '标准参数') {
                    item.show = false;
                }
                if (!_this2.isMobile && item.name === '发送消息') {
                    item.show = false;
                }
            }, this);
        },
        logout: function logout() {
            var _this3 = this;

            var params = {
                customer_token: this.userInfo.token
            };
            __WEBPACK_IMPORTED_MODULE_2__lib_lib__["a" /* default */].api.logout(params, function (data) {
                _this3.$message("登出成功");
            });
        },
        showRouteName: function showRouteName() {
            var _this4 = this;

            var routeSearch = function routeSearch(text) {
                if (_this4.$route.path.search(text) === 1) {
                    return true;
                } else {
                    return false;
                }
            };
            if (routeSearch("tempControl")) {
                this.router = "TEMP";
            } else if (routeSearch("allocate")) {
                this.router = "WATER";
                this.changeTitle(this.devceInfo.name);
            } else if (routeSearch("MtempControl")) {
                this.router = 'MTEMP';
                this.changeTitle(this.devceInfo.name);
            } else {
                this.router = "USER";
                this.changeTitle('设备列表');
            }
            this.checkIdentity(this.sideList.tempControl);
            this.checkIdentity(this.sideList.MtempControl);
            this.checkIdentity(this.sideList.allocateWater);
        },
        changeTitle: function changeTitle(title) {
            var body = document.getElementsByTagName('body')[0];
            document.title = title;
            var iframe = document.createElement("iframe");
            iframe.style.display = "none";
            var d = function d() {
                setTimeout(function () {
                    iframe.removeEventListener('load', d);
                    document.body.removeChild(iframe);
                }, 0);
            };
            iframe.addEventListener('load', d);
            document.body.appendChild(iframe);
        }
    }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var echarts = __webpack_require__(42);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "chartsPlayer",
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      data: [],
      index: 0,
      float: {
        show: true
      },
      charts: {
        shaojie: "",
        honggan: ""
      },
      tableData: "",
      player: {
        status: "PAUSE",
        id: ""
      },
      progress: {
        width: 30,
        start: "",
        startWidth: "",
        move: "",
        clientWidth: document.body.clientWidth,
        time_stamp: ""
      },
      style: {},
      isVertical: true
    };
  },
  computed: {
    standData: function standData() {
      return this.$store.state.standTempData;
    },
    hisData: function hisData() {
      return this.$store.state.playerData;
    }
  },
  created: function created() {
    this.getData();
  },

  methods: {
    scrollTable: function scrollTable(type) {
      var left = this.$refs.tableList.scrollLeft,
          top = this.$refs.tableList.scrollTop;
      if (type === 'left') {
        this.$refs.tableList.scrollLeft = left - 200;
        this.$refs.tableList.scrollTop = top - 200;
      } else {
        this.$refs.tableList.scrollLeft = left + 200;
        this.$refs.tableList.scrollTop = top + 200;
      }
    },
    getData: function getData() {
      this.data = this.hisData;
      this.checkDirction();
      this.clickButton("REPLAY");
    },
    noScoll: function noScoll(e) {
      console.log(123);
    },
    checkDirction: function checkDirction() {
      var _this2 = this;

      var _this = this;
      var changStyle = function changStyle() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;
        if (width < height) {
          _this.isVertical = true;
          _this2.progress.clientWidth = height;
          _this.style = {
            height: width + "px",
            width: height + "px",
            top: (height - width) / 2 + "px",
            left: 0 - (height - width) / 2 + "px",
            transform: "rotate(90deg)",
            "transform-origin": "50% 50%"
          };
        } else {
          _this2.progress.clientWidth = width;

          _this.isVertical = false;
          _this.style = {
            width: width + "px",
            height: height + "px",
            top: 0 + "px",
            left: 0 + "px",
            transform: "none",
            "transform-origin": "50% 50%"
          };
        }
      };
      changStyle();
      var evt = "onorientationchange" in window ? "orientationchange" : "resize";
      window.addEventListener(evt, function () {
        setTimeout(function () {
          changStyle();
        }, 500);
      }, false);
    },
    toggleFloat: function toggleFloat() {
      this.float.show = !this.float.show;
    },
    clickButton: function clickButton(type) {
      var _this3 = this;

      switch (type) {
        case "PLAY":
          this.playCharts();
          break;
        case "PAUSE":
          this.pausePlayer();
          break;
        case "REPLAY":
          this.index = 0;
          this.selectData();
          this.$nextTick(function () {
            _this3.playCharts();
          });
          break;
        case "NEXT":
          this.index = this.index + 1 < this.data.length ? this.index + 1 : this.index;
          this.selectData();
          break;
        case "PRE":
          this.index = this.index - 1 > 0 ? this.index - 1 : 0;
          this.selectData();
          break;
      }
    },
    playCharts: function playCharts() {
      var _this4 = this;

      this.player.id = setInterval(function () {
        if (_this4.index + 1 < _this4.data.length) {
          _this4.player.status = "PLAY";
          _this4.index++;
          _this4.selectData();
        } else {
          _this4.pausePlayer();
          _this4.player.status = "STOP";
        }
      }, 500);
    },
    pausePlayer: function pausePlayer() {
      window.clearInterval(this.player.id);
      this.player.status = "PAUSE";
    },
    selectData: function selectData() {
      var index = this.index;
      this.progress.width = (index / this.data.length * 100).toFixed(2);
      this.tableData = this.data[index];
      this.dealChartsData();
    },
    touchStart: function touchStart(e) {
      var touch = e.changedTouches[0];
      console.log(touch);
      this.progress.start = this.isVertical ? touch.clientY : touch.clientX;
      this.progress.startWidth = this.progress.width;
    },
    touchMove: function touchMove(e) {
      var touch = e.changedTouches[0],
          p = this.progress,
          w = void 0,
          index = void 0;
      w = p.startWidth * 1 + ((this.isVertical ? touch.clientY : touch.clientX) - p.start) / p.clientWidth * 100;
      index = Math.round(this.data.length * (w / 100));
      if (index < 0) {
        index = 0;
      } else if (index >= this.data.length) {
        index = this.data.length - 1;
      } else {
        this.progress.width = w.toFixed(2);
      }

      this.tableData.time_stamp = this.data[index].time_stamp ? this.data[index].time_stamp : 0;
    },
    touchEnd: function touchEnd(e) {
      var touch = e.changedTouches[0],
          p = this.progress,
          w = void 0;
      w = p.startWidth * 1 + ((this.isVertical ? touch.clientY : touch.clientX) - p.start) / p.clientWidth * 100;
      this.progress.width = w.toFixed(2);
      this.index = Math.round(this.data.length * (w / 100));
      if (this.index < 0) {
        this.index = 0;
      } else if (this.index > this.data.length) {
        this.index = this.data.length - 1;
      }
      this.selectData();
    },
    dealChartsData: function dealChartsData() {
      var _this5 = this;

      var tableData = this.data[this.index],
          stand = this.standData;
      if (tableData) {
        var repeatData = function repeatData(data) {
          if (!data.length) {
            return data;
          }
          var json = {},
              item = void 0,
              jsonItem = void 0;
          for (var i = 0; i < data.length; i++) {
            item = data[i];
            jsonItem = json[item.th];
            if (jsonItem) {
              jsonItem.data = Lib.M.getMax(jsonItem.data, item.data);
              jsonItem.count = 1;
            } else {
              jsonItem = {};
              jsonItem.th = item.th;
              jsonItem.key = item.key;
              jsonItem.data = item.data;
              jsonItem.count = 1;
            }
            json[item.th] = jsonItem;
          }
          var arr = [],
              arrItem = void 0;
          for (var x in json) {
            arrItem = json[x];
            arrItem.data = Math.floor(arrItem.data / arrItem.count);
            arr.push(arrItem);
          }
          return arr;
        };

        var dataForEach = function dataForEach(data) {
          data = repeatData(data);
          var result = [],
              xData = [],
              DataLength = void 0;
          if (data && data.length) {
            DataLength = data[data.length - 1].th * 1 + 2;
            for (var i = 0; i <= DataLength; i++) {
              if (i === 0) {
                xData[i] = "0";
                result[i] = "30";
              } else if (i === DataLength - 1) {
                xData[i] = "-";
                result[i] = "30";
              } else {
                xData[i] = "-";
                result[i] = "-";
              }
            }
            data.forEach(function (item, n) {
              xData[item.th] = item.th;
              result[item.th] = item.data;
            }, this);
          } else {
            xData = [];
            result = [];
          }
          return { xData: xData, result: result };
        };

        var realData = [],
            xData = [],
            StandData = void 0,
            reH = void 0,
            reS = void 0,
            standH = void 0,
            standS = void 0;

        reH = dataForEach(tableData["honggan"]);
        reS = dataForEach(tableData["shaojie"]);
        standH = dataForEach(stand["honggan"]);
        standS = dataForEach(stand["shaojie"]);

        this.$nextTick(function () {
          if (_this5.$refs.honggan && _this5.$refs.shaojie) {
            _this5.initChart("honggan", standH.result, reH.result, reH.xData);
            _this5.initChart("shaojie", standS.result, reS.result, reS.xData);
          }
        });
      }
    },
    initChart: function initChart(type, standData, realData, xAxisData) {
      var option = {
        baseOption: {
          grid: {
            show: false,
            top: 20,
            left: 40,
            right: 10,
            bottom: 15
          },
          title: {
            show: type === 'shaojie' ? true : false,
            text: this.tableData.time_stamp,
            left: 45,
            top: 30,
            textStyle: {
              color: '#DC143C'
            }
          },
          tooltip: {
            show: false,
            trigger: "axis",

            formatter: function formatter(params, ticket, callback) {
              var res = void 0,
                  th = "车位";
              res = "" + params[0].axisValue + th + "</br>";
              for (var i = 0; i < params.length; i++) {
                res += params[i].seriesName + ":" + params[i].value + "</br>";
              }
              return res;
            }
          },
          legend: {
            show: true,
            data: [{ name: "标准温度", icon: "rect" }, { name: "实时温度", icon: "rect" }],
            top: 0,
            right: 0,
            itemHeight: 8,
            itemWidth: 16
          },
          xAxis: {
            show: true,
            data: xAxisData,
            axisPointer: {
              show: false
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
              interval: function interval(_interval, val) {
                return true;
              }
            },

            axisLabel: {
              show: true,
              rotate: 45,
              interval: function interval(index, val) {
                return val != "0" && val !== "-" ? true : false;
              },
              formatter: function formatter(value, i) {
                return value;
              },

              textStyle: {
                fontSize: 8
              }
            }
          },
          yAxis: {
            show: true,
            axisLine: { show: false },
            splitLine: {
              show: true
            },
            splitNumber: type === "shaojie" ? 4 : 2,
            max: type === "shaojie" ? 1200 : 200,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: "{value}℃",
              inside: true,
              margin: -30
            }
          },
          series: [{
            name: "实时温度",
            type: "line",
            data: realData,
            symbolSize: 8,
            connectNulls: true,
            itemStyle: {
              normal: {
                color: "#E65D20"
              }
            },
            lineStyle: {
              normal: {
                width: "2"
              }
            }
          }, {
            name: "标准温度",
            type: "line",
            data: standData,
            symbolSize: 8,
            connectNulls: true,
            itemStyle: {
              normal: {
                color: "#2378DC"
              }
            },
            lineStyle: {
              normal: {
                width: "2"
              }
            }
          }]
        }
      };
      if (this.charts[type]) {
        this.charts[type].setOption(option);
      } else {
        var charts = echarts.init(this.$refs[type], charts, {
          height: type === "shaojie" ? 200 : 100
        });
        charts.setOption(option);
        this.charts[type] = charts;
      }
    },
    closePlayer: function closePlayer() {
      this.$router.push("/MtempControl/realData");
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_floatthead__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_floatthead___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_floatthead__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "dropTimePicker",

  props: {
    data: Array,
    title: String,
    loading: Boolean,
    index: [Number, String],
    show: Boolean,
    type: {
      type: String
    },
    control: {
      default: true
    }
  },
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2__common_loading_vue___default.a
  },
  computed: {
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    }
  },
  watch: {
    show: function show() {
      if (this.show) {
        this.toggleList(true);
      } else {
        this.toggleList(false);
      }
    },
    data: function data() {
      this.dealhisData();
    }
  },

  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
      img_no_data: __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default.a,

      listData: [],
      oneDayData: [],
      dropBox1: {
        show: false
      },
      dropBox2: {
        show: false
      },
      selected: {
        day: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD"),
        hour: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("HH:00"),
        hourIndex: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("H") * 1,
        itemIndex: 14,
        addDay: ""
      },
      itemList: [],
      dayList: [{ label: "今天", value: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD") }, {
        label: "昨天",
        value: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(1, "day").format("YYYY-MM-DD")
      }, {
        label: "前天",
        value: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(2, "day").format("YYYY-MM-DD")
      }],

      intervalEvent: {
        selected: ""
      },
      chartsPlayer: {
        show: false
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    dealhisData: function dealhisData() {
      var data = this.data,
          hourItem = void 0,
          oneDayData = [];
      console.log("dealhisData", data, typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data));
      data.forEach(function (v) {

        hourItem = __WEBPACK_IMPORTED_MODULE_1_moment___default()(v.time_stamp).format("H");
        if (oneDayData[hourItem]) {
          oneDayData[hourItem].push(v);
        } else {
          oneDayData[hourItem] = [v];
        }
      });
      this.oneDayData = oneDayData;
      this.listData = oneDayData[oneDayData.length - 1];
      console.log("dealhisData v", this.listData[0]);
      this.selectHour("default");
    },
    toggleList: function toggleList(type) {
      this.dropBox1.show = !this.dropBox1.show;
      this.dropBox2.show = false;
      if (type === false) {
        this.dropBox1.show = false;
        this.dropBox2.show = false;
      } else {
        this.$nextTick(function () {});
      }
    },
    selectDay: function selectDay(day) {
      if (day === "more") {
        var input = this.$refs.datePicker.getElementsByTagName("input")[0];
        input.focus();
      } else {
        this.selected.day = day;
        this.$emit("selectDate", this.selected);
      }
    },
    selectHour: function selectHour(index) {
      var oneDayData = this.oneDayData,
          dataList = this.dataList;
      if (index === "default") {
        index = oneDayData.length > 0 ? oneDayData.length - 1 : 0;
      }
      this.selected.hour = (index < 10 ? "0" + index : index) + ":00";
      this.selected.hourIndex = index;
      if (oneDayData[index]) {
        this.listData = oneDayData[index];
        var itemindex = this.selected.itemIndex;
        this.selectItem(itemindex ? itemindex : 0);
      } else {
        this.listData = [];
      }
    },
    selectItem: function selectItem(index) {
      var _this = this;

      var listData = this.listData;
      if (listData.length) {
        if (index > listData.length - 1) {
          index = listData.length - 1;
        } else if (index < 0) {
          index = 0;
        }
        this.selected.itemIndex = index;
        this.$emit("selectItem", listData[index], listData, index);
        this.$nextTick(function () {
          _this.initScoll();
        });
      }
    },
    selectButtonDown: function selectButtonDown(type) {
      var _this2 = this;

      this.selectButton(type);
      this.intervalEvent.selected = setInterval(function () {
        _this2.selectButton(type);
      }, 300);
    },
    selectButton: function selectButton(type) {
      var hourIndex = this.selected.hourIndex,
          itemIndex = this.selected.itemIndex,
          oneDayData = this.oneDayData,
          dataLength = this.listData.length;
      if (type === "PRE") {
        if (itemIndex > 0) {
          itemIndex = itemIndex - 1;
        } else {
          if (hourIndex > 0) {
            hourIndex = hourIndex - 1;
            itemIndex = oneDayData[hourIndex] && oneDayData[hourIndex].length - 1;
            if (!oneDayData[hourIndex] && hourIndex == -1) {
              return false;
            }
          }
        }
      } else if (type = "NEXT") {
        if (itemIndex < dataLength - 1) {
          itemIndex = itemIndex + 1;
        } else {
          if (hourIndex < 23) {
            hourIndex = hourIndex + 1;
            itemIndex = 0;

            if (!oneDayData[hourIndex] && __WEBPACK_IMPORTED_MODULE_1_moment___default()().isSame(this.selected.day, "day")) {
              return false;
            }
          }
        }
      }
      this.selected.itemIndex = itemIndex;
      this.selected.hourIndex = hourIndex;
      this.selectHour(hourIndex);
      this.initScoll();
    },
    selectButtonUp: function selectButtonUp() {
      clearInterval(this.intervalEvent.selected);
    },
    addDayfn: function addDayfn() {
      var addDay = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.selected.addDay).format("YYYY-MM-DD"),
          dayList = this.dayList;
      if (dayList[0].value === addDay || dayList[1].value === addDay || dayList[2].value === addDay) {} else {
        if (this.dayList[3]) {
          this.dayList.splice(3, 1, {
            label: addDay,
            value: addDay
          });
        } else {
          this.dayList.push({
            label: addDay,
            value: addDay
          });
        }
      }
      this.selected.day = addDay;
      this.$emit("selectDate", this.selected);
    },
    initScoll: function initScoll() {
      var itemIndex = this.selected.itemIndex;
      var hourIndex = this.selected.hourIndex;
      this.$refs.scrollHour.scrollTop = 36 * (hourIndex - 2);
      if (this.data[itemIndex]) {
        this.$refs.scrollItem.scrollTop = 36 * (itemIndex - 2);
      }
    },
    destroyFT: function destroyFT() {
      this.$refs.floatTable('destroy');
    },
    openPlayer: function openPlayer() {
      this.chartsPlayer.show = true;
    },
    closePlayer: function closePlayer() {
      this.chartsPlayer.show = false;
      console.log("close");
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page-header',
  data: function data() {
    return {
      title: '实时数据',
      routeList: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    }

  })),
  created: function created() {
    this.showTitle();
  },
  mounted: function mounted() {},

  methods: {
    showTitle: function showTitle() {
      this.routeList = this.$route.matched;
      this.title = this.$route.name;
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: "msgMenu",
    data: function data() {
        return {
            msgList: [{
                time: "2011",
                msg: "这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息",
                type: "remind1"
            }, {
                time: "2011",
                msg: "这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息",
                type: "information"
            }, {
                time: "2011",
                msg: "这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息这是一条消息",
                type: "warning"
            }]

        };
    }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "pageHead",
  components: {
    msgMenu: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_msgMenu_vue___default.a
  },
  data: function data() {
    return {
      activeIndex: "timeCharts",
      msgMenu: {
        show: false
      },
      clientWidth: document.body.clientWidth,
      router: "",
      msgTool: {
        show: false,
        msg: "",
        sys_alias: "1",
        loading: false
      }
    };
  },

  watch: {
    $route: "showRouteName"
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    },
    isOpen: function isOpen(state) {
      return state.siderbarOpen;
    }
  }), {
    openWidth: function openWidth() {
      return this.clientWidth - (this.isMobile ? 0 : 250);
    },
    openLeft: function openLeft() {
      var left = this.isMobile ? 0 : 250;
      return this.isOpen ? left : 0;
    },
    dtuID: function dtuID() {
      return this.deviceInfo.device_sn.split('LMSZ')[1];
    }
  }),
  mounted: function mounted() {
    var _this = this;

    window.onresize = function () {
      _this.clientWidth = document.body.clientWidth;
    };
    this.showRouteName();
  },

  methods: {
    showRouteName: function showRouteName() {
      if (this.$route.path.search("user") === -1) {
        this.router = "temp";
      } else {
        this.router = "user";
      }
    },
    toggleSide: function toggleSide() {
      this.$store.dispatch("toggleSide");
    },
    toggleMsgTool: function toggleMsgTool() {
      var msgTool = this.msgTool;
      msgTool.show = !msgTool.show;
    },
    setDeviceMsg: function setDeviceMsg() {
      var _this2 = this;

      this.msgTool.loading = true;
      var params = {
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          msg: this.msgTool.msg,
          devNo: this.msgTool.sys_alias * 1
        }),
        sys_alias: this.msgTool.sys_alias,
        device_id: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_3__lib_lib__["a" /* default */].api.setDeviceMsg(params, function (data) {
        _this2.msgTool.loading = false;
        _this2.msgTool.show = false;
        if (data.status_code === "SUCCEEDED") {
          _this2.$message.success("发送成功");
        } else {
          _this2.$message.error("操作失败");
        }
      });
    }
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib__ = __webpack_require__(7);


var image_logo = __webpack_require__(368);
var image_logo_64 = __webpack_require__(369);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "pageSide",
  data: function data() {
    return {
      image_logo: image_logo,
      image_logo_64: image_logo_64,
      activeIndex: "",
      router: this.$route.hash,
      isshow: true,
      sideList: {
        user: [{ path: "/user/deviceList", name: "设备列表", Mname: '设备', icon: "icon-all" }],
        tempControl: [{
          path: "/tempControl/realData",
          name: "工艺曲线", Mname: '工艺',
          icon: "icon-shishibaobiao"
        }, {
          path: "/tempControl/historyData",
          name: "产量统计", Mname: '产量',
          icon: "icon-xiangxi"
        }, {
          path: "/tempControl/controlSet",
          name: "控制参数", Mname: '控制',
          icon: "icon-xitongcanshushezhi"
        }, {
          path: "/tempControl/standardSet",
          name: "标准参数", Mname: '标准',
          icon: "icon-leijianzhuxiulix"
        }, {
          path: "/tempControl/autoVal",
          name: "控制变量", Mname: '变量',
          icon: "icon-text",
          identity: "USER"
        }, {
          path: "/tempControl/deviceConf",
          name: "设备配置", Mname: '配置',
          icon: "icon-sitting",
          identity: "USER"
        }],
        MtempControl: [{
          path: "/MtempControl/realData",
          name: "工艺曲线", Mname: '工艺',
          icon: "icon-shishibaobiao"
        }, {
          path: "/MtempControl/historyData",
          name: "产量统计", Mname: '产量',
          icon: "icon-xiangxi"
        }, {
          path: "/MtempControl/controlSet",
          name: "控制参数", Mname: '控制',
          icon: "icon-xitongcanshushezhi"
        }, {
          path: "/MtempControl/standardSet",
          name: "标准参数", Mname: '标准',
          icon: "icon-leijianzhuxiulix"
        }, {
          path: "/MtempControl/autoVal",
          name: "控制变量", Mname: '变量',
          icon: "icon-text",
          identity: "USER"
        }, {
          path: "/MtempControl/deviceConf",
          name: "设备配置", Mname: '配置',
          icon: "icon-sitting",
          identity: "USER"
        }],
        allocateWater: [{
          path: "/allocate/realData",
          name: "实时数据", Mname: '实时',
          icon: "icon-shishibaobiao"
        }, {
          path: "/allocate/outputData",
          name: "统计报告", Mname: '统计',
          icon: "icon-xiangxi"
        }, {
          path: "/allocate/controlConf",
          name: "控制参数", Mname: '控制',
          icon: "icon-xitongcanshushezhi"
        }, {
          path: "/allocate/standConf",
          name: "标准参数", Mname: '标准',
          icon: "icon-leijianzhuxiulix"
        }, {
          path: "/allocate/autoVal",
          name: "控制变量", Mname: '变量',
          icon: "icon-text",
          identity: "USER"
        }, {
          path: "/allocate/deviceConf",
          name: "设备配置", Mname: '配置',
          icon: "icon-sitting",
          identity: "USER"
        }],
        bottom: [{
          path: "/user?sider=true",
          name: "返回列表", Mname: '列表',
          icon: "icon-undo",
          identity: "CUSTOMER"
        }, {
          path: "/logout/",
          name: "退出登录", Mname: '退出',
          icon: "icon-tuichu",
          identity: "CUSTOMER"
        }, {
          path: "services.leemma.com",
          name: "返回管理后台", Mname: '返回',
          icon: "icon-tuichu",
          identity: "USER"
        }]
      }
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    isOpen: function isOpen(state) {
      return state.siderbarOpen;
    },
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    devceInfo: function devceInfo(state) {
      return state.deviceInfo;
    }
  }),
  created: function created() {
    this.showRouteName();
  },

  watch: {
    $route: "showRouteName"
  },
  methods: {
    handleSelect: function handleSelect(keyPath) {
      if (keyPath === "logout") {
        this.logout();
      } else if (keyPath === "services.leemma.com") {
        location.href = "https://services.leemma.com";
      } else {
        this.$router.push(keyPath);
      }

      if (this.isMobile) {
        this.$store.dispatch("toggleSide");
      }
    },
    checkIdentity: function checkIdentity(arr) {
      var _this = this;

      arr.forEach(function (item) {
        if (item.identity === "USER" && _this.userInfo.identity !== "USER") {
          item.show = false;
        } else {
          item.show = true;
        }
        if (_this.devceInfo.category === '配煤' && item.name === '控制参数') {
          item.show = false;
        }
        if (_this.devceInfo.category === '配水' && item.name === '标准参数') {
          item.show = false;
        }
      }, this);
    },
    logout: function logout() {
      var _this2 = this;

      var params = {
        customer_token: this.userInfo.token
      };
      __WEBPACK_IMPORTED_MODULE_1__lib_lib__["a" /* default */].api.logout(params, function (data) {
        _this2.$message("登出成功");
      });
    },
    showRouteName: function showRouteName() {
      var _this3 = this;

      var routeSearch = function routeSearch(text) {
        if (_this3.$route.path.search(text) === 1) {
          return true;
        } else {
          return false;
        }
      };
      if (routeSearch("tempControl")) {
        this.router = "TEMP";
      } else if (routeSearch("allocate")) {
        this.router = "WATER";
      } else if (routeSearch("MtempControl")) {
        this.router = 'MTEMP';
      } else {
        this.router = "USER";
      }
      this.checkIdentity(this.sideList.tempControl);
      this.checkIdentity(this.sideList.MtempControl);
      this.checkIdentity(this.sideList.allocateWater);
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "wx-loading",
  props: {
    show: {
      type: Boolean

    },
    content: {
      default: '正在加载',
      type: String

    },
    type: {
      type: String

    }

  },

  data: function data() {
    return {};
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: "autoVal",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default.a
    },
    data: function data() {
        return {
            isEdit: false,
            option: {
                sys_alias: ""
            },
            test: "",
            loading: "",
            sys_alias: [],
            val: "",
            confData: [],
            options: [{
                label: "一号窑",
                val: 1
            }],
            tableData: [],
            timeShow: "",
            id_of_setinterval: ''
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.option.sys_alias = 1;
        this.checkUpdata();
    },
    mounted: function mounted() {
        for (var i = 0; i < 1; i++) {
            __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.selectInputFoc();
        }
        this.timingLoadData('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
    },

    methods: {
        timingLoadData: function timingLoadData(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadControlConf(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        checkUpdata: function checkUpdata() {
            var isNew = void 0,
                date = void 0;
            this.loadControlConf(true);
        },
        loadControlConf: function loadControlConf(is_cache) {
            var _this2 = this;

            this.confData = [];
            this.loading = true;
            var params = {
                conf_type: "auto",
                sys_alias: this.option.sys_alias,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                _this2.loading = false;
                if (data.status_code === "SUCCEEDED") {} else {
                    _this2.$message({
                        message: "获取自控变量错误," + data.msg,
                        type: "warning"
                    });
                }
                _this2.timeShow = data.payload.time_stamp;
                if (data.payload && data.payload.data) {
                    var tableData = JSON.parse(data.payload.data);
                    if (tableData.oother) {
                        delete tableData.oother;
                        if (tableData.msg) {
                            delete tableData.msg;
                            delete tableData.isSuccess;
                        }
                    }
                    _this2.tableData = [];
                    for (var key in tableData) {
                        if (tableData.hasOwnProperty(key)) {
                            var element = tableData[key];
                            if (key !== "isSuccess" && key !== "msg") {
                                _this2.tableData.push({
                                    name: key,
                                    data: element
                                });
                            }
                        }
                    }
                } else if (is_cache) {
                    _this2.loadControlConf(false);
                }
            });
        }
    }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: "controlSet",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: 1,
                isEdit: false,
                canEdit: false,
                time_stamp: ""
            },
            test: "",
            loading: "",
            controlLoading: false,
            sys_alias: [],
            paramRange: [],
            val: "",
            deviceConfName: {},
            confData: [],
            peimei: {

                zkcsUchar: '自控参数Uchar类型个数',

                zkcsChar: '自控参数Char类型个数',

                zkcsUint: '自控参数Uint类型个数',

                zkcsInt: '自控参数Int类型个数',

                zkcsUlong: '自控参数Ulong类型个数',

                zkcsLong: '自控参数Long类型个数',

                zkcsFloat: '自控参数Float类型个数'

            },
            peishui: {

                zkcsUchar: '自控参数Uchar类型个数',

                zkcsChar: '自控参数Char类型个数',

                zkcsUint: '自控参数Uint类型个数',

                zkcsInt: '自控参数Int类型个数',

                zkcsUlong: '自控参数Ulong类型个数',

                zkcsLong: '自控参数Long类型个数',

                zkcsFloat: '自控参数Float类型个数'

            },
            id_of_setinterval: ''

        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.option.sys_alias = "1";
        this.deviceConfName = this.deviceInfo.category === '配煤' ? this.peimei : this.peishui;
    },
    mounted: function mounted() {

        this.loadData(true);
        __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.selectInputFoc();

        this.timingLoadData('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
        this.timingLoadData('CLOSE');
    },

    methods: {
        timingLoadData: function timingLoadData(type) {
            var _this = this;

            if (type === "OPEN") {
                var that = this;
                this.id_of_setinterval = setInterval(function () {
                    if (!that.option.isEdit && !that.controlLoading) {
                        _this.loadControlConf(false);
                    }
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadDeviceConf: function loadDeviceConf(is_cache, callback) {

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            var that = this;
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;

                        that.paramRange = [];
                        var totle = 0;
                        for (var key in jsonData) {
                            if (that.deviceConfName[key]) {
                                totle += jsonData[key];
                                that.paramRange.push(totle);
                            }
                        }

                        if (callback) {
                            callback(true);
                        }
                        return;
                    } catch (err) {}
                }
                if (callback) {
                    callback(true);
                }
            });
        },
        loadControlConf: function loadControlConf(is_cache, callback) {
            var _this2 = this;

            this.controlLoading = true;
            this.loading = true;
            var params = {
                conf_type: "control",
                sys_alias: this.option.sys_alias * 1,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            var that = this;
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                that.loading = false;
                that.controlLoading = false;

                if (data.status_code === "SUCCEEDED") {
                    if (data.payload && data.payload.data) {
                        var confData = _this2.dealDateFn(data, "load");
                        if (confData.length > 0) {
                            that.confData = confData;
                            that.option.time_stamp = data.payload.time_stamp;
                            if (callback) {
                                callback();
                            }
                            return;
                        }
                    }
                }

                that.$message({
                    message: "网络连接超时：" + data.msg,
                    type: "warning"
                });
                if (!that.isMobile) {
                    that.$notify.info({
                        title: "温馨提示",
                        message: "无法连接设备时，无法进行参数修改操作",
                        duration: 3000,
                        offset: 60
                    });
                }
                that.closeEdit();
            });
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this3 = this;

            this.loading = true;
            var payload = this.dealDateFn(this.confData, "post");
            if (payload == false) {
                this.$message.error("参数错误");
                return false;
            } else {
                payload.devNo = this.option.sys_alias * 1;
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
            }
            var params = {
                conf_type: "control",
                sys_alias: this.option.sys_alias.toString(),
                device_id: this.deviceInfo.device_id,
                payload: payload
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this3.$message.success("修改成功");
                    _this3.loadControlConf(false);
                    _this3.closeEdit();
                } else {
                    _this3.$message.error("\u4FEE\u6539\u5931\u8D25\uFF1A" + data.msg);
                    _this3.loading = false;
                }
            });
        },
        dealDateFn: function dealDateFn(data, type) {
            var confData = void 0;
            if (type === "load") {
                var jsonData = JSON.parse(data.payload.data);
                if (jsonData.error) {
                    return [];
                }
                confData = [];
                if (jsonData.oother) {
                    delete jsonData.oother;
                    if (jsonData.msg) {
                        delete jsonData.msg;
                        delete jsonData.isSuccess;
                    }
                }
                this.test = jsonData;
                var jsonDataIndex = 0;
                for (var key in jsonData) {
                    if (jsonData.hasOwnProperty(key)) {
                        var item = jsonData[key],
                            precision = 0,
                            step = 1,
                            max = 5000,
                            min = 0;
                        if (this.paramRange.length > 0) {
                            if (jsonDataIndex < this.paramRange[0]) {
                                max = 255;
                                min = 0;
                            } else if (jsonDataIndex < this.paramRange[1]) {
                                max = 127;
                                min = -128;
                            } else if (jsonDataIndex < this.paramRange[2]) {
                                max = 32767;
                                min = -32768;
                            } else if (jsonDataIndex < this.paramRange[3]) {
                                max = 65565;
                                min = 0;
                            } else if (jsonDataIndex < this.paramRange[4]) {
                                max = 2147483647;
                                min = -2147483648;
                            } else if (jsonDataIndex < this.paramRange[5]) {
                                max = 4294967295;
                                min = 0;
                            } else if (jsonDataIndex < this.paramRange[6]) {
                                max = 100000;
                                min = -100000;
                                item = parseFloat(item.toFixed(2));
                                precision = 2;
                                step = 0.01;
                            }
                        }
                        confData.push({
                            name: key,
                            data: item,
                            precision: precision,
                            step: step,
                            max: max,
                            min: min
                        });
                    }
                    jsonDataIndex++;
                }
            } else {
                if (this.paramRange.length < 7) {
                    return false;
                }
                confData = {};

                for (var i = 0; i < data.length; i++) {
                    var _item = data[i];
                    if (data[i].data === "") {
                        return false;
                    }

                    confData[_item.name] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.round(_item.data, 2);
                    if (i < this.paramRange[5]) {
                        confData[_item.name] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.round(_item.data);
                    }
                }
            }
            return confData;
        },
        checkInputNumber: function checkInputNumber(val, oldVal, index) {},
        loadData: function loadData(useCache, callback) {
            var that = this;
            this.loadDeviceConf(useCache, function (succ) {
                that.loadControlConf(useCache, callback);
            });
        },
        openEdit: function openEdit() {
            if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                this.loading = true;
                var that = this;
                this.option.isEdit = true;
                this.loadData(false, function () {
                    that.option.canEdit = true;
                });
                this.timingLoadData('CLOSE');
            } else {
                this.$message.error("权限不足，修改失败");
            }
        },
        closeEdit: function closeEdit() {
            this.option.isEdit = false;
            this.timingLoadData('OPEN');
        }
    }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_lib__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["default"] = ({

    name: "deviceConf",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: ''
            },
            sys_alias: '',
            loading: true,
            isEdit: '',
            deviceConf: {
                data: [],
                time_stamp: ''
            },

            deviceName: {
                data: '',
                time_stamp: ''
            },
            deviceConfName: {},

            peimei: {

                nAiNum: '重量输入名称条数',

                nAoNum: '输出名称条数',

                nDiNum: '输入名称表',

                nDoNum: '输出名称表',

                mAiNum: '电子称总数',

                nAutoNum: '自控提示、报警类型数',

                nNameNum: '数据总数',

                bzcsUchar: '标准参数Uchar类型个数',

                bzcsChar: '标准参数Char类型个数',

                bzcsUint: '标准参数Uint类型个数',

                bzcsInt: '标准参数Int类型个数',

                bzcsUlong: '标准参数Ulong类型个数',

                bzcsLong: '标准参数Long类型个数',

                bzcsFloat: '标准参数Float类型个数',

                zkcsUchar: '自控参数Uchar类型个数',

                zkcsChar: '自控参数Char类型个数',

                zkcsUint: '自控参数Uint类型个数',

                zkcsInt: '自控参数Int类型个数',

                zkcsUlong: '自控参数Ulong类型个数',

                zkcsLong: '自控参数Long类型个数',

                zkcsFloat: '自控参数Float类型个数',

                zkblUchar: '自控变量Uchar类型个数',

                zkblChar: '自控变量Char类型个数',

                zkblUint: '自控变量Uint类型个数',

                zkblInt: '自控变量Int类型个数',

                zkblUlong: '自控变量Ulong类型个数',

                zkblLong: '自控变量Long类型个数',

                zkblFloat: '自控变量Float类型个数'
            },
            peishui: {

                mAiNum: "重量输入名称条数",

                nAoNum: "输出名称条数",

                nDiNum: '输入名称表',

                nDoNum: '输出名称表',

                nAiNum: '电子称总数',

                nAutoNum: '自控提示、报警类型数',

                nNameNum: '数据总数',

                nReUchar: '实时数据Uchar类型个数',

                nReChar: '实时数据Char类型个数',

                nReUint: '实时数据Uint类型个数',

                nReInt: '实时数据Int类型个数',

                nReUlong: '实时数据Ulong类型个数',

                nReLong: '实时数据Long类型个数',

                nReFloat: '实时数据Float类型个数',

                zkcsUchar: '自控参数Uchar类型个数',

                zkcsChar: '自控参数Char类型个数',

                zkcsUint: '自控参数Uint类型个数',

                zkcsInt: '自控参数Int类型个数',

                zkcsUlong: '自控参数Ulong类型个数',

                zkcsLong: '自控参数Long类型个数',

                zkcsFloat: '自控参数Float类型个数',

                zkblUchar: '自控变量Uchar类型个数',

                zkblChar: '自控变量Char类型个数',

                zkblUint: '自控变量Uint类型个数',

                zkblInt: '自控变量Int类型个数',

                zkblUlong: '自控变量Ulong类型个数',

                zkblLong: '自控变量Long类型个数',

                zkblFloat: '自控变量Float类型个数'
            },
            id_of_setinterval: ''
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.option.sys_alias = '1';
        this.deviceConfName = this.deviceInfo.category === '配煤' ? this.peimei : this.peishui;
        this.initData(true);
        this.timingLoadData('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.timingLoadData('CLOSE');
    },

    methods: {
        timingLoadData: function timingLoadData(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.initData(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        initData: function initData(type) {
            this.loading = true;
            this.loadDeviceConf(type);
            this.loadDeviceName(type);
        },
        loadDeviceConf: function loadDeviceConf(is_cache) {
            var _this2 = this;

            this.loading = true;

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                _this2.loading = false;
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;
                        _this2.deviceConf.data = [];
                        for (var key in jsonData) {
                            if (_this2.deviceConfName[key]) {
                                _this2.deviceConf.data.push({
                                    name: key,
                                    data: jsonData[key]
                                });
                            }
                        }
                        _this2.deviceConf.time_stamp = data.payload.time_stamp;
                    } catch (err) {}
                } else {
                    if (is_cache) {
                        _this2.initData(false);
                    }
                }
            });
        },
        loadDeviceName: function loadDeviceName(is_cache) {
            var _this3 = this;

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.loadDeviceName(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var _data = JSON.parse(_data.payload.data);

                        _this3.deviceName.data = _data;
                        _this3.deviceName.time_stamp = _data.payload.time_stamp;
                    } catch (err) {
                        console.error();
                    }
                }
            });
        },
        openEdit: function openEdit() {
            this.isEdit = true;
            this.initData(false);
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this4 = this;

            var params = {
                payload: this.dealDeviceConf(),
                device_id: this.deviceInfo.device_id,
                sys_alias: this.option.sys_alias

            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.setDeviceSetting(params, function (data) {
                if (data.status_code === 'SUCCEEDED') {
                    _this4.$message.success('操作成功');
                } else {
                    _this4.$message.error('操作失败');
                }
            });
        },
        dealDeviceConf: function dealDeviceConf() {
            var data = this.deviceConf.data,
                json = {};
            data.forEach(function (v) {
                json[v.name] = v.data;
            });
            json.devNo = this.option.sys_alias * 1;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json);
        }
    }

});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tempControl_pageHead_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tempControl_pageHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tempControl_pageHead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_pageSide_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_pageSide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tempControl_pageSide_vue__);











/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'dashboard',
    components: {
        pageHead: __WEBPACK_IMPORTED_MODULE_5__components_tempControl_pageHead_vue___default.a,
        pageFooter: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue___default.a,
        pageSide: __WEBPACK_IMPORTED_MODULE_6__components_tempControl_pageSide_vue___default.a,
        MpageHead: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue___default.a,
        MpageSide: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue___default.a
    },
    data: function data() {
        return {
            showMe: true
        };
    },

    computed: {
        isLoading: function isLoading() {
            return this.$store.state.isLoading;
        },
        isMobile: function isMobile() {
            return this.$store.state.isMobile;
        },
        isOpen: function isOpen() {
            return this.$store.state.siderbarOpen;
        }
    },
    created: function created() {
        var userInfo = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("userInfo");
        var deviceInfo = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("deviceInfo");
        var deviceListType = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("deviceListType");

        if (userInfo) {
            this.$store.dispatch("setUserInfo", userInfo);
        }
        if (deviceInfo) {
            this.$store.dispatch("setDeviceInfo", deviceInfo);
        }
        if (deviceListType) {
            this.$store.dispatch("setDeviceListType", deviceListType);
        }
    },
    mounted: function mounted() {},


    methods: {
        clickMobileMask: function clickMobileMask() {
            this.$store.dispatch('toggleSide');
        }
    }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_arrow_png__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_loading__);


var echarts = __webpack_require__(42);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: "historyData",
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_header___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_5__components_common_loading___default.a
  },
  data: function data() {
    return {
      img_no_data: __WEBPACK_IMPORTED_MODULE_2__assets_images_no_data_svg___default.a,
      img_arrow: __WEBPACK_IMPORTED_MODULE_3__assets_images_arrow_png___default.a,
      option: {
        sys_alias: 1,
        dateType: "date"
      },
      sys_alias: [],
      loading: {
        chart: true,
        table: true
      },

      charts: "",

      hisData: {
        timeType: "by_day",
        data: [],
        average: []
      },
      chartsData: {
        xData: [],
        proData: [],
        passData: []
      },
      tableHeader: []
    };
  },
  created: function created() {
    this.loadHisData();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.selectInputFoc();
  },


  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    },
    siderbarOpen: function siderbarOpen(state) {
      var _this = this;

      setTimeout(function () {
        _this.charts.resize();
      }, 400);
      return state.siderbarOpen;
    }
  }),

  methods: {
    momentYear: function momentYear(data) {
      return moment(data).format("YYYY-MM");
    },
    changeOption: function changeOption(type) {
      this.loadHisData();
    },
    loadHisData: function loadHisData() {
      var _this2 = this;

      this.loading.table = true;
      var params = {
        device_id: this.deviceInfo.device_id,
        data_type: "clData",
        sys_alias: this.option.sys_alias
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }

      __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.loadDeviceData(params, function (data) {
        _this2.loading.chart = false;
        _this2.loading.table = false;
        if (data.status_code === "SUCCEEDED") {
          console.log(data.payload);

          if (data.payload && data.payload) {
            try {
              _this2.hisData.data = JSON.parse(data.payload.data);

              _this2.chartsDataFn(_this2.hisData.data.monData);
              _this2.$nextTick(function () {
                _this2.initChart();
              });
            } catch (error) {
              console.error({
                msg: "产量数据解析错误",
                data: data,
                error: error
              });
            }
          } else {
            _this2.hisData.data = [];
          }
        } else {
          _this2.$message(data.msg);
        }
      });
    },
    chartsDataFn: function chartsDataFn(data) {
      var coal = [],
          material = [];

      for (var i = 1; i < data.length; i++) {
        coal.push(data[i].煤料);
        material.push(data[i].原料);
      }

      var data1 = [],
          data2 = [];

      this.chartsData = {
        coal: coal,
        material: material
      };
    },
    initChart: function initChart() {
      var chartsData = this.chartsData;
      var charts = void 0;

      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        legend: {
          data: ["煤料", "原料"],
          align: "left",
          bottom: 20
        },

        xAxis: {
          show: true,
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          silent: false,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          show: "true",
          type: "value",
          name: "T"
        },
        series: [{
          name: "煤料",
          type: "bar",
          data: chartsData.coal,
          animationDelay: function animationDelay(idx) {
            return idx * 10;
          },
          itemStyle: {
            normal: {
              color: "#000"
            },
            emphasis: {
              color: "#ccc"
            }
          },
          barCategoryGap: "40%"
        }, {
          name: "原料",
          type: "bar",
          data: chartsData.material,
          animationDelay: function animationDelay(idx) {
            return idx * 10;
          },
          itemStyle: {
            normal: {
              color: "#ff8283"
            },
            emphasis: {
              color: "#ff5653"
            }
          },
          barCategoryGap: "40%"
        }],
        animationEasing: "elasticOut",
        animationDelayUpdate: function animationDelayUpdate(idx) {
          return idx * 5;
        }
      };
      if (this.$refs.charts) {
        charts = echarts.init(this.$refs.charts, charts, {
          height: 400
        });
        charts.setOption(option);
      }

      this.charts = charts;
    },
    setScroll: function setScroll(type) {
      var hisTable = this.$refs.hisTable,
          scrollLeft = this.$refs.hisTable.scrollLeft;
      if (type === "right") {
        hisTable.scrollLeft = scrollLeft + 80;
      } else {
        hisTable.scrollLeft = scrollLeft - 80;
      }
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_wxLoading__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_wxLoading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_wxLoading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_dropTimePicker__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_dropTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_dropTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(6);












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "W_realData",
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2__components_common_loading_vue___default.a,
    Mconfirm: __WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm___default.a,
    WxLoading: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_wxLoading___default.a,
    dropList: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_dropTimePicker___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    config: function config(state) {
      return state.config;
    }
  })),
  data: function data() {
    return {
      option: {
        sys_alias: 1,
        date: __WEBPACK_IMPORTED_MODULE_7_moment___default()()

      },
      sys_alias: [],
      realData: {},
      tableData: {},
      realDataTh: {
        fAi: "实时值",
        fHour: "时累计",
        fDay: "日累计",
        fmc: "设定值"
      },
      edit: {
        type: "CLOSE"
      },
      loading: {
        realData: true,
        confData: true,
        auto: false
      },
      confData: {},
      dropList: {
        show: false
      },
      hisDataList: [],
      hisData: [],

      id_of_setinterval: ""
    };
  },
  created: function created() {
    this.getConf(true);
    this.loadHisData();
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].M.selectInputFoc();
    this.timingLoadRealData('OPEN');
  },
  beforeDestroy: function beforeDestroy() {
    this.timingLoadRealData('CLOSE');
  },

  methods: {
    toogleDrop: function toogleDrop() {
      if (this.dropList.show) {
        this.loadRealData(true);
      }
      this.dropList.show = !this.dropList.show;
    },
    selectItem: function selectItem(data, dataList, index) {
      this.tableData = this.hisData[index];
    },
    selectDate: function selectDate(time) {
      this.option.date = time.day;
      this.loadHisData();
    },
    timingLoadRealData: function timingLoadRealData(type) {
      var _this = this;

      if (type === "OPEN") {
        this.id_of_setinterval = setInterval(function () {
          _this.loadRealData(false, true);
        }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
      } else {
        clearInterval(this.id_of_setinterval);
      }
    },
    loadFreashData: function loadFreashData() {
      this.loadRealData(false);
      this.getConf(false);
    },
    loadRealData: function loadRealData(is_cache, is_auto) {
      var _this2 = this;

      if (!is_auto) {
        this.loading.realData = true;
      } else {
        this.loading.auto = true;
      }

      var params = {
        data_type: "realData",
        sys_alias: 1,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].api.loadDeviceData(params, function (data) {
        if (data.status_code === "SUCCEEDED") {}
        if (data.payload.data) {
          var payload = JSON.parse(data.payload.data);
          _this2.realData = payload;
          _this2.tableData = {
            fAi: payload.fAi,
            fDay: payload.fDay,
            fHour: payload.fHour,
            fdb: payload.fdb,
            fhb: payload.fhb,
            fmc: payload.fmc,
            sdz: payload.sdz,
            yxzt: payload.yxzt ? payload.yxzt : {},
            time_stamp: payload.date
          };
          _this2.loading.realData = false;
          _this2.loading.auto = false;
        } else {}
      });
    },
    openEdit: function openEdit() {
      this.edit.type = 'OPEN';
      this.getConf(false);
    },
    closeEdit: function closeEdit() {
      this.edit.type = 'CLOSE';
    },
    getConf: function getConf(is_cache) {
      if (this.deviceInfo.category === '配水') {
        this.loadControlConf(is_cache);
      } else if (this.deviceInfo.category === '配煤') {
        this.loadStandConf(is_cache);
      }
    },
    saveConf: function saveConf() {
      if (this.deviceInfo.category === '配水') {
        this.saveControlConf();
      } else if (this.deviceInfo.category === '配煤') {
        this.saveStandConf();
      }
    },
    loadStandConf: function loadStandConf(is_cache) {
      var _this3 = this;

      this.loading.confData = true;
      var params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias * 1,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache,
        payload: {
          devNo: this.option.sys_alias * 1,
          type: 30 }
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].api.loadDeviceConf(params, function (data) {
        _this3.loading.confData = false;

        if (data.status_code === "SUCCEEDED") {} else {
          _this3.$message({
            message: "网络连接超时：" + data.msg,
            type: "warning"
          });
          if (!_this3.isMobile) {
            _this3.$notify.info({
              title: "温馨提示",
              message: "无法连接设备时，无法进行参数修改操作",
              duration: 3000,
              offset: 60
            });
          }
          _this3.closeEdit();
        }
        if (data.payload && data.payload.data) {
          _this3.confData = JSON.parse(data.payload.data);
        }
      });
    },
    saveStandConf: function saveStandConf() {
      var _this4 = this;

      this.loading.confData = true;
      var payload = this.confData;
      payload.devNo = this.option.sys_alias * 1;
      payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
      var params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias.toString(),
        device_id: this.deviceInfo.device_id,
        payload: payload
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].api.setDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this4.$message.success("修改成功");
          _this4.getConf(false);
          _this4.closeEdit();
        } else {
          _this4.$message.error("\u4FEE\u6539\u5931\u8D25\uFF1A" + data.msg);
          _this4.loading.confData = false;
        }
      });
    },
    saveControlConf: function saveControlConf() {
      var _this5 = this;

      this.loading.confData = true;
      var payload = this.confData;
      payload.devNo = this.option.sys_alias * 1;
      payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
      var params = {
        conf_type: "control",
        sys_alias: this.option.sys_alias.toString(),
        device_id: this.deviceInfo.device_id,
        payload: payload
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].api.setDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this5.$message.success("修改成功");
          _this5.getConf(false);
          _this5.closeEdit();
        } else {
          _this5.$message.error("\u4FEE\u6539\u5931\u8D25\uFF1A" + data.msg);
          _this5.loading.confData = false;
        }
      });
    },
    loadHisData: function loadHisData() {
      var _this6 = this;

      var params = {
        device_id: this.deviceInfo.device_id,
        data_type: "hisDatap",
        sys_alias: this.option.sys_alias,
        page_size: 300,
        order: "asc"
      };
      if (this.option.date) {
        params.begin = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.option.date).format("YYYY-MM-DD 00:00:00");
        params.end = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.option.date).add(1, "day").format("YYYY-MM-DD 00:00:00");
      }
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].api.loadDeviceData(params, function (data) {
        _this6.loadRealData(true);

        if (data.status_code === "SUCCEEDED") {
          if (data.payload && data.payload.length > 0) {
            _this6.hisData = _this6.dealHisData(data.payload);
            _this6.hisDataList = _this6.hisData.map(function (obj) {
              obj.fAi.forEach(function (aiObj, i) {
                var newObj = {};
                newObj[aiObj.key] = aiObj.value;
                obj["fAi_" + i] = newObj;
              });
              obj.fAi = null;
              obj.sdz.forEach(function (sdzObj, i) {
                var newObj = {};
                newObj[sdzObj.key] = sdzObj.value;
                obj["sdz_" + i] = newObj;
              });
              obj.sdz = null;
              return obj;
            });
          } else {}
        } else {
          console.error("历史数据接口：" + data.msg);
        }
      });
    },
    dealHisData: function dealHisData(data) {
      var arr = [];
      data.forEach(function (v) {
        v.data = JSON.parse(v.data);
        arr.push({
          fAi: v.data.fAi,
          fDay: v.data.fDay,
          fHour: v.data.fHour,
          fdb: v.data.fdb,
          fhb: v.data.fhb,
          fmc: v.data.fmc,
          sdz: v.data.sdz,
          yxzt: v.data.yxzt ? v.data.yxzt : {},
          time_stamp: v.data.date

        });
      });
      return arr;
    },
    loadControlConf: function loadControlConf(is_cache) {
      var _this7 = this;

      this.loading.confData = true;
      var params = {
        conf_type: "control",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_6__lib_lib__["a" /* default */].api.loadDeviceConf(params, function (data) {
        _this7.loading.confData = false;

        if (data.status_code === "SUCCEEDED") {} else {
          _this7.$message({
            message: "网络连接超时：" + data.msg,
            type: "warning"
          });
          if (!_this7.isMobile) {
            _this7.$notify.info({
              title: "温馨提示",
              message: "无法连接设备时，无法进行参数修改操作",
              duration: 3000,
              offset: 60
            });
          }
          _this7.closeEdit();
        }
        if (data.payload && data.payload.data) {
          _this7.confData = JSON.parse(data.payload.data);
        }
      });
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: "controlSet",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: "",
                isEdit: false,
                canEdit: false,
                time_stamp: ""
            },
            test: "",
            loading: "",
            controlLoading: false,
            sys_alias: [],
            val: "",
            confData: [],
            deviceConfName: {},
            paramRange: [],
            peimei: {

                bzcsUchar: '标准参数Uchar类型个数',

                bzcsChar: '标准参数Char类型个数',

                bzcsUint: '标准参数Uint类型个数',

                bzcsInt: '标准参数Int类型个数',

                bzcsUlong: '标准参数Ulong类型个数',

                bzcsLong: '标准参数Long类型个数',

                bzcsFloat: '标准参数Float类型个数'
            },
            peishui: {

                nReUchar: '实时数据Uchar类型个数',

                nReChar: '实时数据Char类型个数',

                nReUint: '实时数据Uint类型个数',

                nReInt: '实时数据Int类型个数',

                nReUlong: '实时数据Ulong类型个数',

                nReLong: '实时数据Long类型个数',

                nReFloat: '实时数据Float类型个数'

            }

        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        }
    }),
    created: function created() {
        this.option.sys_alias = "1";
        this.deviceConfName = this.deviceInfo.category === '配煤' ? this.peimei : this.peishui;
    },
    mounted: function mounted() {
        this.loadData(true);
        __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.selectInputFoc();
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
    },

    methods: {
        loadDeviceConf: function loadDeviceConf(is_cache, callback) {

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            var that = this;
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;

                        that.paramRange = [];
                        var totle = 0;
                        for (var key in jsonData) {
                            if (that.deviceConfName[key]) {
                                totle += jsonData[key];
                                that.paramRange.push(totle);
                            }
                        }

                        if (callback) {
                            callback(true);
                        }
                        return;
                    } catch (err) {}
                }
                if (callback) {
                    callback(true);
                }
            });
        },
        loadControlConf: function loadControlConf(is_cache, callback) {
            var _this = this;

            this.loading = true;
            this.controlLoading = true;
            var params = {
                conf_type: "standard",
                sys_alias: this.option.sys_alias,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache,
                payload: {
                    devNo: 1,
                    type: 30
                }
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            var that = this;
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                _this.loading = false;
                _this.controlLoading = false;

                if (data.status_code === "SUCCEEDED") {
                    if (data.payload && data.payload.data) {
                        var confData = _this.dealDateFn(data, "load");
                        if (confData.length > 0) {
                            that.confData = confData;
                            that.option.time_stamp = data.payload.time_stamp;
                            if (callback) {
                                callback();
                            }
                            return;
                        }
                    }
                }
                _this.$message({
                    message: "网络连接超时：" + data.msg,
                    type: "warning"
                });
                if (!_this.isMobile) {
                    _this.$notify.info({
                        title: "温馨提示",
                        message: "无法连接设备时，无法进行参数修改操作",
                        duration: 3000,
                        offset: 60
                    });
                }
                _this.closeEdit();
            });
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this2 = this;

            this.loading = true;
            var payload = this.dealDateFn(this.confData, "post");
            if (payload == false) {
                this.$message.error("参数错误");
                return false;
            } else {
                payload.devNo = 1;
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
            }
            var params = {
                conf_type: "standard",
                sys_alias: this.option.sys_alias.toString(),
                device_id: this.deviceInfo.device_id,
                payload: payload
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this2.$message.success("修改成功");
                    _this2.loadControlConf(false);
                    _this2.closeEdit();
                } else {
                    _this2.$message.error("\u4FEE\u6539\u5931\u8D25\uFF1A" + data.msg);
                    _this2.loading = false;
                }
            });
        },
        dealDateFn: function dealDateFn(data, type) {
            var confData = void 0;
            if (type === "load") {
                var jsonData = JSON.parse(data.payload.data);
                confData = [];
                if (jsonData.oother) {
                    delete jsonData.oother;
                    if (jsonData.msg) {
                        delete jsonData.msg;
                        delete jsonData.isSuccess;
                    }
                }
                this.test = jsonData;
                var jsonDataIndex = 0;
                for (var key in jsonData) {
                    if (jsonData.hasOwnProperty(key)) {
                        var item = jsonData[key],
                            precision = 0,
                            step = 1,
                            max = 5000,
                            min = 0;
                        if (this.paramRange.length > 0) {
                            if (jsonDataIndex < this.paramRange[0]) {
                                max = 255;
                                min = 0;
                            } else if (jsonDataIndex < this.paramRange[1]) {
                                max = 127;
                                min = -128;
                            } else if (jsonDataIndex < this.paramRange[2]) {
                                max = 32767;
                                min = -32768;
                            } else if (jsonDataIndex < this.paramRange[3]) {
                                max = 65565;
                                min = 0;
                            } else if (jsonDataIndex < this.paramRange[4]) {
                                max = 2147483647;
                                min = -2147483648;
                            } else if (jsonDataIndex < this.paramRange[5]) {
                                max = 4294967295;
                                min = 0;
                            } else if (jsonDataIndex < this.paramRange[6]) {
                                max = 100000;
                                min = -100000;
                                item = parseFloat(item.toFixed(2));
                                precision = 2;
                                step = 0.01;
                            }
                        }
                        confData.push({
                            name: key,
                            data: item,
                            precision: precision,
                            step: step,
                            max: max,
                            min: min
                        });
                    }
                    jsonDataIndex++;
                }
            } else {
                if (this.paramRange.length < 7) {
                    return false;
                }
                confData = {};
                for (var i = 0; i < data.length; i++) {
                    var _item = data[i];
                    if (data[i].data === "") {
                        return false;
                    }
                    confData[_item.name] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.round(_item.data, 2);
                    if (i < this.paramRange[5]) {
                        confData[_item.name] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.round(_item.data);
                    }
                }
            }
            return confData;
        },
        checkInputNumber: function checkInputNumber(val, index) {},
        loadData: function loadData(useCache, callback) {
            var that = this;
            this.loadDeviceConf(useCache, function (succ) {
                that.loadControlConf(useCache, callback);
            });
        },
        openEdit: function openEdit() {
            if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                this.loading = true;
                var that = this;
                this.option.isEdit = true;
                this.loadData(false, function () {
                    that.option.canEdit = true;
                });
            } else {
                this.$message.error("权限不足，修改失败");
            }
        },
        closeEdit: function closeEdit() {
            this.option.isEdit = false;
        }
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_Mconfirm__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_Mconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_Mconfirm__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      msg: 'demo',
      time1: '',
      dateType: '',
      msgShow: false,
      show: true,

      urlParams: this.$route.query
    };
  },

  components: {
    Mconfirm: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_Mconfirm___default.a
  },
  mounted: function mounted() {},

  methods: {
    open: function open() {
      this.show = true;
    },
    cancel: function cancel() {
      this.show = false;
    },
    define: function define() {
      this.show = false;
    }
  }

});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_error_svg__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_images_error_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_images_error_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "error",
  data: function data() {
    return {
      errorImg: __WEBPACK_IMPORTED_MODULE_0__assets_images_error_svg___default.a,
      error_code: '',
      title: '无法访问',
      config: __WEBPACK_IMPORTED_MODULE_1__lib_lib__["a" /* default */].C
    };
  },
  created: function created() {
    this.error_code = this.$route.query.error;
    if (this.error_code === '401') {
      this.title = '权限不足,无法访问';
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "logo",
  data: function data() {
    return {
      msg: "",
      type: this.$route.query.type
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    }
  })),
  created: function created() {
    this.verifyToken();
    this.$store.dispatch('setDeviceListType', this.type);
  },

  methods: {
    verifyToken: function verifyToken() {
      var query = this.$route.query;
      var userInfo = __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.ls.getItem("userInfo"),
          customer_token = query.customer_token,
          user_token = query.user_token;
      if (!customer_token && !user_token && userInfo) {
        if (userInfo.identity === "CUSTOMER") {
          customer_token = userInfo.token;
        }
      }

      if (customer_token) {
        this.verifyCustom(customer_token);
      } else if (user_token) {
        this.verifyUser(user_token);
      } else {
        this.msg = "登陆失败";


        location.href = __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].C.adminHost + "leemmaCustomer?state=" + this.type;
      }
    },
    verifyCustom: function verifyCustom(customer_token) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.verifyCustom({ customer_token: customer_token }, function (data) {
        if (data.status_code === "SUCCEEDED") {
          var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            token: customer_token,
            identity: "CUSTOMER"
          }, data.payload);
          _this.$store.dispatch("setUserInfo", payload);
          _this.$router.push("/user/");
        } else {
          _this.$router.push("/error");
        }
      });
    },
    verifyUser: function verifyUser(token) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.verifyUser({ auth_token: token }, function (data) {
        if (data.status_code === "SUCCEEDED") {
          var payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            token: token,
            identity: "USER"
          }, data.payload);
          _this2.$store.dispatch("setUserInfo", payload);
          _this2.loadDevice(token);
        } else {
          if (__WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.isWeChat()) {
            console.log("wechat");
          } else {
            console.log("customer");
          }
        }
      });
    },
    loadDevice: function loadDevice(token) {
      var _this3 = this;

      var deviceInfo = __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.ls.getItem("deviceInfo");
      var params = {
        device_id: this.$route.query.device_id ? this.$route.query.device_id : deviceInfo.device_id,
        auth_token: token
      };
      __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.loadDevice(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this3.$store.dispatch("setDeviceInfo", data.payload);
          if (data.payload.category === '温控') {
            if (_this3.isMobile) {
              _this3.$router.push("/MtempControl/");
            } else {
              _this3.$router.push("/tempControl/");
            }
          } else {
            _this3.$router.push("/allocate/");
          }
        } else {
          _this3.$router.push("/error");
          _this3.msg = "无法获取当前设备详情";
        }
      });
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_config__ = __webpack_require__(107);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'logout',
    created: function created() {
        location.href = __WEBPACK_IMPORTED_MODULE_0__lib_config__["a" /* default */].adminHost + 'leemmaCustomer';
    }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: "autoVal",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default.a
    },
    data: function data() {
        return {
            isEdit: false,
            option: {
                sys_alias: ""
            },
            test: "",
            loading: "",
            sys_alias: [],
            val: "",
            confData: [],
            options: [{
                label: "一号窑",
                val: 1
            }],
            tableData: [],
            timeShow: "",
            id_of_setinterval: ''
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
        this.option.sys_alias = "1";
    },
    mounted: function mounted() {
        for (var i = 0; i < 1; i++) {
            this.checkUpdata();
            __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.selectInputFoc();
        }
        this.timingLoad('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
        this.timingLoad('CLOSE');
    },

    methods: {
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: "" + (i + 1),
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        checkUpdata: function checkUpdata() {
            var isNew = void 0,
                date = void 0;
            this.changeOption(true);
        },
        changeOption: function changeOption(type) {
            this.loading = true;
            this.confData = [];
            this.loadControlConf(type);
        },
        timingLoad: function timingLoad(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadControlConf(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadControlConf: function loadControlConf(is_cache) {
            var _this2 = this;

            var params = {
                conf_type: "auto",
                sys_alias: this.option.sys_alias,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                _this2.loading = false;
                if (data.status_code === "SUCCEEDED") {} else {
                    _this2.$message({
                        message: "获取自控变量错误," + data.msg,
                        type: "warning"
                    });
                }
                _this2.timeShow = data.payload.time_stamp;
                if (data.payload && data.payload.data) {
                    var tableData = JSON.parse(data.payload.data);
                    if (tableData.oother) {
                        delete tableData.oother;
                        if (tableData.msg) {
                            delete tableData.msg;
                            delete tableData.isSuccess;
                        }
                    }
                    _this2.tableData = [];
                    for (var key in tableData) {
                        if (tableData.hasOwnProperty(key)) {
                            var element = tableData[key];
                            if (key !== "isSuccess" && key !== "msg") {
                                _this2.tableData.push({
                                    name: key,
                                    data: element
                                });
                            }
                        }
                    }
                } else if (is_cache) {
                    _this2.loadControlConf(false);
                }
            });
        }
    }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: "controlSet",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default.a,
        Mconfirm: __WEBPACK_IMPORTED_MODULE_5__components_tempControl_Mconfirm___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: "",
                isEdit: false,
                time_stamp: ""
            },
            test: "",
            loading: "",
            sys_alias: [],
            val: "",
            confData: [],
            isRepeat: false,
            floatDataIndexStart: 24,
            floatDataIndexEnd: 45,
            saveConf: {
                show: true
            },
            id_of_setinterval: ''

        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
        this.option.sys_alias = "1";
    },
    mounted: function mounted() {
        for (var i = 0; i < 1; i++) {
            this.changeOption(true);
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.selectInputFoc();
        }
        this.timingLoad('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
        this.timingLoad('CLOSE');
    },

    methods: {
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: "" + (i + 1),
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        changeOption: function changeOption(type) {
            this.loading = true;
            this.confData = [];
            var that = this;
            this.loadDeviceSettings(type, function (is_succ) {
                that.loadControlConf(type);
            });
        },
        timingLoad: function timingLoad(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadControlConf(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadDeviceSettings: function loadDeviceSettings(is_cache, callback) {
            var _this2 = this;

            this.loading = true;
            var params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;
                        console.log("device setting:", jsonData);
                        _this2.floatDataIndexStart = jsonData.zkcsUchar + jsonData.zkcsChar + jsonData.zkcsUint + jsonData.zkcsInt + jsonData.zkcsUlong + jsonData.zkcsLong;
                        _this2.floatDataIndexEnd = _this2.floatDataIndexStart + jsonData.zkcsFloat;
                    } catch (err) {
                        console.log(err);
                    }
                    if (callback) {
                        callback();
                    }
                } else {
                    if (!is_cache) {
                        _this2.loadDeviceSettings(true, callback);
                    } else {
                        if (callback) {
                            callback();
                        }
                    }
                }
            });
        },
        loadControlConf: function loadControlConf(is_cache) {
            var _this3 = this;

            var params = {
                conf_type: "control",
                sys_alias: this.option.sys_alias,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                _this3.loading = false;

                if (data.status_code === "SUCCEEDED") {} else {
                    _this3.$message({
                        message: "网络连接超时：" + data.msg,
                        type: "warning"
                    });
                    if (!_this3.isMobile) {
                        _this3.$notify.info({
                            title: "温馨提示",
                            message: "无法连接设备时，无法进行参数修改操作",
                            duration: 3000,
                            offset: 60
                        });
                    }
                    _this3.closeEdit();
                    if (!_this3.isRepeat) {
                        _this3.isRepeat = true;
                        _this3.loadControlConf(false);
                    }
                }
                if (data.payload && data.payload.data) {
                    _this3.confData = _this3.dealDateFn(data, "load");
                    _this3.option.time_stamp = data.payload.time_stamp;
                }
            });
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this4 = this;

            this.loading = true;
            var payload = this.dealDateFn(this.confData, "post");
            if (payload == false) {
                this.$message.error("参数错误");
                return false;
            } else {
                payload.devNo = this.option.sys_alias * 1;
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
            }
            var params = {
                conf_type: "control",
                sys_alias: this.option.sys_alias.toString(),
                device_id: this.deviceInfo.device_id,
                payload: payload
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            console.log(params);
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this4.$message.success("修改成功");
                    _this4.loadControlConf(false);
                    _this4.closeEdit();
                } else {
                    _this4.$message.error("\u4FEE\u6539\u5931\u8D25\uFF1A" + data.msg);
                    _this4.loading = false;
                }
            });
        },
        dealDateFn: function dealDateFn(data, type) {
            var confData = void 0;
            if (type === "load") {
                var jsonData = JSON.parse(data.payload.data);
                confData = [];
                if (jsonData.oother) {
                    delete jsonData.oother;
                    if (jsonData.msg) {
                        delete jsonData.msg;
                        delete jsonData.isSuccess;
                    }
                }
                this.test = jsonData;
                var jsonDataIndex = 0;
                for (var key in jsonData) {
                    if (jsonData.hasOwnProperty(key)) {
                        var item = jsonData[key],
                            precision = 0,
                            step = 1,
                            max = void 0,
                            min = void 0;
                        if (jsonDataIndex < 11) {
                            max = 255;
                            min = 0;
                        } else if (jsonDataIndex < this.floatDataIndexStart) {
                            max = 65565;
                            min = 0;
                        } else if (jsonDataIndex < this.floatDataIndexEnd) {
                            max = 35575;
                            min = -35575;
                            if (precision <= 0) {
                                precision = 1;
                                item = item.toFixed(precision);
                                console.log(item, precision);
                            }
                        }
                        confData.push({
                            name: key,
                            data: item,
                            max: max,
                            min: min
                        });
                    }
                    jsonDataIndex++;
                }
            } else {
                confData = {};
                for (var i = 0; i < data.length; i++) {
                    var _item = data[i];
                    if (data[i].data === "") {
                        return false;
                    }
                    confData[_item.name] = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.round(_item.data, 2);
                    if (i < this.floatDataIndexStart) {
                        confData[_item.name] = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.round(_item.data);
                    }
                }
            }
            console.log(confData);
            return confData;
        },
        checkInputNumber: function checkInputNumber(val, index) {},
        openEdit: function openEdit() {
            if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                this.option.isEdit = true;
                this.changeOption(false);
                this.timingLoad('CLOSE');
            } else {
                this.$message.error("权限不足，修改失败");
            }
        },
        closeEdit: function closeEdit() {
            this.timingLoad('OPEN');
            this.option.isEdit = false;
        }
    }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_lib__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["default"] = ({

    name: "deviceConf",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: ''
            },
            sys_alias: '',
            loading: true,
            isEdit: '',
            deviceConf: {
                data: [],
                time_stamp: ''
            },

            deviceName: {
                data: '',
                time_stamp: ''
            },

            deviceConfName: {
                bakeCars: '焙烧窑总车位',

                dryCars: '烧烘干窑总车位',

                bakeCarNum: '焙烧标准温度个数',

                dryCarNum: '烘干标准温度个数',

                kiNum: 'K型热电偶总数',

                aoNum: '风机总数',

                piNum: '压力总数',

                aioNum: '4-20mA型总数',

                hisKi: '历史数据表中温度数据个数',

                hisAo: '历史数据表中风机总数',

                hisPi: '历史数据表中压力总数',

                hisCi: '历史数据表中湿度总数',

                detectNum: '巡检提示、报警类型数',

                autoNum: '自控提示、报警类型数',

                zkcsUchar: '自控参数Uchar类型个数',

                zkcsChar: '自控参数Char类型个数',

                zkcsUint: '自控参数Uint类型个数',

                zkcsInt: '自控参数Int类型个数',

                zkcsUlong: '自控参数Ulong类型个数',

                zkcsLong: '自控参数Long类型个数',

                zkcsFloat: '自控参数Float类型个数',

                zkblUchar: '自控变量Uchar类型个数',

                zkblChar: '自控变量Char类型个数',

                zkblUint: "自控变量Uint类型个数",

                zkblInt: "自控变量Int类型个数",

                zkblUlong: '自控变量Ulong类型个数',

                zkblLong: '自控变量Long类型个数',

                zkblFloat: '自控变量Float类型个数'

            },
            id_of_setinterval: ''
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.sys_alias = __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].M.creatAliasMeun(this.deviceInfo.alias_m);
        this.option.sys_alias = '1';
        this.initData(true);
    },
    beforeDestroy: function beforeDestroy() {
        this.timingLoad('CLOSE');
    },

    methods: {
        initData: function initData(type) {
            this.loading = true;
            this.loadDeviceConf(type);

            this.timingLoad('OPEN');
        },
        changeOption: function changeOption(type) {
            this.loading = true;
            this.confData = [];
            this.loadDeviceConf(type);
            this.loadDeviceName(type);
        },
        timingLoad: function timingLoad(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadDeviceConf(false);
                    _this.loadDeviceName(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadDeviceConf: function loadDeviceConf(is_cache) {
            var _this2 = this;

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                _this2.loading = false;
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;
                        _this2.deviceConf.data = [];
                        for (var key in jsonData) {
                            if (_this2.deviceConfName[key]) {
                                _this2.deviceConf.data.push({
                                    name: key,
                                    data: jsonData[key]
                                });
                            }
                        }
                        _this2.deviceConf.time_stamp = data.payload.time_stamp;
                    } catch (err) {}
                } else {
                    if (is_cache) {
                        _this2.initData(false);
                    }
                }
            });
        },
        loadDeviceName: function loadDeviceName(is_cache) {
            var _this3 = this;

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.loadDeviceName(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var _data = JSON.parse(_data.payload.data);

                        _this3.deviceName.data = _data;
                        _this3.deviceName.time_stamp = _data.payload.time_stamp;
                    } catch (err) {
                        console.error();
                    }
                }
            });
        },
        openEdit: function openEdit() {
            this.isEdit = true;
            this.initData(false);
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this4 = this;

            var params = {
                payload: this.dealDeviceConf(),
                device_id: this.deviceInfo.device_id,
                sys_alias: this.option.sys_alias

            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.setDeviceSetting(params, function (data) {
                if (data.status_code === 'SUCCEEDED') {
                    _this4.$message.success('操作成功');
                } else {
                    _this4.$message.error('操作失败');
                }
            });
        },
        dealDeviceConf: function dealDeviceConf() {
            var data = this.deviceConf.data,
                json = {};
            data.forEach(function (v) {
                json[v.name] = v.data;
            });
            json.devNo = this.option.sys_alias * 1;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json);
        }
    }

});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_datePick__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_datePick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_datePick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_loading__);


var echarts = __webpack_require__(42);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: "historyData",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default.a,
        dataPicker: __WEBPACK_IMPORTED_MODULE_5__components_common_datePick___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_7__components_common_loading___default.a
    },
    data: function data() {
        return {
            img_no_data: __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default.a,
            img_arrow: __WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png___default.a,
            option: {
                sys_alias: 1,
                date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD"),
                dateType: "date"
            },
            excelModal: {
                show: false
            },
            sys_alias: [],
            loading: {
                chart: true,
                table: true
            },

            charts: "",
            timeOpt: [{
                label: "年报表",
                val: "by_year"
            }, {
                label: "月报表",
                val: "by_month"
            }, {
                label: "日报表",
                val: "by_day"
            }],
            hisData: {
                timeType: "by_day",
                data: [],
                average: []
            },
            chartsData: {
                xData: [],
                proData: [],
                passData: []
            },
            tableHeader: [],
            dayHeader: [{ name: "进车开始时间", key: "startDate" }, { name: "累计进车数", key: "leiji" }, { name: "进车时间（分）", key: "carInTime" }, { name: "进车间隔", key: "carInIntervalTime" }, { name: "操作员姓名", key: "name" }, { name: "发热量（kc/kg）", key: "heat" }, { name: "合格率（％）", key: "rate" }],
            monthHeader: [{ name: "日期", key: "date" }, { name: "进车平均间隔", key: "interval" }, { name: "进车数", key: "day_counter" }, { name: "发热量平均", key: "heat" }, { name: "平均合格率", key: "rate" }],
            yearHeader: [{ name: "日期", key: "date" }, { name: "进车平均间隔", key: "interval" }, { name: "进车数", key: "counter" }, { name: "发热量平均", key: "heat" }, { name: "平均合格率", key: "rate" }]
        };
    },
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
    },
    mounted: function mounted() {
        this.loadHisData();
        __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.selectInputFoc();
    },

    watch: {
        "hisData.timeType": function hisDataTimeType() {
            this.changeOption();
        }
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        siderbarOpen: function siderbarOpen(state) {
            var _this = this;

            setTimeout(function () {
                _this.charts.resize();
            }, 400);
            return state.siderbarOpen;
        }
    }),

    methods: {
        momentYear: function momentYear(data) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(data).format("YYYY-MM");
        },
        momentDay: function momentDay(data) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(data).format("HH:mm:ss");
        },
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: i + 1,
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        changeOption: function changeOption(type) {
            if (this.hisData.timeType === "by_day") {
                this.option.dateType = "date";
            } else {
                this.option.dateType = this.hisData.timeType.split("by_")[1];
            }
            this.loadHisData();
        },
        loadHisData: function loadHisData() {
            var _this2 = this;

            this.loading.table = true;

            var params = {
                device_id: this.deviceInfo.device_id,
                data_type: "proData",
                sys_alias: this.option.sys_alias,
                date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).format("YYYY-MM-DD"),
                time_type: this.hisData.timeType
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }

            if (!params.date) {
                params.date = "2011-02-01";
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceData(params, function (data) {
                _this2.loading.chart = false;
                _this2.loading.table = false;
                if (data.status_code === "SUCCEEDED") {
                    if (data.payload && data.payload) {
                        try {
                            _this2.hisData.data = _this2.parseJsonArr(data.payload);

                            _this2.chartsDataFn(_this2.hisData.data);
                            _this2.$nextTick(function () {
                                if (_this2.hisData.timeType && _this2.hisData.timeType !== "by_day") {
                                    _this2.initChart();
                                }
                            });
                        } catch (error) {
                            console.error({
                                msg: "产量数据解析错误",
                                data: data,
                                error: error
                            });
                        }
                    } else {
                        _this2.hisData.data = [];
                    }
                } else {
                    _this2.$message(data.msg);
                }
            });
        },
        clickExcel: function clickExcel() {
            this.excelModal.show = true;
        },
        exportExcelFn: function exportExcelFn() {
            var params = {
                device_id: this.deviceInfo.device_id,
                data_type: "proData",
                sys_alias: this.option.sys_alias,
                date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).format("YYYY-MM-DD"),
                time_type: this.hisData.timeType
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }

            var url = __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].C.APIhost + "/devices/" + this.deviceInfo.device_id + "/pro_export?device_id=" + this.deviceInfo.device_id + "&data_type=proData&sys_alias=" + this.option.sys_alias + "&date=" + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).format("YYYY-MM-DD") + "&time_type=" + this.hisData.timeType + "&auth_token=" + (params.auth_token ? params.auth_token : "") + (params.customer_token ? '&customer_token=' + customer_token : "");
            window.open(url);
        },
        parseJsonArr: function parseJsonArr(arr) {
            var resArr = [];
            if (this.hisData.timeType === "by_day") {
                this.tableHeader = this.dayHeader;
                arr.forEach(function (item) {
                    try {
                        resArr.push(JSON.parse(item.data));
                    } catch (error) {
                        console.error({
                            error: error,
                            msg: "日产量数据解析失败",
                            data: item.data
                        });
                    }
                }, this);
            } else {
                this.tableHeader = this.hisData.timeType === "by_month" ? this.monthHeader : this.yearHeader;
                resArr = arr.data;
                this.hisData.average = JSON.parse(arr.average);
            }
            return resArr;
        },
        chartsDataFn: function chartsDataFn(data) {
            var xData = [],
                countData = [],
                rateData = [];

            if (this.hisData.timeType === "by_month") {
                var monthDays = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).daysInMonth();
                for (var i = 1; i <= monthDays; i++) {
                    xData.push(i);
                    countData.push(0.1);
                }
                data.forEach(function (item) {
                    var d = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.date).format("D") * 1 - 1,
                        x = xData[d];
                    if (x) {
                        countData[x - 1] = item.day_counter ? item.day_counter : item.counter;
                    }
                });
            } else if (this.hisData.timeType === "by_year") {
                for (var _i = 1; _i <= 12; _i++) {
                    xData.push(_i);
                    countData.push(0.1);
                }
                data.forEach(function (item) {
                    var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.date).format("M") * 1,
                        x = xData[m - 1];
                    if (x) {
                        countData[m - 1] = item.day_counter ? item.day_counter : item.counter;
                    }
                });
            }

            this.chartsData = {
                xData: xData,
                countData: countData
            };
        },
        initChart: function initChart() {
            var chartsData = this.chartsData;
            var charts = void 0;

            var xAxisData = [];
            var data1 = [];

            for (var i = 0; i < 12; i++) {
                xAxisData.push(i);
                data1.push((Math.random() + 2) * 100);
            }
            var option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#283b56"
                        }
                    }
                },
                legend: {
                    data: ["进车数"],
                    align: "left",
                    bottom: 20
                },

                xAxis: {
                    show: true,

                    data: chartsData.xData,
                    silent: false,
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    show: "true",
                    type: "value",
                    name: "进车数",
                    max: this.hisData.timeType === "by_year" ? "800" : "50"
                },
                series: {
                    name: "进车数",
                    type: "bar",
                    data: chartsData.countData,
                    animationDelay: function animationDelay(idx) {
                        return idx * 10;
                    },
                    itemStyle: {
                        normal: {
                            color: "#ff8283"
                        },
                        emphasis: {
                            color: "#ff5653"
                        }
                    },
                    barCategoryGap: "40%"
                },
                animationEasing: "elasticOut",
                animationDelayUpdate: function animationDelayUpdate(idx) {
                    return idx * 5;
                }
            };
            if (this.$refs.charts) {
                charts = echarts.init(this.$refs.charts, charts, {
                    height: 400
                });
                charts.setOption(option);
            }

            this.charts = charts;
        },
        setScroll: function setScroll(type) {
            var hisTable = this.$refs.hisTable,
                scrollLeft = this.$refs.hisTable.scrollLeft;
            if (type === "right") {
                hisTable.scrollLeft = scrollLeft + 80;
            } else {
                hisTable.scrollLeft = scrollLeft - 80;
            }
        }
    }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'dashboard',
    components: {
        pageHead: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_MpageHead_vue___default.a,
        pageFooter: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue___default.a,
        pageSide: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_MpageSide_vue___default.a
    },
    data: function data() {
        return {
            showMe: true
        };
    },

    computed: {
        isLoading: function isLoading() {
            return this.$store.state.isLoading;
        },
        isOpen: function isOpen() {
            return this.$store.state.siderbarOpen;
        }
    },
    created: function created() {
        var userInfo = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("userInfo");
        var deviceInfo = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("deviceInfo");
        var deviceListType = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("deviceListType");

        if (userInfo) {
            this.$store.dispatch("setUserInfo", userInfo);
        }
        if (deviceInfo) {
            this.$store.dispatch("setDeviceInfo", deviceInfo);
        }
        if (deviceListType) {
            this.$store.dispatch("setDeviceListType", deviceListType);
        }
    },
    mounted: function mounted() {},


    methods: {
        clickMobileMask: function clickMobileMask() {
            this.$store.dispatch('toggleSide');
        }
    }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_datePick__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_datePick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_datePick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tempControl_dropTimePicker__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tempControl_dropTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_tempControl_dropTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_tempControl_Mconfirm__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_tempControl_Mconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_tempControl_Mconfirm__);








var echarts = __webpack_require__(42);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "timeCharts",
  components: {
    ElButton: __WEBPACK_IMPORTED_MODULE_4__node_modules_element_ui_packages_button_src_button_vue___default.a,
    pageHeader: __WEBPACK_IMPORTED_MODULE_7__components_tempControl_header___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_8__components_common_datePick___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_10__components_common_loading___default.a,
    dropTimePicker: __WEBPACK_IMPORTED_MODULE_11__components_tempControl_dropTimePicker___default.a,
    Mconfirm: __WEBPACK_IMPORTED_MODULE_13__components_tempControl_Mconfirm___default.a
  },
  data: function data() {
    return {
      img_no_data: __WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg___default.a,

      option: {
        sys_alias: 1,
        chartsType: "shaojie",
        date: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY-MM-DD 00:00:ss"),
        selectedDate: __WEBPACK_IMPORTED_MODULE_5_moment___default()().format("YYYY-MM-DD HH:mm:ss"),
        brickList: ""
      },

      loading: {
        realData: true,
        hisData: true,
        standConf: false
      },

      sys_alias: [],

      chartsType: [{
        val: "shaojie",
        label: "烧结"
      }, {
        val: "honggan",
        label: "烘干"
      }],
      echartError: false,
      max_pt: -1,
      max_dry: -1,

      realData: {},

      tableData: "",
      tableTypeName: {
        shaojie: "烧结(℃)",
        cewen: "测温(℃)",
        honggan: "烘干(℃)",
        other: "其他",
        yali: "压力(Pa)",
        fengji: "风机(Hz)"
      },

      hisData: [],
      hisListData: [],
      oneDayData: [],
      timeLineData: {
        options: [],
        timeList: [],
        index: 0,
        show: false
      },

      stand: {
        type: 0,
        data: {},
        list: [],
        conf: "",
        edit: false
      },

      charts: {
        shaojie: "",
        honggan: ""
      },
      chartsData: {
        realData: [],
        standData: [],
        xAxis: []
      },

      hisTable: {
        show: false,
        data: []
      },

      id_of_setinterval: "",

      isNotHisData: false,

      fengji: {
        show: false,
        payload: {
          flag: false,
          fjNo: 0,
          fjPl: 0,
          devNo: 0
        },
        select: {}
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    siderbarOpen: function siderbarOpen(state) {
      return state.siderbarOpen;
    },

    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    },
    config: function config(state) {
      return state.config;
    }
  })),
  created: function created() {
    this.creatAliasMeun(this.deviceInfo.alias_m);
  },
  mounted: function mounted() {
    this.loadBrick();
    this.loadDeviceList();

    __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].M.selectInputFoc();
    window.onorientationchange = this.orientationChange;
  },
  beforeDestroy: function beforeDestroy() {
    this.timingLoadRealData("close");
    window.onorientationchange = "";

    this.echarts = "";
  },

  methods: {
    openPlayer: function openPlayer() {
      this.$store.dispatch("setPlayerData", this.hisData);
      this.$router.push("/chartsPlayer");
    },
    orientationChange: function orientationChange() {
      var _this = this;

      switch (window.orientation) {
        case 0:
        case 90:
        case -90:
          setTimeout(function () {
            if (_this.charts.shaojie && _this.charts.honggan) {
              _this.charts.shaojie.resize();
              _this.charts.honggan.resize();
            }
          }, 400);
          break;
        case 180:
          break;
      }
    },
    creatAliasMeun: function creatAliasMeun(MaxAlias) {
      for (var i = 0; i < MaxAlias; i++) {
        this.sys_alias.push({
          val: i + 1,
          label: i + 1 + "\u53F7\u7A91"
        });
      }
    },
    loadDeviceList: function loadDeviceList() {
      var _this2 = this;

      var params = {
        device_id: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.loadDevice(params, function (data) {
        if (data.status_code !== "SUCCEEDED") {
          _this2.$message.error(data.msg);
        } else {
          var device = data.payload;
          device.device_id = device.device_id.$oid;
          _this2.$store.dispatch("setDeviceInfo", device);
        }
      });
    },
    initChart: function initChart(type, standData, realData, xAxisData) {
      var option = {
        baseOption: {
          title: {
            show: true,
            text: type === "shaojie" ? "烧结" : "烘干",
            top: 0,
            right: 0
          },
          grid: {
            show: false,
            top: 20,
            left: 30,
            right: 0,
            bottom: 35
          },

          tooltip: {
            trigger: "axis",

            formatter: function formatter(params, ticket, callback) {
              var res = void 0,
                  th = "车位";
              res = "" + params[0].axisValue + th + "</br>";
              for (var i = 0; i < params.length; i++) {
                res += params[i].seriesName + ":" + params[i].value + "</br>";
              }
              return res;
            }
          },
          legend: {
            show: true,
            data: [{ name: "标准温度", icon: "rect" }, { name: "实时温度", icon: "rect" }],
            bottom: 0,
            itemHeight: 8,
            itemWidth: 16
          },
          xAxis: {
            show: true,
            data: xAxisData,
            axisPointer: {
              show: true
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
              interval: function interval(_interval, val) {
                return true;
              }
            },

            axisLabel: {
              show: true,
              rotate: 45,
              interval: function interval(index, val) {
                return val != "0" && val !== "-" ? true : false;
              },
              formatter: function formatter(value, i) {
                return value;
              },

              textStyle: {
                fontSize: 8
              }
            }
          },
          yAxis: {
            show: true,
            axisLine: { show: false },
            splitLine: {
              show: true
            },
            splitNumber: type === "shaojie" ? 6 : 4,
            max: type === "shaojie" ? 1200 : 200,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: "{value}℃",
              inside: true,
              margin: -30
            }
          },
          series: [{
            name: "标准温度",
            type: "line",
            data: standData,
            symbolSize: 8,

            itemStyle: {
              normal: {
                color: "#2378DC"
              }
            },
            connectNulls: true,
            lineStyle: {
              normal: {
                width: "2"
              }
            }
          }, {
            name: "实时温度",
            type: "line",
            data: realData,
            symbolSize: 8,
            connectNulls: true,
            itemStyle: {
              normal: {
                color: "#E65D20"
              }
            },
            lineStyle: {
              normal: {
                width: "2"
              }
            }
          }]
        }
      };

      if (this.charts[type]) {
        this.charts[type].setOption(option);
      } else {
        var charts = echarts.init(this.$refs[type], charts, {
          height: type === "shaojie" ? 300 : 125
        });
        charts.setOption(option);
        this.charts[type] = charts;
      }
    },
    loadBrick: function loadBrick(is_cache) {
      var _this3 = this;

      var params = {
        conf_type: "brick",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache ? is_cache : true
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.loadDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this3.stand.type = data.payload.name > 30 ? 0 : data.payload.name;
          try {
            if (data.payload.list) {
              _this3.stand.list = JSON.parse(data.payload.list);
            } else {
              _this3.stand.list = [];
            }
          } catch (error) {
            console.error({
              msg: "获取砖类型列表失败",
              data: data
            });
          }
          _this3.loadStandConf(true);
          _this3.timingLoadRealData("open");
        } else {
          _this3.loading.hisData = false;
          _this3.loading.realData = false;

          _this3.$notify({
            title: "初始化通信中",
            message: "正在获取设备数据，请稍等",
            type: "warning"
          });
          console.error({
            msg: "获取当前砖类型失败",
            data: data
          });
          _this3.loadRealDataFn("show");
        }
      });
    },
    loadStandConf: function loadStandConf(is_cache) {
      var _this4 = this;

      var params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache,
        name: this.stand.type ? this.stand.type : 30,
        payload: {
          devNo: 1,
          type: this.stand.type ? this.stand.type : 30
        }
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.loadDeviceConf(params, function (data) {
        _this4.loadHisData("created");
        if (data.status_code === "SUCCEEDED") {} else {
          _this4.$message({
            message: "标准参数获取失败：" + data.msg,
            type: "warning",
            duration: 5000
          });
        }
        if (data.payload && data.payload.data) {
          _this4.stand.conf = JSON.parse(data.payload.data);
          _this4.stand.data = _this4.dealApiData(data.payload.data);
          _this4.$store.dispatch("setStandData", _this4.stand.data);
        } else {
          if (is_cache) {
            _this4.loadStandConf(false);
          }
          console.error({
            msg: "获取标准参数数据失败",
            data: data
          });
        }
      });
    },
    dealTableKeyName: function dealTableKeyName(key) {
      var res = key.replace(/[(烘干||烧结)℃||Hz]/g, "");
      return res;
    },
    dealApiData: function dealApiData(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      var shaojie = [],
          honggan = [],
          cewen = [],
          fengji = [],
          yali = [],
          other = [];
      var item = void 0,
          th = void 0;
      var jsonData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.ki, data.ao, data.pi, data.ci);
      var nameRegExp = {
        shaojie: /烧结|顶中|顶外|顶内|内侧|外侧|内|外|中/
      };
      for (item in jsonData) {
        if (item) {
          var pushJson = {
            th: item,
            data: jsonData[item],
            key: item,
            id: __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].M.guid()
          };
          if (nameRegExp.shaojie.test(item)) {
            pushJson.th = item.replace(/[^0-9]/g, "");
            shaojie.push(pushJson);
          } else if (item.search("烘干") !== -1) {
            pushJson.th = item.split("车位烘干")[0];
            honggan.push(pushJson);
          } else if (item.search("测温") !== -1) {
            cewen.push(pushJson);
          } else if (item.search("风机") !== -1) {
            fengji.push(pushJson);
          } else if (item.search("压力") !== -1) {
            yali.push(pushJson);
          } else {
            cewen.push(pushJson);
          }
        }
      }

      function thSort(a, b) {
        if (a.th * 1 > b.th * 1) {
          return 1;
        } else {
          return -1;
        }
      }

      shaojie.sort(thSort);
      honggan.sort(thSort);
      return {
        shaojie: shaojie,
        honggan: honggan,
        cewen: cewen,
        fengji: fengji,
        yali: yali,
        other: other
      };
    },
    changeDate: function changeDate(selectTime) {
      var date = this.option.selectedDate,
          oneDay = this.oneDayData,
          time = selectTime.day + " " + selectTime.hour + ":00";
      if (selectTime.day !== __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("YYYY-MM-DD")) {
        this.option.date = time;
        this.option.selectedDate = time;
        this.loadHisData("created");
      }
    },
    dealChartsData: function dealChartsData() {
      var _this5 = this;

      var tableData = this.tableData,
          stand = this.stand.data;
      if (tableData) {
        var repeatData = function repeatData(data) {
          if (!data || !data.length) {
            return [];
          }
          var json = {},
              item = void 0,
              jsonItem = void 0;
          for (var i = 0; i < data.length; i++) {
            item = data[i];
            jsonItem = json[item.th];
            if (jsonItem) {
              jsonItem.data = __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].M.getMax(jsonItem.data, item.data);
              jsonItem.count = 1;
            } else {
              jsonItem = {};
              jsonItem.th = item.th;
              jsonItem.key = item.key;
              jsonItem.data = item.data;
              jsonItem.count = 1;
            }
            json[item.th] = jsonItem;
          }
          var arr = [],
              arrItem = void 0;
          for (var x in json) {
            arrItem = json[x];
            arrItem.data = Math.floor(arrItem.data / arrItem.count);
            arr.push(arrItem);
          }
          return arr;
        };

        var dataForEach = function dataForEach(data, type) {
          data = repeatData(data);
          var result = [],
              xData = [],
              DataLength = void 0;
          if (data && data.length) {
            DataLength = data[data.length - 1].th * 1 + 2;
            var maxPos = DataLength;
            if (type === "shaojie") {
              maxPos = that.max_pt;
            } else {
              maxPos = that.max_dry;
            }
            if (maxPos > DataLength) {
              DataLength = maxPos;
            }
            for (var i = 0; i <= DataLength; i++) {
              if (i === 0) {
                xData[i] = "0";
                result[i] = "30";
              } else if (i === DataLength - 1) {
                xData[i] = i + 1;
                result[i] = "30";
              } else {
                xData[i] = "-";
                result[i] = "-";
              }
            }
            data.forEach(function (item, n) {
              xData[item.th] = item.th;
              result[item.th] = item.data;
            }, this);
          } else {
            xData = [];
            result = [];
          }
          return { xData: xData, result: result };
        };

        var realData = [],
            xData = [],
            StandData = void 0,
            reH = void 0,
            reS = void 0,
            standH = void 0,
            standS = void 0,
            splitIndex = void 0,
            that = this;

        reH = dataForEach(tableData["honggan"], "honggan");
        reS = dataForEach(tableData["shaojie"], "shaojie");
        standH = dataForEach(stand["honggan"], "honggan");
        standS = dataForEach(stand["shaojie"], "shaojie");

        this.$nextTick(function () {
          if (_this5.$refs.shaojie && _this5.$refs.honggan) {
            _this5.initChart("honggan", standH.result, reH.result, reH.xData);
            _this5.initChart("shaojie", standS.result, reS.result, reS.xData);
          }
        });
      }
    },
    dealHisFn: function dealHisFn(data) {
      var hisData = [];
      if (!data) {
        return false;
      }
      if (data.length > 0) {
        var item = void 0,
            r = void 0;
        for (var i = 0; i < data.length; i++) {
          item = data[i];
          try {
            r = this.dealApiData(item.data);
            r.time_stamp = item.time_stamp;
            hisData.push(r);
          } catch (error) {
            console.error("历史数据处理err:" + error);
            console.error(item);
          }
        }
      }
      return hisData;
    },
    selectHisData: function selectHisData(data, listData) {
      this.tableData = data;
      this.hisListData = listData;

      this.dealChartsData();
    },
    selectButtonChartsFn: function selectButtonChartsFn(type, hourIndex, itemIndex) {
      var _this6 = this;

      var index = this.timeLineData.index,
          dateFormat = "YYYY-MM-DD HH:00:SS",
          date = this.option.selectedDate,
          oneDay = this.oneDayData,
          data = oneDay[hourIndex];

      if (data) {
        this.hisData = data;
        this.realData = data[0];
        this.tableData = data[0];
        this.dealChartsData();
      } else {
        this.hisData = [];
      }
      if (type === "PRE") {
        this.option.selectedDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).subtract(1, "hour").format(dateFormat);
      } else if (type === "NEXT") {
        this.option.selectedDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).add(1, "hour").format(dateFormat);
      }

      this.$nextTick(function () {
        if (itemIndex > _this6.hisData.length - 1) {
          itemIndex = _this6.hisData.length - 1;
        }
        _this6.selectHisData(itemIndex);
      });
    },
    openTimePicker: function openTimePicker() {
      var _this7 = this;

      var show = this.timeLineData.show;
      this.timeLineData.show = !show;
      this.$nextTick(function () {
        if (_this7.timeLineData.show) {
          _this7.loadHisData("created");
        } else {
          _this7.tableData = _this7.realData;
        }
      });
    },
    loadHisDataP: function loadHisDataP(order, page_size) {
      var _this8 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var params = {
          device_id: _this8.deviceInfo.device_id,
          data_type: "hisData",
          sys_alias: _this8.option.sys_alias,
          page_size: page_size ? page_size : 300,
          order: order ? order : "asc"
        };
        if (_this8.option.date) {
          params.begin = __WEBPACK_IMPORTED_MODULE_5_moment___default()(_this8.option.date).format("YYYY-MM-DD 00:00:00");
          params.end = __WEBPACK_IMPORTED_MODULE_5_moment___default()(_this8.option.date).add(1, "day").format("YYYY-MM-DD 00:00:00");
        }
        if (_this8.userInfo.identity === "USER") {
          params.auth_token = _this8.userInfo.token;
        } else {
          params.customer_token = _this8.userInfo.token;
        }
        __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.loadDeviceData(params, function (data) {
          if (data.status_code === "SUCCEEDED") {
            if (data.payload && data.payload.length > 0) {
              resolve(data);
            } else {
              reject({
                msg: "历史数据接口无数据",
                data: data
              });
            }
          } else {
            console.error("历史数据接口：" + data.msg);
            reject({
              msg: "历史数据接口",
              data: data.msg
            });
          }
        });
      });
    },
    loadHisData: function loadHisData(type) {
      var _this9 = this;

      if (type === "created") {
        if (!this.hisData.length) {
          this.loading.realData = true;
        }
        this.loading.hisData = true;
      }
      this.$nextTick(function () {
        _this9.loadHisDataP().then(function (data) {
          _this9.loading.hisData = false;
          _this9.loading.realData = false;
          if (type === "created") {
            _this9.hisData = _this9.dealHisFn(data.payload);
            _this9.tableData = _this9.hisData[_this9.hisData.length - 1];
            _this9.dealChartsData();
          }
        }).catch(function (reason) {
          _this9.oneDayData = {};
          _this9.hisData = [];

          _this9.loadHisDataP("", 1).then(function (data) {
            _this9.loading.hisData = false;
            _this9.loading.realData = false;
            var dataList = _this9.dealHisFn(data.payload);
            _this9.tableData = dataList[0];
          }).catch(function (data) {
            _this9.loading.hisData = false;
            _this9.$message.info("当天无温度数据");
            _this9.$nextTick(function () {
              _this9.loadRealDataFn("REVIEW");
            });
          });
        });
      });
    },
    loadRealDataFn: function loadRealDataFn(type) {
      if (type === "show") {
        this.timeLineData.show = false;
        this.loading.realData = true;
      }

      if (type === "REVIEW") {
        type = "show";
      }
      this.loadRealDataP(type);
    },
    loadRealDataP: function loadRealDataP(type) {
      var _this10 = this;

      var params = {
        device_id: this.deviceInfo.device_id,
        data_type: "realData",
        sys_alias: this.option.sys_alias
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.loadDeviceData(params, function (data) {
        if (data.status_code === "FAILED") {
          _this10.$message({
            message: data.msg,
            type: "warning",
            duration: 5000
          });
        }
        if (data.payload && data.payload.data) {
          _this10.max_pt = data.payload.max_pt;
          _this10.max_dry = data.payload.max_dry;
          _this10.realData = _this10.dealApiData(data.payload.data);
          _this10.realData.time_stamp = data.payload.time_stamp;
          if (type === "show") {
            _this10.charts = { shaojie: "", honggan: "" };
            _this10.tableData = _this10.realData;
            _this10.loading.realData = false;

            _this10.$nextTick(function () {
              _this10.dealChartsData();
            });
          }
        } else {}
      });
    },
    timingLoadRealData: function timingLoadRealData(type) {
      var _this11 = this;

      if (type === "open") {
        this.loadRealDataP();
        this.id_of_setinterval = setInterval(function () {
          _this11.loadRealDataP();

          if (!_this11.timeLineData.show) {
            _this11.tableData = _this11.realData;
            _this11.dealChartsData();
          }
        }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
      } else {
        clearInterval(this.id_of_setinterval);
      }
    },
    setStandConf: function setStandConf() {
      var _this12 = this;

      this.loading.standConf = true;
      var params = void 0,
          payload = void 0,
          oldConf = void 0,
          dealPayload = void 0;
      oldConf = this.stand.conf;

      dealPayload = function dealPayload(data) {
        var item = void 0,
            jsonData = void 0,
            editValue = void 0;

        editValue = function editValue(goal, value) {
          var key = void 0,
              subKey = void 0;
          for (key in oldConf) {
            for (subKey in oldConf[key]) {
              if (goal === subKey) {
                if (oldConf[key][subKey] == value) {
                  return "normal";
                } else {
                  oldConf[key][subKey] = value * 1;
                  return "update";
                }
              }
            }
          }
        };
        jsonData = data.fengji.concat(data.fengji, data.honggan, data.cewen, data.shaojie, data.yali, data.other);
        for (item in jsonData) {
          var result = editValue(jsonData[item].key, jsonData[item].data);
          if (result === "update") {
            console.log("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u6210\u529F");
          } else if (result === "normal") {
            console.log("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u672A\u6539\u53D8");
          } else {
            console.error("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u5931\u8D25");
          }
        }
        return oldConf;
      };

      payload = dealPayload(this.stand.data);
      payload.devNo = this.option.sys_alias * 1;
      params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias.toString(),
        device_id: this.deviceInfo.device_id,
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.setDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this12.$message.success("修改成功");
          _this12.loadStandConf(false);
          _this12.stand.edit = false;
        } else {
          _this12.$message.error("修改失败," + data.msg);
        }

        _this12.loading.standConf = false;
      });
    },
    editStandInput: function editStandInput() {
      this.dealChartsData();
    },
    openStandEdit: function openStandEdit() {
      var _this13 = this;

      var stand = this.stand,
          takeStandbyReal = void 0;

      takeStandbyReal = function takeStandbyReal() {
        var realData = void 0,
            hisData = void 0,
            standConf = void 0,
            key = void 0;
        hisData = _this13.hisData;
        realData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this13.tableData));
        if (_this13.timeLineData.show) {
          hisData = _this13.hisListData;
        } else {
          hisData = hisData.slice(-10);
        }

        hisData.forEach(function (item, itemIndex) {
          for (key in item) {
            for (var i = 0; i < item[key].length; i++) {
              if (key !== "time_stamp") {
                realData[key][i].data = realData[key][i].data + item[key][i].data;
                if (itemIndex === hisData.length - 1) {
                  realData[key][i].data = Math.floor(realData[key][i].data / (hisData.length + 1));
                }
              }
            }
          }
        });
        standConf = realData;
        return standConf;
      };
      if (stand.edit) {
        this.stand.data = this.dealApiData(this.stand.conf);
      } else {
        location.hash = "#tablelist";
        this.stand.data = takeStandbyReal();
      }
      this.$nextTick(function () {
        _this13.dealChartsData();
      });

      this.stand.edit = !stand.edit;
    },
    openFengjiEdit: function openFengjiEdit() {
      this.fengji.show = true;
      var payload = this.fengji.payload;
      payload.devNo = this.option.sys_alias;
    },
    selectFenji: function selectFenji(e) {
      var f = this.fengji.select = this.realData.fengji[this.fengji.selected];
      this.fengji.payload.fjPl = f.data * 1;
      this.fengji.payload.fjNo = f.key.split("@")[1] * 1;
    },
    saveFenji: function saveFenji() {
      var _this14 = this;

      var url = "devices/" + this.deviceInfo.device_sn + "/frequency",
          params = {
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.fengji.payload),
        device_sn: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_9__lib_lib__["a" /* default */].api.setFrequency(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this14.$message.success("操作成功");
          _this14.fengji.show = false;
          _this14.loadRealDataFn("show");
          _this14.realData.fengji[_this14.fengji.selected].data = _this14.fengji.payload.fjPl;
          _this14.tableData.fengji[_this14.fengji.selected].data = _this14.fengji.payload.fjPl;
        } else {
          _this14.$message.error("操作失败");
        }
      });
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_Mconfirm__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_Mconfirm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tempControl_Mconfirm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_common_loading_vue__);







var echarts = __webpack_require__(42);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: "standardSet",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_7__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_8__components_common_loading_vue___default.a,
        Mconfirm: __WEBPACK_IMPORTED_MODULE_6__components_tempControl_Mconfirm___default.a
    },
    data: function data() {
        return {
            img_no_data: __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default.a,
            sys_alias: [],
            option: {
                aliasNo: "1",
                selectType: "shaojie",
                time_stamp: ""
            },

            chartsType: [{
                val: "shaojie",
                label: "烧结"
            }, {
                val: "honggan",
                label: "烘干"
            }],
            loading: {
                standard: true,
                echarts: true
            },
            max_pt: -1,
            max_dry: -1,
            standConf: {},
            confTypeName: {
                shaojie: "烧结",
                cewen: "测温",
                honggan: "烘干",
                other: "其他",
                yali: "压力",
                fengji: "风机"
            },
            oldConf: "",
            isEdit: false,
            charts: "",

            hisData: [],
            realData: {},

            chartsData: {},

            stand: {
                list: [],
                type: "",
                edit: {
                    name: "",
                    id: ""
                }
            },

            dialog: {
                standType: false
            }
        };
    },

    watch: {
        "option.selectType": function optionSelectType() {
            this.changeSelectType();
        }
    },
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
    },
    mounted: function mounted() {
        this.loadBrick();
        __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].M.selectInputFoc();
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        siderbarOpen: function siderbarOpen(state) {
            return state.siderbarOpen;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        }
    })),
    methods: {
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: "" + (i + 1),
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        loadBrick: function loadBrick() {
            var _this2 = this;

            var params = {
                conf_type: "brick",
                sys_alias: this.option.aliasNo,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this2.stand.type = data.payload.name;
                    try {
                        _this2.stand.list = JSON.parse(data.payload.list);
                        _this2.stand.type = data.payload.name;
                    } catch (error) {
                        console.error({
                            error: error,
                            msg: "解析砖类型列表失败",
                            data: data
                        });
                    }
                }
                _this2.loadHisData();
            });
        },
        loadStandConf: function loadStandConf(is_cache) {
            var _this3 = this;

            this.loading.standard = true;
            var params = {
                conf_type: "standard",
                sys_alias: this.option.aliasNo,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache,
                name: this.stand.type ? this.stand.type : 30,
                payload: {
                    devNo: this.option.aliasNo * 1,
                    type: this.stand.type ? this.stand.type : 30
                }
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {} else {
                    _this3.isEdit = false;
                    _this3.$message({
                        message: "网络连接超时：" + data.msg,
                        type: "warning"
                    });
                }
                if (data.payload && data.payload.data) {
                    var s = JSON.parse(data.payload.data);
                    delete s.oother;
                    delete s.msg;
                    _this3.oldConf = s;
                    _this3.standConf = _this3.dealApiData(s);
                    _this3.option.time_stamp = data.payload.time_stamp;
                    _this3.$nextTick(function () {
                        _this3.dealChartsData("shaojie");
                    });
                }
                _this3.loading.echarts = false;
                _this3.loading.standard = false;
            });
        },
        loadHisData: function loadHisData() {
            var _this4 = this;

            var params = {
                device_id: this.deviceInfo.device_id,
                data_type: "realData",
                sys_alias: this.option.aliasNo,
                page_size: 5,
                page_no: 1
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.loadDeviceData(params, function (data) {
                _this4.loadStandConf(true);

                if (data.status_code === "SUCCEEDED") {
                    _this4.max_pt = data.payload.max_pt;
                    _this4.max_dry = data.payload.max_dry;
                    _this4.realData = _this4.dealApiData(JSON.parse(data.payload.data));
                } else {
                    console.error("历史数据接口：" + data.msg);
                }
            });
        },
        dealHisFn: function dealHisFn(data) {
            var hisData = [];
            if (data.length > 0) {
                var item = void 0;
                for (var i = 0; i < data.length; i++) {
                    item = data[i];
                    try {
                        var r = this.dealApiData(JSON.parse(item.data));
                        r.time_stamp = item.time_stamp;
                        hisData.push(r);
                    } catch (error) {
                        console.error("历史数据处理err:" + error);
                        console.error(item);
                    }
                }
            }
            return hisData;
        },
        dealApiData: function dealApiData(data) {
            var shaojie = [],
                honggan = [],
                cewen = [],
                fengji = [],
                yali = [],
                other = [];
            var item = void 0,
                th = void 0;
            var jsonData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data.ki, data.ao, data.pi, data.ci);
            var nameRegExp = {
                shaojie: /烧结|顶中|顶外|顶内|内侧|外侧|内|外|中/
            };
            for (item in jsonData) {
                var pushJson = {
                    th: item,
                    data: jsonData[item],
                    key: item
                };
                if (nameRegExp.shaojie.test(item)) {
                    pushJson.th = item.replace(/[^0-9]/g, "");
                    pushJson.thName = item;
                    shaojie.push(pushJson);
                } else if (item.search("烘干") !== -1) {
                    pushJson.th = item.split("车位烘干")[0];
                    honggan.push(pushJson);
                } else if (item.search("测温") !== -1) {
                    cewen.push(pushJson);
                } else if (item.search("风机") !== -1) {
                    fengji.push(pushJson);
                } else if (item.search("压力") !== -1) {
                    yali.push(pushJson);
                } else {
                    other.push(pushJson);
                }
            }

            function thSort(a, b) {
                if (a.th * 1 > b.th * 1) {
                    return 1;
                } else {
                    return -1;
                }
            }

            shaojie.sort(thSort);
            honggan.sort(thSort);
            return {
                shaojie: shaojie,
                honggan: honggan,
                cewen: cewen,
                fengji: fengji,
                yali: yali,
                other: other
            };
        },
        openEdit: function openEdit() {
            if (this.isEdit) {
                this.saveStandConf(false);
            } else {
                if (this.userInfo.role === "manager" || this.userInfo.role) {
                    this.isEdit = true;
                    this.loadStandConf(false);
                } else {
                    this.$message.error("权限不足，修改失败");
                }
            }
        },
        closeEdit: function closeEdit() {
            this.isEdit = false;
        },
        delSaveData: function delSaveData(data) {
            var _this = this,
                oldConf = _this.oldConf;

            function checkValue(type, value) {
                value = Math.floor(value);

                return value;
            }

            function editValue(goal, value) {
                var key = void 0,
                    subKey = void 0;
                for (key in oldConf) {
                    for (subKey in oldConf[key]) {
                        if (goal === subKey) {
                            if (oldConf[key][subKey] == value) {
                                return "normal";
                            } else {
                                oldConf[key][subKey] = checkValue(key, value);
                                return "update";
                            }
                        }
                    }
                }
            }

            var item = void 0;
            var jsonData = data.fengji.concat(data.fengji, data.honggan, data.cewen, data.shaojie, data.yali, data.other);
            for (item in jsonData) {
                var result = editValue(jsonData[item].key, jsonData[item].data);
                if (result === "update") {
                    console.log("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u6210\u529F");
                } else if (result === "normal") {} else {
                    console.error("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u5931\u8D25");
                }
            }
            return oldConf;
        },
        saveStandConf: function saveStandConf(is_change) {
            var _this5 = this;

            var payload = this.delSaveData(this.standConf);
            this.loading.standard = true;
            payload.devNo = this.option.aliasNo * 1;
            var params = {
                conf_type: "standard",
                sys_alias: this.option.aliasNo,
                device_id: this.deviceInfo.device_id,
                is_change: is_change.toString(),
                payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this5.$message.success("修改成功");
                    _this5.isEdit = false;
                    _this5.loadStandConf(false);
                } else {
                    _this5.$message.error("修改失败," + data.msg);
                    _this5.loading.standard = false;
                }
            });
        },
        setStandByrealData: function setStandByrealData() {
            this.standConf = this.realData;
            this.saveStandConf();
        },
        changeSelectType: function changeSelectType() {
            var type = this.option.selectType;
            this.dealChartsData(type);
        },
        dealChartsData: function dealChartsData(type) {
            var _this7 = this;

            var real = this.realData,
                stand = this.standConf;
            var that = this;

            function repeatData(data) {
                if (!data.length) {
                    return data;
                }
                var json = {},
                    item = void 0,
                    jsonItem = void 0;
                for (var i = 0; i < data.length; i++) {
                    item = data[i];
                    jsonItem = json[item.th];
                    if (jsonItem) {
                        jsonItem.data = __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].M.getMax(jsonItem.data, item.data);
                        jsonItem.count = 1;
                    } else {
                        jsonItem = {};
                        jsonItem.th = item.th;
                        jsonItem.key = item.key;
                        jsonItem.data = item.data;
                        jsonItem.count = 1;
                    }
                    json[item.th] = jsonItem;
                }
                var arr = [],
                    arrItem = void 0;
                for (var x in json) {
                    arrItem = json[x];
                    arrItem.data = Math.floor(arrItem.data / arrItem.count);
                    arr.push(arrItem);
                }
                return arr;
            }

            function dataForEach(data) {
                var _this6 = this;

                data = repeatData(data);
                var result = [],
                    xData = [],
                    DataLength = void 0;

                DataLength = data[data.length - 1].th * 1 + 2;
                var maxPos = DataLength;
                if (type === "shaojie") {
                    maxPos = that.max_pt;
                } else {
                    maxPos = that.max_dry;
                }
                if (maxPos > DataLength) {
                    DataLength = maxPos;
                }

                var _loop = function _loop(i) {
                    if (i === 0) {
                        xData[i] = "0";
                        result[i] = "30";
                    } else if (i === DataLength - 1) {
                        xData[i] = i + 1;
                        result[i] = "30";
                    } else {
                        xData[i] = "-";
                        result[i] = "-";
                    }
                    data.forEach(function (item, n) {
                        if (i == item.th) {
                            xData[i] = item.key;
                            result[i] = item.data;
                        }
                    }, _this6);
                };

                for (var i = 0; i <= DataLength; i++) {
                    _loop(i);
                }

                return { xData: xData, result: result };
            }
            try {
                this.chartsData.xAxisData = dataForEach(real[type]).xData;
                this.chartsData.realData = dataForEach(real[type]).result;
            } catch (error) {
                console.error({
                    error: error,
                    data: { real: real, stand: stand },
                    msg: "标准参数echats图表数据解析失败"
                });
            }
            try {
                this.chartsData.standData = dataForEach(stand[type]).result;
            } catch (error) {
                console.error({
                    error: error,
                    data: { real: real, stand: stand },
                    msg: "标准参数echats图表数据解析失败"
                });
            }

            this.$nextTick(function () {
                _this7.initChart(_this7.chartsData);
            });
        },
        initChart: function initChart(data) {
            var charts = void 0;
            if (this.$refs.charts) {
                charts = echarts.init(this.$refs.charts, charts, {
                    height: 300
                });
            } else {
                return false;
            }

            var option = {
                baseOption: {
                    tooltip: {
                        show: true,
                        trigger: "axis"
                    },
                    legend: {
                        data: ["标准温度", "实时温度"],
                        bottom: 0
                    },
                    xAxis: {
                        show: false,
                        data: data.xAxisData,
                        axisLabel: {
                            show: true,
                            interval: function interval(index, value) {
                                if (value == "NONE") {
                                    return false;
                                } else {
                                    return true;
                                }
                            }
                        }
                    },
                    yAxis: {
                        axisLine: { show: false },
                        splitLine: {
                            show: true
                        },
                        axisTick: {
                            show: false
                        }
                    },
                    series: [{
                        name: "标准温度",
                        type: "line",
                        data: data.standData,
                        itemStyle: {
                            normal: {
                                color: "#76e191",
                                borderWidth: 2
                            }
                        },
                        smooth: "true",
                        connectNulls: true,
                        lineStyle: {
                            normal: {
                                width: "3"
                            }
                        }
                    }, {
                        name: "实时温度",
                        type: "line",
                        data: data.realData,
                        itemStyle: {
                            normal: {
                                color: "#eb5650"
                            }
                        },
                        smooth: "true",
                        connectNulls: true,
                        lineStyle: {
                            normal: {
                                width: "3"
                            }
                        }
                    }]
                }
            };
            charts.setOption(option);
            this.charts = charts;
        },
        changeStandType: function changeStandType() {
            this.loadStandConf(false);
        },
        openSetStandType: function openSetStandType() {
            this.dialog.standType = true;
        },
        saveStandType: function saveStandType() {
            var _this8 = this;

            var payload = {
                brick_list: this.stand.list
            };
            var params = {
                device_id: this.deviceInfo.device_id,
                sys_alias: this.option.aliasNo.toString(),
                conf_type: "brick",
                payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this8.$message.success("修改成功");
                    _this8.dialog.standType = false;
                    _this8.loadStandConf(false);
                } else {
                    _this8.$message.error("修改失败");
                }
                console.log(data);
            });
        }
    }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: "autoVal",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading___default.a
    },
    data: function data() {
        return {
            isEdit: false,
            option: {
                sys_alias: ""
            },
            test: "",
            loading: "",
            sys_alias: [],
            val: "",
            confData: [],
            options: [{
                label: "一号窑",
                val: 1
            }],
            tableData: [],
            timeShow: "",
            id_of_setinterval: ''
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
        this.option.sys_alias = "1";
    },
    mounted: function mounted() {
        for (var i = 0; i < 1; i++) {
            this.checkUpdata();
            __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].M.selectInputFoc();
        }
        this.timingLoad('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
        this.timingLoad('CLOSE');
    },

    methods: {
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: "" + (i + 1),
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        checkUpdata: function checkUpdata() {
            var isNew = void 0,
                date = void 0;
            this.changeOption(true);
        },
        changeOption: function changeOption(type) {
            this.loading = true;
            this.confData = [];
            this.loadControlConf(type);
        },
        timingLoad: function timingLoad(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadControlConf(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadControlConf: function loadControlConf(is_cache) {
            var _this2 = this;

            this.confData = [];
            this.loading = true;
            var params = {
                conf_type: "auto",
                sys_alias: this.option.sys_alias,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_1__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                _this2.loading = false;
                if (data.status_code === "SUCCEEDED") {} else {
                    _this2.$message({
                        message: "获取自控变量错误," + data.msg,
                        type: "warning"
                    });
                }
                _this2.timeShow = data.payload.time_stamp;
                if (data.payload && data.payload.data) {
                    var tableData = JSON.parse(data.payload.data);
                    if (tableData.oother) {
                        delete tableData.oother;
                        if (tableData.msg) {
                            delete tableData.msg;
                            delete tableData.isSuccess;
                        }
                    }
                    _this2.tableData = [];
                    for (var key in tableData) {
                        if (tableData.hasOwnProperty(key)) {
                            var element = tableData[key];
                            if (key !== "isSuccess" && key !== "msg") {
                                _this2.tableData.push({
                                    name: key,
                                    data: element
                                });
                            }
                        }
                    }
                } else if (is_cache) {
                    _this2.loadControlConf(false);
                }
            });
        }
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);









/* harmony default export */ __webpack_exports__["default"] = ({
    name: "controlSet",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_4__components_common_loading___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: "",
                isEdit: false,
                time_stamp: ""
            },
            test: "",
            loading: "",
            sys_alias: [],
            val: "",
            confData: [],
            floatDataIndexStart: 24,
            floatDataIndexEnd: 45,
            isRepeat: false,
            id_of_setinterval: ''
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }
    }),
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
        this.option.sys_alias = "1";
    },
    mounted: function mounted() {
        for (var i = 0; i < 1; i++) {
            this.changeOption(true);
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.selectInputFoc();
        }
        this.timingLoad('OPEN');
    },
    beforeDestroy: function beforeDestroy() {
        this.loading = false;
        this.timingLoad('CLOSE');
    },

    methods: {
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: "" + (i + 1),
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        changeOption: function changeOption(type) {
            this.loading = true;
            this.confData = [];
            var that = this;
            this.loadDeviceSettings(type, function (is_succ) {
                that.loadControlConf(type);
            });
        },
        timingLoad: function timingLoad(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadControlConf(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadDeviceSettings: function loadDeviceSettings(is_cache, callback) {
            var _this2 = this;

            this.loading = true;
            var params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;
                        console.log("device setting:", jsonData);
                        _this2.floatDataIndexStart = jsonData.zkcsUchar + jsonData.zkcsChar + jsonData.zkcsUint + jsonData.zkcsInt + jsonData.zkcsUlong + jsonData.zkcsLong;
                        _this2.floatDataIndexEnd = _this2.floatDataIndexStart + jsonData.zkcsFloat;
                    } catch (err) {
                        console.log(err);
                    }
                    if (callback) {
                        callback();
                    }
                } else {
                    if (!is_cache) {
                        _this2.loadDeviceSettings(true, callback);
                    } else {
                        if (callback) {
                            callback();
                        }
                    }
                }
            });
        },
        loadControlConf: function loadControlConf(is_cache) {
            var _this3 = this;

            var params = {
                conf_type: "control",
                sys_alias: this.option.sys_alias,
                device_id: this.deviceInfo.device_id,
                is_cache: is_cache
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
                _this3.loading = false;

                if (data.status_code === "SUCCEEDED") {} else {
                    _this3.$message({
                        message: "网络连接超时：" + data.msg,
                        type: "warning"
                    });
                    if (!_this3.isMobile) {
                        _this3.$notify.info({
                            title: "温馨提示",
                            message: "无法连接设备时，无法进行参数修改操作",
                            duration: 3000,
                            offset: 60
                        });
                    }
                    _this3.closeEdit();
                    if (!_this3.isRepeat) {
                        _this3.isRepeat = true;
                        _this3.loadControlConf(false);
                    }
                }
                if (data.payload && data.payload.data) {
                    _this3.confData = _this3.dealDateFn(data, "load");
                    _this3.option.time_stamp = data.payload.time_stamp;
                }
            });
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this4 = this;

            this.loading = true;
            var payload = this.dealDateFn(this.confData, "post");
            if (payload == false) {
                this.$message.error("参数错误");
                return false;
            } else {
                payload.devNo = this.option.sys_alias * 1;
                payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload);
            }
            var params = {
                conf_type: "control",
                sys_alias: this.option.sys_alias.toString(),
                device_id: this.deviceInfo.device_id,
                payload: payload
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            console.log(params);
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
                if (data.status_code === "SUCCEEDED") {
                    _this4.$message.success("修改成功");
                    _this4.loadControlConf(false);
                    _this4.closeEdit();
                } else {
                    _this4.$message.error("\u4FEE\u6539\u5931\u8D25\uFF1A" + data.msg);
                    _this4.loading = false;
                }
            });
        },
        dealDateFn: function dealDateFn(data, type) {
            var confData = void 0;
            if (type === "load") {
                var jsonData = JSON.parse(data.payload.data);
                confData = [];
                if (jsonData.oother) {
                    delete jsonData.oother;
                    if (jsonData.msg) {
                        delete jsonData.msg;
                        delete jsonData.isSuccess;
                    }
                }
                this.test = jsonData;
                var jsonDataIndex = 0;
                for (var key in jsonData) {
                    if (jsonData.hasOwnProperty(key)) {
                        var item = jsonData[key],
                            precision = 0,
                            step = 1,
                            max = void 0,
                            min = void 0;
                        precision = __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.getPrecision(item);
                        if (jsonDataIndex < 11) {
                            max = 255;
                            min = 0;
                        } else if (jsonDataIndex < this.floatDataIndexStart) {
                            max = 65565;
                            min = 0;
                        } else if (jsonDataIndex < this.floatDataIndexEnd) {
                            max = 35575;
                            min = -35575;

                            if (precision <= 0) {
                                precision = 1;
                                item = item.toFixed(precision);
                                console.log(item, precision);
                            }
                        }

                        step = Math.pow(0.1, precision);
                        confData.push({
                            name: key,
                            data: item,
                            prec: precision,
                            step: step,
                            max: max,
                            min: min
                        });
                    }
                    jsonDataIndex++;
                }
            } else {
                confData = {};
                for (var i = 0; i < data.length; i++) {
                    var _item = data[i];
                    if (data[i].data === "") {
                        return false;
                    }
                    confData[_item.name] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.round(_item.data, 2);
                    if (i < this.floatDataIndexStart) {
                        confData[_item.name] = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.round(_item.data);
                    }
                }
            }
            console.log(confData);
            return confData;
        },
        checkInputNumber: function checkInputNumber(val, index) {},
        openEdit: function openEdit() {
            if (this.userInfo.role === "manager" || this.userInfo.role === "admin") {
                this.changeOption(false);
                this.option.isEdit = true;
                this.timingLoad('');
            } else {
                this.$message.error("权限不足，修改失败");
            }
        },
        closeEdit: function closeEdit() {
            this.option.isEdit = false;
            this.timingLoad('OPEN');
        }
    }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_lib__ = __webpack_require__(7);








/* harmony default export */ __webpack_exports__["default"] = ({

    name: "deviceConf",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_3__components_common_loading_vue___default.a
    },
    data: function data() {
        return {
            option: {
                sys_alias: ''
            },
            sys_alias: '',
            loading: true,
            isEdit: '',
            deviceConf: {
                data: [],
                time_stamp: ''
            },

            deviceName: {
                data: '',
                time_stamp: ''
            },

            deviceConfName: {
                bakeCars: '焙烧窑总车位',

                dryCars: '烧烘干窑总车位',

                bakeCarNum: '焙烧标准温度个数',

                dryCarNum: '烘干标准温度个数',

                kiNum: 'K型热电偶总数',

                aoNum: '风机总数',

                piNum: '压力总数',

                aioNum: '4-20mA型总数',

                hisKi: '历史数据表中温度数据个数',

                hisAo: '历史数据表中风机总数',

                hisPi: '历史数据表中压力总数',

                hisCi: '历史数据表中湿度总数',

                detectNum: '巡检提示、报警类型数',

                autoNum: '自控提示、报警类型数',

                zkcsUchar: '自控参数Uchar类型个数',

                zkcsChar: '自控参数Char类型个数',

                zkcsUint: '自控参数Uint类型个数',

                zkcsInt: '自控参数Int类型个数',

                zkcsUlong: '自控参数Ulong类型个数',

                zkcsLong: '自控参数Long类型个数',

                zkcsFloat: '自控参数Float类型个数',

                zkblUchar: '自控变量Uchar类型个数',

                zkblChar: '自控变量Char类型个数',

                zkblUint: "自控变量Uint类型个数",

                zkblInt: "自控变量Int类型个数",

                zkblUlong: '自控变量Ulong类型个数',

                zkblLong: '自控变量Long类型个数',

                zkblFloat: '自控变量Float类型个数',
                id_of_setinterval: ''

            }
        };
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        config: function config(state) {
            return state.config;
        }

    }),
    created: function created() {
        this.sys_alias = __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].M.creatAliasMeun(this.deviceInfo.alias_m);
        this.option.sys_alias = '1';
        this.initData(true);
    },
    beforeDestroy: function beforeDestroy() {
        this.timingLoad('CLOSE');
    },

    methods: {
        initData: function initData(type) {
            this.loading = true;
            this.changeOption(type);
            this.timingLoad('OPEN');
        },
        changeOption: function changeOption(type) {
            this.loading = true;
            this.confData = [];
            this.loadDeviceConf(type);
            this.loadDeviceName(type);
        },
        timingLoad: function timingLoad(type) {
            var _this = this;

            if (type === "OPEN") {
                this.id_of_setinterval = setInterval(function () {
                    _this.loadDeviceConf(false);
                    _this.loadDeviceName(false);
                }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
            } else {
                clearInterval(this.id_of_setinterval);
            }
        },
        loadDeviceConf: function loadDeviceConf(is_cache) {
            var _this2 = this;

            this.loading = true;

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.loadDeviceSetting(params, function (data) {
                _this2.loading = false;
                if (data.payload && data.payload.data) {
                    try {
                        var jsonData = JSON.parse(data.payload.data);
                        delete jsonData.oother;
                        delete jsonData.isSuccess;
                        delete jsonData.msg;
                        _this2.deviceConf.data = [];
                        for (var key in jsonData) {
                            if (_this2.deviceConfName[key]) {
                                _this2.deviceConf.data.push({
                                    name: key,
                                    data: jsonData[key]
                                });
                            }
                        }
                        _this2.deviceConf.time_stamp = data.payload.time_stamp;
                    } catch (err) {}
                } else {
                    if (is_cache) {
                        _this2.initData(false);
                    }
                }
            });
        },
        loadDeviceName: function loadDeviceName(is_cache) {
            var _this3 = this;

            var params = void 0;
            params = {
                sys_alias: this.option.sys_alias,
                is_cache: is_cache,
                device_id: this.deviceInfo.device_id
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.loadDeviceName(params, function (data) {
                if (data.payload && data.payload.data) {
                    try {
                        var _data = JSON.parse(_data.payload.data);

                        _this3.deviceName.data = _data;
                        _this3.deviceName.time_stamp = _data.payload.time_stamp;
                    } catch (err) {
                        console.error();
                    }
                }
            });
        },
        openEdit: function openEdit() {
            this.isEdit = true;
            this.initData(false);
        },
        saveDeviceConf: function saveDeviceConf() {
            var _this4 = this;

            var params = {
                payload: this.dealDeviceConf(),
                device_id: this.deviceInfo.device_id,
                sys_alias: this.option.sys_alias

            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }
            __WEBPACK_IMPORTED_MODULE_4__lib_lib__["a" /* default */].api.setDeviceSetting(params, function (data) {
                if (data.status_code === 'SUCCEEDED') {
                    _this4.$message.success('操作成功');
                } else {
                    _this4.$message.error('操作失败');
                }
            });
        },
        dealDeviceConf: function dealDeviceConf() {
            var data = this.deviceConf.data,
                json = {};
            data.forEach(function (v) {
                json[v.name] = v.data;
            });
            json.devNo = this.option.sys_alias * 1;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(json);
        }
    }

});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_datePick__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_datePick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_common_datePick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_loading__);


var echarts = __webpack_require__(42);










/* harmony default export */ __webpack_exports__["default"] = ({
    name: "historyData",
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default.a,
        dataPicker: __WEBPACK_IMPORTED_MODULE_5__components_common_datePick___default.a,
        loading: __WEBPACK_IMPORTED_MODULE_7__components_common_loading___default.a
    },
    data: function data() {
        return {
            img_no_data: __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default.a,
            img_arrow: __WEBPACK_IMPORTED_MODULE_4__assets_images_arrow_png___default.a,
            option: {
                sys_alias: 1,
                date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().format("YYYY-MM-DD"),
                dateType: "date"
            },
            sys_alias: [],
            loading: {
                chart: true,
                table: true
            },

            charts: "",
            timeOpt: [{
                label: "年报表",
                val: "by_year"
            }, {
                label: "月报表",
                val: "by_month"
            }, {
                label: "日报表",
                val: "by_day"
            }],
            hisData: {
                timeType: "by_day",
                data: [],
                average: []
            },
            chartsData: {
                xData: [],
                proData: [],
                passData: []
            },
            tableHeader: [],
            dayHeader: [{ name: "进车开始时间", key: "startDate" }, { name: "进车时间（分）", key: "carInTime" }, { name: "进车间隔", key: "carInIntervalTime" }, { name: "操作员姓名", key: "name" }, { name: "累计进车数", key: "leiji" }, { name: "发热量（kc/kg）", key: "heat" }, { name: "合格率（％）", key: "rate" }],
            monthHeader: [{ name: "日期", key: "date" }, { name: "进车平均间隔", key: "interval" }, { name: "进车数", key: "day_counter" }, { name: "发热量平均", key: "heat" }, { name: "平均合格率", key: "rate" }],
            yearHeader: [{ name: "日期", key: "date" }, { name: "进车平均间隔", key: "interval" }, { name: "进车数", key: "counter" }, { name: "发热量平均", key: "heat" }, { name: "平均合格率", key: "rate" }]
        };
    },
    created: function created() {
        this.creatAliasMeun(this.deviceInfo.alias_m);
    },
    mounted: function mounted() {
        this.loadHisData();
        __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].M.selectInputFoc();
    },

    watch: {
        "hisData.timeType": function hisDataTimeType() {
            this.changeOption();
        }
    },

    computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapState */])({
        isMobile: function isMobile(state) {
            return state.isMobile;
        },
        userInfo: function userInfo(state) {
            return state.userInfo;
        },
        deviceInfo: function deviceInfo(state) {
            return state.deviceInfo;
        },
        siderbarOpen: function siderbarOpen(state) {
            var _this = this;

            setTimeout(function () {
                _this.charts.resize();
            }, 400);
            return state.siderbarOpen;
        }
    }),

    methods: {
        momentYear: function momentYear(data) {
            return __WEBPACK_IMPORTED_MODULE_1_moment___default()(data).format("YYYY-MM");
        },
        creatAliasMeun: function creatAliasMeun(MaxAlias) {
            for (var i = 0; i < MaxAlias; i++) {
                this.sys_alias.push({
                    val: i + 1,
                    label: i + 1 + "\u53F7\u7A91"
                });
            }
        },
        changeOption: function changeOption(type) {
            if (this.hisData.timeType === "by_day") {
                this.option.dateType = "date";
            } else {
                this.option.dateType = this.hisData.timeType.split("by_")[1];
            }
            this.loadHisData();
        },
        loadHisData: function loadHisData() {
            var _this2 = this;

            this.loading.table = true;

            var params = {
                device_id: this.deviceInfo.device_id,
                data_type: "proData",
                sys_alias: this.option.sys_alias,
                date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).format("YYYY-MM-DD"),
                time_type: this.hisData.timeType
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }

            if (!params.date) {
                params.date = "2011-02-01";
            }
            __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].api.loadDeviceData(params, function (data) {
                _this2.loading.chart = false;
                _this2.loading.table = false;
                if (data.status_code === "SUCCEEDED") {
                    console.log(data.payload);

                    if (data.payload && data.payload) {
                        try {
                            _this2.hisData.data = _this2.parseJsonArr(data.payload);

                            _this2.chartsDataFn(_this2.hisData.data);
                            _this2.$nextTick(function () {
                                if (_this2.hisData.timeType && _this2.hisData.timeType !== "by_day") {
                                    _this2.initChart();
                                }
                            });
                        } catch (error) {
                            console.error({
                                msg: "产量数据解析错误",
                                data: data,
                                error: error
                            });
                        }
                    } else {
                        _this2.hisData.data = [];
                    }
                } else {
                    _this2.$message(data.msg);
                }
            });
        },
        exportExcelFn: function exportExcelFn() {
            var params = {
                device_id: this.deviceInfo.device_id,
                data_type: "proData",
                sys_alias: this.option.sys_alias,
                date: __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).format("YYYY-MM-DD"),
                time_type: this.hisData.timeType
            };
            if (this.userInfo.identity === "USER") {
                params.auth_token = this.userInfo.token;
            } else {
                params.customer_token = this.userInfo.token;
            }

            var url = __WEBPACK_IMPORTED_MODULE_2__lib_lib_js__["a" /* default */].C.APIhost + "/devices/" + this.deviceInfo.device_id + "/pro_export?device_id=" + this.deviceInfo.device_id + "&data_type=proData&sys_alias=" + this.option.sys_alias + "&date=" + __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).format("YYYY-MM-DD") + "&time_type=" + this.hisData.timeType + "&auth_token=" + (params.auth_token ? params.auth_token : "") + (params.customer_token ? '&customer_token=' + customer_token : "");
            window.open(url);
        },
        parseJsonArr: function parseJsonArr(arr) {
            var resArr = [];
            if (this.hisData.timeType === "by_day") {
                this.tableHeader = this.dayHeader;
                arr.forEach(function (item) {
                    try {
                        resArr.push(JSON.parse(item.data));
                    } catch (error) {
                        console.error({
                            error: error,
                            msg: "日产量数据解析失败",
                            data: item.data
                        });
                    }
                }, this);
            } else {
                this.tableHeader = this.hisData.timeType === "by_month" ? this.monthHeader : this.yearHeader;
                resArr = arr.data;
                this.hisData.average = JSON.parse(arr.average);
            }
            return resArr;
        },
        chartsDataFn: function chartsDataFn(data) {
            var xData = [],
                countData = [],
                rateData = [];

            if (this.hisData.timeType === "by_month") {
                var monthDays = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.option.date).daysInMonth();
                for (var i = 1; i <= monthDays; i++) {
                    xData.push(i);
                    countData.push(0.1);
                }
                data.forEach(function (item) {
                    var d = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.date).format("D") * 1 - 1,
                        x = xData[d];
                    if (x) {
                        countData[x - 1] = item.day_counter ? item.day_counter : item.counter;
                    }
                });
            } else if (this.hisData.timeType === "by_year") {
                for (var _i = 1; _i <= 12; _i++) {
                    xData.push(_i);
                    countData.push(0.1);
                }
                data.forEach(function (item) {
                    var m = __WEBPACK_IMPORTED_MODULE_1_moment___default()(item.date).format("M") * 1,
                        x = xData[m - 1];
                    if (x) {
                        countData[m - 1] = item.day_counter ? item.day_counter : item.counter;
                    }
                });
            }

            this.chartsData = {
                xData: xData,
                countData: countData
            };
        },
        initChart: function initChart() {
            var chartsData = this.chartsData;
            var charts = void 0;

            var xAxisData = [];
            var data1 = [];

            for (var i = 0; i < 12; i++) {
                xAxisData.push(i);
                data1.push((Math.random() + 2) * 100);
            }
            var option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        label: {
                            backgroundColor: "#283b56"
                        }
                    }
                },
                legend: {
                    data: ["进车数"],
                    align: "left",
                    bottom: 20
                },

                xAxis: {
                    show: true,

                    data: chartsData.xData,
                    silent: false,
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    show: "true",
                    type: "value",
                    name: "进车数",
                    max: this.hisData.timeType === "by_year" ? "800" : "50"
                },
                series: {
                    name: "进车数",
                    type: "bar",
                    data: chartsData.countData,
                    animationDelay: function animationDelay(idx) {
                        return idx * 10;
                    },
                    itemStyle: {
                        normal: {
                            color: "#ff8283"
                        },
                        emphasis: {
                            color: "#ff5653"
                        }
                    },
                    barCategoryGap: "40%"
                },
                animationEasing: "elasticOut",
                animationDelayUpdate: function animationDelayUpdate(idx) {
                    return idx * 5;
                }
            };
            if (this.$refs.charts) {
                charts = echarts.init(this.$refs.charts, charts, {
                    height: 400
                });
                charts.setOption(option);
            }

            this.charts = charts;
        },
        setScroll: function setScroll(type) {
            var hisTable = this.$refs.hisTable,
                scrollLeft = this.$refs.hisTable.scrollLeft;
            if (type === "right") {
                hisTable.scrollLeft = scrollLeft + 80;
            } else {
                hisTable.scrollLeft = scrollLeft - 80;
            }
        }
    }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_pageHead_vue__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_pageHead_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_pageHead_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_pageSide_vue__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tempControl_pageSide_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_tempControl_pageSide_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  components: {
    pageHead: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_pageHead_vue___default.a,
    pageFooter: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_pageFooter_vue___default.a,
    pageSide: __WEBPACK_IMPORTED_MODULE_4__components_tempControl_pageSide_vue___default.a
  },
  data: function data() {
    return {
      showMe: true
    };
  },

  computed: {
    isLoading: function isLoading() {
      return this.$store.state.isLoading;
    },
    isOpen: function isOpen() {
      return this.$store.state.siderbarOpen;
    },
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    }
  },
  created: function created() {
    var userInfo = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("userInfo");
    var deviceInfo = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("deviceInfo");
    var deviceListType = __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].getItem("deviceListType");

    if (userInfo) {
      this.$store.dispatch("setUserInfo", userInfo);
    }
    if (deviceInfo) {
      this.$store.dispatch("setDeviceInfo", deviceInfo);
    }if (deviceListType) {
      this.$store.dispatch("setDeviceListType", deviceListType);
    }
  },
  mounted: function mounted() {},


  methods: {
    clickMobileMask: function clickMobileMask() {
      this.$store.dispatch('toggleSide');
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_datePick__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_datePick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_datePick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_lib__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_loading__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_common_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tempControl_dropTimePicker__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tempControl_dropTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_tempControl_dropTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_indexSlider_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_indexSlider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_common_indexSlider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg__);






var echarts = __webpack_require__(42);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: "timeCharts",
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_7__components_common_datePick___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_9__components_common_loading___default.a,
    dropTimePicker: __WEBPACK_IMPORTED_MODULE_10__components_tempControl_dropTimePicker___default.a,
    indexSlider: __WEBPACK_IMPORTED_MODULE_11__components_common_indexSlider_vue___default.a
  },
  data: function data() {
    return {
      img_no_data: __WEBPACK_IMPORTED_MODULE_12__assets_images_no_data_svg___default.a,

      option: {
        sys_alias: 1,
        chartsType: "shaojie",
        date: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD 00:00:ss"),
        selectedDate: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format("YYYY-MM-DD HH:mm:ss"),
        brickList: ""
      },

      loading: {
        realData: true,
        hisData: true,
        standConf: false
      },

      sys_alias: [],

      chartsType: [{
        val: "shaojie",
        label: "烧结"
      }, {
        val: "honggan",
        label: "烘干"
      }],
      max_pt: -1,
      max_dry: -1,
      echartError: false,

      realData: {},

      tableData: "",
      tableTypeName: {
        shaojie: "烧结",
        cewen: "测温",
        honggan: "烘干",
        other: "其他",
        yali: "压力",
        fengji: "风机"
      },

      hisData: [],
      hisListData: [],
      oneDayData: [],
      timeLineData: {
        options: [],
        timeList: [],
        index: 0,
        show: false
      },

      stand: {
        type: 0,
        data: {},
        list: [],
        conf: "",
        edit: false
      },

      charts: "",
      chartsData: {
        realData: [],
        standData: [],
        xAxis: []
      },

      hisTable: {
        show: false,
        data: []
      },

      id_of_setinterval: "",

      isNotHisData: false,

      fengji: {
        show: false,
        payload: {
          flag: false,
          fjNo: 0,
          fjPl: 0,
          devNo: 0
        },
        select: {},
        selected: ""
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    siderbarOpen: function siderbarOpen(state) {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.charts) {
          _this2.charts.resize();
        }
      }, 400);
      return state.siderbarOpen;
    },

    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    },
    config: function config(state) {
      return state.config;
    }
  })),
  created: function created() {
    this.creatAliasMeun(this.deviceInfo.alias_m);
  },
  mounted: function mounted() {
    this.loadBrick();
    this.loadDeviceList();

    __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].M.selectInputFoc();
  },
  beforeDestroy: function beforeDestroy() {
    this.timingLoadRealData("close");

    this.echarts = "";
  },

  methods: {
    creatAliasMeun: function creatAliasMeun(MaxAlias) {
      for (var i = 0; i < MaxAlias; i++) {
        this.sys_alias.push({
          val: i + 1,
          label: i + 1 + "\u53F7\u7A91"
        });
      }
    },
    loadDeviceList: function loadDeviceList() {
      var _this3 = this;

      var params = {
        device_id: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.loadDevice(params, function (data) {
        if (data.status_code !== "SUCCEEDED") {
          _this3.$message.error(data.msg);
        } else {
          var device = data.payload;
          device.device_id = device.device_id.$oid;
          _this3.$store.dispatch("setDeviceInfo", device);
        }
      });
    },
    initChart: function initChart(standData, realData, xAxisData) {
      var option = {
        baseOption: {
          grid: {
            show: true,
            top: 30,
            left: 50,
            right: 0,
            bottom: 60
          },

          tooltip: {
            trigger: "axis"
          },
          legend: {
            show: true,
            data: ["标准温度", "实时温度"],
            bottom: 0
          },
          xAxis: {
            show: true,
            data: xAxisData,
            splitLine: {
              lineStyle: {
                color: "#DDDDDD"
              },
              interval: function interval() {
                return true;
              },
              show: true
            },
            axisTick: {
              show: true,
              alignWithLabel: true,
              interval: function interval(_interval, val) {
                return true;
              }
            },
            axisLabel: {
              show: true,
              interval: function interval(_interval2, val) {
                return val != "0" && val !== "-" ? true : false;
              },
              formatter: function formatter(value) {
                return value ? value : false;
              }
            }
          },
          yAxis: {
            axisLine: { show: true },
            splitLine: {
              show: true
            },
            splitNumber: this.option.chartsType === "shaojie" ? 6 : 4,
            max: this.option.chartsType === "shaojie" ? 1200 : 200,
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: "{value}℃"
            }
          },
          series: [{
            name: "标准温度",
            type: "line",
            data: standData,

            itemStyle: {
              normal: {
                color: "#2378DC"
              }
            },
            smooth: "true",
            connectNulls: true,
            lineStyle: {
              normal: {
                width: "4"
              }
            }
          }, {
            name: "实时温度",
            type: "line",
            data: realData,
            smooth: "true",
            connectNulls: true,
            itemStyle: {
              normal: {
                color: "#E65D20"
              }
            },
            lineStyle: {
              normal: {
                width: "4"
              }
            }
          }]
        }
      };

      if (this.charts) {
        this.charts.setOption(option);
      } else {
        console.log("init");

        var charts = echarts.init(this.$refs.charts, charts, {
          height: this.isMobile ? 300 : 400
        });
        charts.setOption(option);
        this.charts = charts;
      }
    },
    loadBrick: function loadBrick(is_cache) {
      var _this4 = this;

      var params = {
        conf_type: "brick",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache ? is_cache : true
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.loadDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this4.stand.type = data.payload.name > 30 ? 0 : data.payload.name;
          try {
            if (data.payload.list) {
              _this4.stand.list = JSON.parse(data.payload.list);
            } else {
              _this4.stand.list = [];
            }
          } catch (error) {
            console.error({
              msg: "获取砖类型列表失败",
              data: data
            });
          }
          _this4.loadStandConf(true);
          _this4.timingLoadRealData("open");
        } else {
          _this4.loading.hisData = false;
          _this4.loading.realData = false;

          _this4.$notify({
            title: "初始化通信中",
            message: "正在获取设备数据，请稍等",
            type: "warning"
          });
          console.error({
            msg: "获取当前砖类型失败",
            data: data
          });
          _this4.loadRealDataFn("show");
        }
      });
    },
    loadStandConf: function loadStandConf(is_cache) {
      var _this5 = this;

      var params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache,
        name: this.stand.type ? this.stand.type : 30,
        payload: {
          devNo: 1,
          type: this.stand.type ? this.stand.type : 30
        }
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.loadDeviceConf(params, function (data) {
        _this5.loadHisData("created");
        if (data.status_code === "SUCCEEDED") {} else {
          _this5.$message({
            message: "网络连接超时：" + data.msg,
            type: "warning"
          });
        }
        if (data.payload && data.payload.data) {
          _this5.stand.conf = JSON.parse(data.payload.data);
          _this5.stand.data = _this5.dealApiData(data.payload.data);
        } else {
          if (is_cache) {
            _this5.loadStandConf(false);
          }
          console.error({
            msg: "获取标准参数数据失败",
            data: data
          });
        }
      });
    },
    dealApiData: function dealApiData(data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
      var shaojie = [],
          honggan = [],
          cewen = [],
          fengji = [],
          yali = [],
          other = [];
      var item = void 0,
          th = void 0;
      var jsonData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(data.ki, data.ao, data.pi, data.ci);

      var nameRegExp = {
        shaojie: /烧结|顶中|顶外|顶内|内侧|外侧|内|外|中/
      };

      for (item in jsonData) {
        if (item) {
          var pushJson = {
            th: item,
            data: jsonData[item],
            key: item,
            id: __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].M.guid()
          };
          if (nameRegExp.shaojie.test(item)) {
            pushJson.th = item.replace(/[^0-9]/g, "");
            pushJson.thName = item;
            shaojie.push(pushJson);
          } else if (item.search("烘干") !== -1) {
            pushJson.th = item.split("车位烘干")[0];
            honggan.push(pushJson);
          } else if (item.search("测温") !== -1) {
            cewen.push(pushJson);
          } else if (item.search("风机") !== -1) {
            pushJson.th = pushJson.key.split("@")[0];
            fengji.push(pushJson);
          } else if (item.search("压力") !== -1) {
            yali.push(pushJson);
          } else {
            cewen.push(pushJson);
          }
        }
      }

      function thSort(a, b) {
        if (a.th * 1 > b.th * 1) {
          return 1;
        } else {
          return -1;
        }
      }

      shaojie.sort(thSort);
      honggan.sort(thSort);
      return {
        shaojie: shaojie,
        honggan: honggan,
        cewen: cewen,
        fengji: fengji,
        yali: yali,
        other: other
      };
    },
    changeDate: function changeDate(selectTime) {
      var date = this.option.selectedDate,
          oneDay = this.oneDayData,
          time = selectTime.day + " " + selectTime.hour + ":00";
      if (selectTime.day !== __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format("YYYY-MM-DD")) {
        this.option.date = time;
        this.option.selectedDate = time;
        this.loadHisData("created");
      }
    },
    dealChartsData: function dealChartsData() {
      var _this7 = this;

      var tableData = this.tableData,
          stand = this.stand.data;
      if (tableData) {
        var repeatData = function repeatData(data) {
          if (!data || !data.length) {
            return [];
          }
          var json = {},
              item = void 0,
              jsonItem = void 0;
          for (var i = 0; i < data.length; i++) {
            item = data[i];
            jsonItem = json[item.th];
            if (jsonItem) {
              jsonItem.data = __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].M.getMax(jsonItem.data, item.data);
              jsonItem.count = 1;
            } else {
              jsonItem = {};
              jsonItem.th = item.th;
              jsonItem.key = item.key;
              jsonItem.data = item.data;
              jsonItem.count = 1;
            }
            json[item.th] = jsonItem;
          }
          var arr = [],
              arrItem = void 0;
          for (var x in json) {
            arrItem = json[x];
            arrItem.data = Math.floor(arrItem.data / arrItem.count);
            arr.push(arrItem);
          }
          return arr;
        };

        var dataForEach = function dataForEach(data) {
          var _this6 = this;

          var result = [],
              xData = [],
              DataLength = void 0;
          data = repeatData(data);
          if (data && data.length > 0) {
            DataLength = data[data.length - 1].th * 1 + 2;
            var maxPos = DataLength;
            if (opt.chartsType === "shaojie") {
              maxPos = that.max_pt;
            } else {
              maxPos = that.max_dry;
            }
            if (maxPos > DataLength) {
              DataLength = maxPos;
            }

            var _loop = function _loop(i) {
              if (i === 0) {
                xData[i] = "0";
                result[i] = "30";
              } else if (i === DataLength - 1) {
                xData[i] = i + 1;
                result[i] = "30";
              } else {
                xData[i] = "-";
                result[i] = "-";
              }
              data.forEach(function (item, n) {
                if (i == item.th) {
                  xData[i] = item.th;
                  result[i] = item.data;
                }
              }, _this6);
            };

            for (var i = 0; i <= DataLength; i++) {
              _loop(i);
            }
          }
          return { xData: xData, result: result };
        };

        var realData = [],
            xData = [],
            StandData = void 0,
            re = void 0,
            opt = this.option,
            _this = this,
            that = this;

        re = dataForEach(tableData[opt.chartsType]);
        xData = re.xData;
        realData = re.result;
        stand = dataForEach(stand[opt.chartsType]).result;
        if (stand.length <= 0 && realData.length <= 0) {
          xData = realData = stand = ["0", "-", "-", "-", "-", "0"];
        }

        this.$nextTick(function () {
          if (_this7.$refs.charts) {
            _this7.initChart(stand, realData, xData);
          }
        });
      }
    },
    dealHisFn: function dealHisFn(data) {
      var hisData = [];
      if (!data) {
        return false;
      }
      if (data.length > 0) {
        var item = void 0,
            r = void 0;
        for (var i = 0; i < data.length; i++) {
          item = data[i];
          try {
            r = this.dealApiData(item.data);
            r.time_stamp = item.time_stamp;
            hisData.push(r);
          } catch (error) {
            console.error("历史数据处理err:" + error);
            console.error(item);
          }
        }
      }
      return hisData;
    },
    selectHisData: function selectHisData(data, listData) {
      this.tableData = data;
      this.hisListData = listData;

      this.dealChartsData();
    },
    selectButtonChartsFn: function selectButtonChartsFn(type, hourIndex, itemIndex) {
      var _this8 = this;

      var index = this.timeLineData.index,
          dateFormat = "YYYY-MM-DD HH:00:SS",
          date = this.option.selectedDate,
          oneDay = this.oneDayData,
          data = oneDay[hourIndex];

      if (data) {
        this.hisData = data;
        this.realData = data[0];
        this.tableData = data[0];
        this.dealChartsData();
      } else {
        this.hisData = [];
      }
      if (type === "PRE") {
        this.option.selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).subtract(1, "hour").format(dateFormat);
      } else if (type === "NEXT") {
        this.option.selectedDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).add(1, "hour").format(dateFormat);
      }

      this.$nextTick(function () {
        if (itemIndex > _this8.hisData.length - 1) {
          itemIndex = _this8.hisData.length - 1;
        }
        _this8.selectHisData(itemIndex);
      });
    },
    openTimePicker: function openTimePicker() {
      var _this9 = this;

      var show = this.timeLineData.show;
      this.timeLineData.show = !show;
      this.$nextTick(function () {
        if (_this9.timeLineData.show) {
          _this9.loadHisData("created");
        } else {
          if (_this9.realData && _this9.realData.time_stamp) {
            _this9.tableData = _this9.realData;
          }
        }
      });
    },
    loadHisDataP: function loadHisDataP(order, page_size) {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var params = {
          device_id: _this10.deviceInfo.device_id,
          data_type: "hisData",
          sys_alias: _this10.option.sys_alias,
          page_size: page_size ? page_size : 300,
          order: order ? order : "asc"
        };
        if (_this10.option.date) {
          params.begin = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this10.option.date).format("YYYY-MM-DD 00:00:00");
          params.end = __WEBPACK_IMPORTED_MODULE_4_moment___default()(_this10.option.date).add(1, "day").format("YYYY-MM-DD 00:00:00");
        }
        if (_this10.userInfo.identity === "USER") {
          params.auth_token = _this10.userInfo.token;
        } else {
          params.customer_token = _this10.userInfo.token;
        }
        __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.loadDeviceData(params, function (data) {
          if (data.status_code === "SUCCEEDED") {
            if (data.payload && data.payload.length > 0) {
              resolve(data);
            } else {
              reject({
                msg: "历史数据接口无数据",
                data: data
              });
            }
          } else {
            console.error("历史数据接口：" + data.msg);
            reject({
              msg: "历史数据接口",
              data: data.msg
            });
          }
        });
      });
    },
    loadHisData: function loadHisData(type) {
      var _this11 = this;

      if (type === "created") {
        if (!this.hisData.length) {
          this.loading.realData = true;
        }
        this.loading.hisData = true;
      }
      this.$nextTick(function () {
        _this11.loadHisDataP().then(function (data) {
          _this11.loading.hisData = false;
          _this11.loading.realData = false;
          if (type === "created") {
            _this11.hisData = _this11.dealHisFn(data.payload);
            _this11.tableData = _this11.hisData[_this11.hisData.length - 1];
            _this11.dealChartsData();
          }
        }).catch(function (reason) {
          _this11.oneDayData = {};
          _this11.hisData = [];

          _this11.loadHisDataP("", 1).then(function (data) {
            _this11.loading.hisData = false;
            _this11.loading.realData = false;
            var dataList = _this11.dealHisFn(data.payload);
            _this11.tableData = dataList[0];
          }).catch(function (data) {
            _this11.loading.hisData = false;
            _this11.$message.info("暂无历史数据");
            _this11.$nextTick(function () {
              _this11.loadRealDataFn("REVIEW");
            });
          });
          console.log(reason);
        });
      });
    },
    loadRealDataFn: function loadRealDataFn(type) {
      if (type === "show") {
        this.timeLineData.show = false;
        this.loading.realData = true;
      }

      if (type === "REVIEW") {
        type = "show";
      }
      this.loadRealDataP(type);
    },
    loadRealDataP: function loadRealDataP(type) {
      var params = {
        device_id: this.deviceInfo.device_id,
        data_type: "realData",
        sys_alias: this.option.sys_alias
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      var that = this;
      __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.loadDeviceData(params, function (data) {
        if (data.status_code === "FAILED") {
          that.$message({
            message: data.msg,
            type: "warning"
          });
        }
        if (data.payload && data.payload.data) {
          that.max_pt = data.payload.max_pt;
          that.max_dry = data.payload.max_dry;
          that.realData = that.dealApiData(data.payload.data);
          that.realData.time_stamp = data.payload.time_stamp;
          if (type === "show") {
            that.charts = "";
            that.tableData = that.realData;
            that.loading.realData = false;

            that.$nextTick(function () {
              that.dealChartsData();
            });
          }
        } else {}
      });
    },
    timingLoadRealData: function timingLoadRealData(type) {
      var _this12 = this;

      if (type === "open") {
        this.loadRealDataP();
        this.id_of_setinterval = setInterval(function () {
          _this12.loadRealDataP();

          if (!_this12.timeLineData.show) {
            _this12.tableData = _this12.realData;
            _this12.dealChartsData();
          }
        }, this.config.refreshInterval ? this.config.refreshInterval : 30000);
      } else {
        clearInterval(this.id_of_setinterval);
      }
    },
    setStandConf: function setStandConf() {
      var _this13 = this;

      this.loading.standConf = true;
      var params = void 0,
          payload = void 0,
          oldConf = void 0,
          dealPayload = void 0;
      oldConf = this.stand.conf;

      dealPayload = function dealPayload(data) {
        var item = void 0,
            jsonData = void 0,
            editValue = void 0;

        editValue = function editValue(goal, value) {
          var key = void 0,
              subKey = void 0;
          for (key in oldConf) {
            for (subKey in oldConf[key]) {
              if (goal === subKey) {
                if (oldConf[key][subKey] == value) {
                  return "normal";
                } else {
                  oldConf[key][subKey] = value * 1;
                  return "update";
                }
              }
            }
          }
        };
        jsonData = data.fengji.concat(data.fengji, data.honggan, data.cewen, data.shaojie, data.yali, data.other);
        for (item in jsonData) {
          var result = editValue(jsonData[item].key, jsonData[item].data);
          if (result === "update") {
            console.log("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u6210\u529F");
          } else if (result === "normal") {
            console.log("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u672A\u6539\u53D8");
          } else {
            console.error("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u5931\u8D25");
          }
        }
        return oldConf;
      };

      payload = dealPayload(this.stand.data);
      payload.devNo = this.option.sys_alias * 1;
      params = {
        conf_type: "standard",
        sys_alias: this.option.sys_alias.toString(),
        device_id: this.deviceInfo.device_id,
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload),
        is_change: "true"
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.setDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this13.$message.success("修改成功");
          _this13.stand.edit = false;
          _this13.loadStandConf(false);
        } else {
          _this13.$message.error("修改失败," + data.msg);
        }

        _this13.loading.standConf = false;
      });
    },
    editStandInput: function editStandInput() {
      this.dealChartsData();
    },
    openStandEdit: function openStandEdit() {
      var _this14 = this;

      var stand = this.stand,
          takeStandbyReal = void 0;

      takeStandbyReal = function takeStandbyReal() {
        var realData = void 0,
            hisData = void 0,
            standConf = void 0,
            key = void 0;
        hisData = _this14.hisData;
        realData = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this14.tableData));
        if (_this14.timeLineData.show) {
          hisData = _this14.hisListData;
        } else {
          hisData = hisData.slice(-10);
        }

        hisData.forEach(function (item, itemIndex) {
          for (key in item) {
            for (var i = 0; i < item[key].length; i++) {
              if (key !== "time_stamp") {
                realData[key][i].data = realData[key][i].data + item[key][i].data;
                if (itemIndex === hisData.length - 1) {
                  realData[key][i].data = Math.floor(realData[key][i].data / (hisData.length + 1));
                }
              }
            }
          }
        });
        standConf = realData;
        return standConf;
      };
      if (stand.edit) {
        this.stand.data = this.dealApiData(this.stand.conf);
      } else {
        location.hash = "#tablelist";
        this.stand.data = takeStandbyReal();
      }
      this.$nextTick(function () {
        _this14.dealChartsData();
      });

      this.stand.edit = !stand.edit;
    },
    openFengjiEdit: function openFengjiEdit() {
      this.fengji.show = true;
      var payload = this.fengji.payload;
      payload.devNo = this.option.sys_alias;
    },
    selectFenji: function selectFenji(e) {
      var f = this.fengji.select = this.realData.fengji[this.fengji.selected];
      this.fengji.payload.fjPl = f.data * 1;
      this.fengji.payload.fjNo = f.key.split("@")[1] * 1;
    },
    saveFenji: function saveFenji() {
      var _this15 = this;

      var url = "devices/" + this.deviceInfo.device_sn + "/frequency",
          params = {
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.fengji.payload),
        device_sn: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_8__lib_lib__["a" /* default */].api.setFrequency(params, function (data) {
        if (data.status_code === 'SUCCEEDED') {
          _this15.$message.success('操作成功');
          _this15.fengji.show = false;
          _this15.loadRealDataFn('show');
          _this15.realData.fengji[_this15.fengji.selected].data = _this15.fengji.payload.fjPl;
          _this15.tableData.fengji[_this15.fengji.selected].data = _this15.fengji.payload.fjPl;
        } else {
          _this15.$message.error('操作失败');
        }
      });
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loading_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_common_loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_common_loading_vue__);







var echarts = __webpack_require__(42);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "standardSet",
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_6__components_tempControl_header___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_7__components_common_loading_vue___default.a
  },
  data: function data() {
    return {
      img_no_data: __WEBPACK_IMPORTED_MODULE_3__assets_images_no_data_svg___default.a,
      sys_alias: [],
      option: {
        aliasNo: "1",
        selectType: "shaojie",
        time_stamp: ""
      },

      chartsType: [{
        val: "shaojie",
        label: "烧结"
      }, {
        val: "honggan",
        label: "烘干"
      }],
      max_pt: -1,
      max_dry: -1,
      loading: {
        standard: true,
        echarts: true
      },
      standConf: {},
      confTypeName: {
        shaojie: "烧结",
        cewen: "测温",
        honggan: "烘干",
        other: "其他",
        yali: "压力",
        fengji: "风机"
      },
      oldConf: "",
      isEdit: false,
      charts: "",

      hisData: [],
      realData: {},

      chartsData: {},

      stand: {
        list: [],
        type: "",
        edit: {
          name: "",
          id: ""
        }
      },

      dialog: {
        standType: false
      }
    };
  },

  watch: {
    "option.selectType": function optionSelectType() {
      this.changeSelectType();
    }
  },
  created: function created() {
    this.creatAliasMeun(this.deviceInfo.alias_m);
  },
  mounted: function mounted() {
    this.loadBrick();
    __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].M.selectInputFoc();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    siderbarOpen: function siderbarOpen(state) {
      return state.siderbarOpen;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    deviceInfo: function deviceInfo(state) {
      return state.deviceInfo;
    }
  })),
  methods: {
    creatAliasMeun: function creatAliasMeun(MaxAlias) {
      for (var i = 0; i < MaxAlias; i++) {
        this.sys_alias.push({
          val: "" + (i + 1),
          label: i + 1 + "\u53F7\u7A91"
        });
      }
    },
    loadBrick: function loadBrick() {
      var _this2 = this;

      var params = {
        conf_type: "brick",
        sys_alias: this.option.aliasNo,
        device_id: this.deviceInfo.device_id
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this2.stand.type = data.payload.name;
          try {
            _this2.stand.list = JSON.parse(data.payload.list);
            _this2.stand.type = data.payload.name;
          } catch (error) {
            console.error({
              error: error,
              msg: "解析砖类型列表失败",
              data: data
            });
          }
        }
        _this2.loadHisData();
      });
    },
    loadStandConf: function loadStandConf(is_cache) {
      var _this3 = this;

      this.loading.standard = true;
      var params = {
        conf_type: "standard",
        sys_alias: this.option.aliasNo,
        device_id: this.deviceInfo.device_id,
        is_cache: is_cache,
        name: this.stand.type ? this.stand.type : 30,
        payload: {
          devNo: this.option.aliasNo * 1,
          type: this.stand.type ? this.stand.type : 30
        }
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.loadDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {} else {
          if (!is_cache) {
            _this3.isEdit = false;
          }
          _this3.$message({
            message: "网络连接超时：" + data.msg,
            type: "warning"
          });
          if (!_this3.isMobile) {
            _this3.$notify.info({
              title: "温馨提示",
              message: "无法连接设备时，无法进行参数修改操作",
              duration: 3000,
              offset: 60
            });
          }
        }
        if (data.payload && data.payload.data) {
          var s = JSON.parse(data.payload.data);
          delete s.oother;
          delete s.msg;
          _this3.oldConf = s;
          _this3.standConf = _this3.dealApiData(s);
          _this3.option.time_stamp = data.payload.time_stamp;

          _this3.$nextTick(function () {
            _this3.dealChartsData("shaojie");
          });
        }
        _this3.loading.echarts = false;

        _this3.loading.standard = false;
      });
    },
    loadHisData: function loadHisData() {
      var _this4 = this;

      var params = {
        device_id: this.deviceInfo.device_id,
        data_type: "realData",
        sys_alias: this.option.aliasNo,
        page_size: 5,
        page_no: 1
      };

      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.loadDeviceData(params, function (data) {
        _this4.loadStandConf(true);

        if (data.status_code === "SUCCEEDED") {
          _this4.max_pt = data.payload.max_pt;
          _this4.max_dry = data.payload.max_dry;
          _this4.hisData = _this4.dealApiData(JSON.parse(data.payload.data));
          debugger;
          _this4.realData = _this4.hisData;
        } else {
          console.error("历史数据接口：" + data.msg);
        }
      });
    },
    dealHisFn: function dealHisFn(data) {
      var hisData = [];
      if (data.length > 0) {
        var item = void 0;
        for (var i = 0; i < data.length; i++) {
          item = data[i];
          try {
            var r = this.dealApiData(JSON.parse(item.data));
            r.time_stamp = item.time_stamp;
            hisData.push(r);
          } catch (error) {
            console.error("历史数据处理err:" + error);
            console.error(item);
          }
        }
      }
      return hisData;
    },
    dealApiData: function dealApiData(data) {
      var shaojie = [],
          honggan = [],
          cewen = [],
          fengji = [],
          yali = [],
          other = [];
      var item = void 0,
          th = void 0;
      var jsonData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(data.ki, data.ao, data.pi, data.ci);
      var nameRegExp = {
        shaojie: /烧结|顶中|顶外|顶内|内侧|外侧|内|外|中/
      };
      for (item in jsonData) {
        var pushJson = {
          th: item,
          data: jsonData[item],
          key: item
        };
        if (nameRegExp.shaojie.test(item)) {
          pushJson.th = item.replace(/[^0-9]/g, "");
          shaojie.push(pushJson);
        } else if (item.search("烘干") !== -1) {
          pushJson.th = item.split("车位烘干")[0];
          honggan.push(pushJson);
        } else if (item.search("测温") !== -1) {
          cewen.push(pushJson);
        } else if (item.search("风机") !== -1) {
          fengji.push(pushJson);
        } else if (item.search("压力") !== -1) {
          yali.push(pushJson);
        } else {
          other.push(pushJson);
        }
      }

      function thSort(a, b) {
        if (a.th * 1 > b.th * 1) {
          return 1;
        } else {
          return -1;
        }
      }

      shaojie.sort(thSort);
      honggan.sort(thSort);
      return {
        shaojie: shaojie,
        honggan: honggan,
        cewen: cewen,
        fengji: fengji,
        yali: yali,
        other: other
      };
    },
    openEdit: function openEdit() {
      if (this.isEdit) {
        this.saveStandConf(false);
      } else {
        if (this.userInfo.role === "manager" || this.userInfo.role) {
          this.loadStandConf(false);
          this.isEdit = true;
        } else {
          this.$message.error("权限不足，修改失败");
        }
      }
    },
    delSaveData: function delSaveData(data) {
      var _this = this,
          oldConf = _this.oldConf;

      function checkValue(type, value) {
        value = Math.floor(value);

        return value;
      }

      function editValue(goal, value) {
        var key = void 0,
            subKey = void 0;
        for (key in oldConf) {
          for (subKey in oldConf[key]) {
            if (goal === subKey) {
              if (oldConf[key][subKey] == value) {
                return "normal";
              } else {
                oldConf[key][subKey] = checkValue(key, value);
                return "update";
              }
            }
          }
        }
      }

      var item = void 0;
      var jsonData = data.fengji.concat(data.fengji, data.honggan, data.cewen, data.shaojie, data.yali, data.other);
      for (item in jsonData) {
        var result = editValue(jsonData[item].key, jsonData[item].data);
        if (result === "update") {
          console.log("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u6210\u529F");
        } else if (result === "normal") {} else {
          console.error("\u6807\u51C6\u914D\u7F6E\uFF1A" + jsonData[item].key + "\u4FEE\u6539\u5931\u8D25");
        }
      }
      return oldConf;
    },
    saveStandConf: function saveStandConf(is_change) {
      var _this5 = this;

      var payload = this.delSaveData(this.standConf);
      this.loading.standard = true;
      payload.devNo = this.option.aliasNo * 1;
      var params = {
        conf_type: "standard",
        sys_alias: this.option.aliasNo,
        device_id: this.deviceInfo.device_id,
        is_change: is_change.toString(),
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this5.$message.success("修改成功");
          _this5.isEdit = false;
          _this5.loadStandConf(false);
        } else {
          _this5.$message.error("修改失败," + data.msg);
          _this5.loading.standard = false;
        }
      });
    },
    setStandByrealData: function setStandByrealData() {
      this.standConf = this.realData;
      this.saveStandConf();
    },
    changeSelectType: function changeSelectType() {
      var type = this.option.selectType;
      this.dealChartsData(type);
    },
    dealChartsData: function dealChartsData(type) {
      var _this7 = this;

      var real = this.realData,
          stand = this.standConf;
      var that = this;

      function repeatData(data) {
        if (!data.length) {
          return data;
        }
        var json = {},
            item = void 0,
            jsonItem = void 0;
        for (var i = 0; i < data.length; i++) {
          item = data[i];
          jsonItem = json[item.th];
          if (jsonItem) {
            jsonItem.data = __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].M.getMax(jsonItem.data, item.data);
            jsonItem.count = 1;
          } else {
            jsonItem = {};
            jsonItem.th = item.th;
            jsonItem.key = item.key;
            jsonItem.data = item.data;
            jsonItem.count = 1;
          }
          json[item.th] = jsonItem;
        }
        var arr = [],
            arrItem = void 0;
        for (var x in json) {
          arrItem = json[x];
          arrItem.data = Math.floor(arrItem.data / arrItem.count);
          arr.push(arrItem);
        }
        return arr;
      }

      function dataForEach(data) {
        var _this6 = this;

        data = repeatData(data);
        var result = [],
            xData = [],
            DataLength = void 0;

        DataLength = data[data.length - 1].th * 1 + 2;
        var maxPos = DataLength;
        if (type === "shaojie") {
          maxPos = that.max_pt;
        } else {
          maxPos = that.max_dry;
        }
        if (maxPos > DataLength) {
          DataLength = maxPos;
        }

        var _loop = function _loop(i) {
          if (i === 0) {
            xData[i] = "0";
            result[i] = "30";
          } else if (i === DataLength - 1) {
            xData[i] = i + 1;
            result[i] = "30";
          } else {
            xData[i] = "-";
            result[i] = "-";
          }
          data.forEach(function (item, n) {
            if (i == item.th) {
              xData[i] = item.key;
              result[i] = item.data;
            }
          }, _this6);
        };

        for (var i = 0; i <= DataLength; i++) {
          _loop(i);
        }
        return { xData: xData, result: result };
      }

      try {
        this.chartsData.xAxisData = dataForEach(real[type]).xData;
        this.chartsData.realData = dataForEach(real[type]).result;
      } catch (error) {
        console.error({
          error: error,
          data: { real: real, stand: stand },
          msg: "标准参数echats图表数据解析失败"
        });
      }
      try {
        this.chartsData.standData = dataForEach(stand[type]).result;
      } catch (error) {
        console.error({
          error: error,
          data: { real: real, stand: stand },
          msg: "标准参数echats图表数据解析失败"
        });
      }

      this.$nextTick(function () {
        _this7.initChart(_this7.chartsData);
      });
    },
    initChart: function initChart(data) {
      var charts = void 0;
      if (this.$refs.charts) {
        charts = echarts.init(this.$refs.charts, charts, {
          height: 300
        });
      } else {
        return false;
      }

      var option = {
        baseOption: {
          tooltip: {
            show: true,
            trigger: "axis"
          },
          legend: {
            data: ["标准温度", "实时温度"],
            bottom: 0
          },
          xAxis: {
            show: false,
            data: data.xAxisData,
            axisLabel: {
              show: true,
              interval: function interval(index, value) {
                if (value == "NONE") {
                  return false;
                } else {
                  return true;
                }
              }
            }
          },
          yAxis: {
            axisLine: { show: false },
            splitLine: {
              show: true
            },
            axisTick: {
              show: false
            }
          },
          series: [{
            name: "标准温度",
            type: "line",
            data: data.standData,
            itemStyle: {
              normal: {
                color: "#76e191",
                borderWidth: 2
              }
            },
            smooth: "true",
            connectNulls: true,
            lineStyle: {
              normal: {
                width: "3"
              }
            }
          }, {
            name: "实时温度",
            type: "line",
            data: data.realData,
            itemStyle: {
              normal: {
                color: "#eb5650"
              }
            },
            smooth: "true",
            connectNulls: true,
            lineStyle: {
              normal: {
                width: "3"
              }
            }
          }]
        }
      };
      charts.setOption(option);
      this.charts = charts;
    },
    changeStandType: function changeStandType() {
      this.loadStandConf(false);
    },
    openSetStandType: function openSetStandType() {
      this.dialog.standType = true;
    },
    saveStandType: function saveStandType() {
      var _this8 = this;

      var payload = {
        brick_list: this.stand.list
      };
      var params = {
        device_id: this.deviceInfo.device_id,
        sys_alias: this.option.aliasNo.toString(),
        conf_type: "brick",
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(payload)
      };
      if (this.userInfo.identity === "USER") {
        params.auth_token = this.userInfo.token;
      } else {
        params.customer_token = this.userInfo.token;
      }
      __WEBPACK_IMPORTED_MODULE_5__lib_lib_js__["a" /* default */].api.setDeviceConf(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this8.$message.success("修改成功");
          _this8.dialog.standType = false;
          _this8.loadStandConf(false);
        } else {
          _this8.$message.error("修改失败");
        }
        console.log(data);
      });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_tempicon_svg__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_images_tempicon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_images_tempicon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_device_svg__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_images_no_device_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_images_no_device_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tempControl_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_lib__ = __webpack_require__(7);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: "deviceList",
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_3__components_tempControl_header___default.a
  },
  data: function data() {
    return {
      image1: __WEBPACK_IMPORTED_MODULE_1__assets_images_tempicon_svg___default.a,
      img_no_devices: __WEBPACK_IMPORTED_MODULE_2__assets_images_no_device_svg___default.a,
      deviceList: [],
      loading: true,
      dialog: {
        show: false,
        method: "device",
        name: "",
        device_sn: "",
        uuid: "",
        password: "",
        adminShow: false
      },
      typeName: {
        "温控": "5a3338e0aa22fb6a17cd77fb",
        "配水": "5a585accaa22fb4a9db5aa5a",
        "配煤": "5a585ad7aa22fb4a9db5aa5b"
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    deviceListType: function deviceListType(state) {
      return state.deviceListType;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    this.loadDeviceList();
  },

  methods: {
    loadDeviceList: function loadDeviceList() {
      var _this = this;

      var params = {
        customer_token: this.userInfo.token,
        page_no: 1,
        page_size: 20,
        category_id: this.deviceListType ? this.typeName[this.deviceListType] : ''
      };
      __WEBPACK_IMPORTED_MODULE_5__lib_lib__["a" /* default */].api.loadDevice(params, function (data) {
        _this.loading = false;
        if (data.status_code !== "SUCCEEDED") {
          _this.$message.error(data.msg);
        } else {
          _this.deviceList = data.payload;
          if (_this.deviceList.length && !_this.$route.query.sider) {
            var index = _this.findTypeDevice(data.payload).index,
                count = _this.findTypeDevice(data.payload).count;
            if (index !== "NONE" && count === 1) {
              _this.intoDevice(index);
            } else if (count > 1) {} else {
              if (_this.deviceListType) {
                _this.$message({
                  type: 'info', duration: 5000,
                  message: '您没有' + _this.deviceListType + '设备'
                });
                _this.$store.dispatch('setDeviceListType', '');
              }
            }
          } else if (_this.deviceList.length === 0) {
            _this.dialog.show = true;
          }
        }
      });
    },
    findTypeDevice: function findTypeDevice(list) {
      var _this2 = this;

      var index = "NONE",
          count = 0;
      list.forEach(function (item, i) {
        if (item.category === _this2.deviceListType) {
          index = i;
          count++;
        }
      });
      console.log(index);
      return { index: index, count: count };
    },
    openBindDevice: function openBindDevice(method) {
      var dialog = this.dialog;
      dialog.method = method;
      dialog.show = true;
    },
    customerBinding: function customerBinding() {
      var _this3 = this;

      var params = {
        customerId: this.userInfo.id,
        customer_token: this.userInfo.token,
        method: this.dialog.method
      };
      if (params.method === "account") {
        params.name = this.dialog.name;
        params.password = this.dialog.password;
        if (params.name * 1 < 1000) {
          this.dialog.adminShow = true;
          return false;
        }
        if (params.name * 1 < 1000) {
          this.$message.error("请输入密码");
          this.dialog.show = false;
          return false;
        }
      } else if (params.method === "device") {
        params.uuid = this.dialog.uuid;
      }
      __WEBPACK_IMPORTED_MODULE_5__lib_lib__["a" /* default */].api.bindDevice(params, function (data) {
        if (data.status_code === "SUCCEEDED") {
          _this3.$message.success("操作成功");
          _this3.dialog.show = false;
          _this3.loadDeviceList();
        } else {
          _this3.$message.error("" + data.msg);
        }
      });
    },
    intoDevice: function intoDevice(index) {
      var device = this.deviceList[index];
      this.$store.dispatch("setDeviceInfo", device);
      if (device.category === "温控") {
        if (this.isMobile) {
          this.$router.push({ path: "/MtempControl/realData" });
        } else {
          this.$router.push({ path: "/tempControl/realData" });
        }
      } else {
        this.$router.push({ path: "/allocate/realData" });
      }
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tempControl_header__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'msgList',
  components: {
    pageHeader: __WEBPACK_IMPORTED_MODULE_2__components_tempControl_header___default.a
  },
  data: function data() {
    return {

      checked: "",
      activeTab: "notice",
      msgList: 4
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    isMobile: function isMobile(state) {
      return state.isMobile;
    }
  })),
  created: function created() {},

  methods: {}

});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tempControl_header__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tempControl_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tempControl_header__);




/* harmony default export */ __webpack_exports__["default"] = ({

    name: 'setting',
    components: {
        pageHeader: __WEBPACK_IMPORTED_MODULE_0__components_tempControl_header___default.a
    },
    data: function data() {
        return {
            userInfo: {
                isEdit: false,
                name: "管理员",
                phone: "18888888888",
                email: "leemma@leemma.com",
                loading: false
            }

        };
    },

    methods: {
        editUser: function editUser() {
            var _this = this;

            if (this.userInfo.isEdit) {
                this.userInfo.loading = true;
                setTimeout(function () {
                    _this.$message({
                        message: '用户信息修改成功',
                        type: 'success'
                    });
                    _this.userInfo.loading = false;
                }, 1000);
            } else {}
            this.userInfo.isEdit = !this.userInfo.isEdit;
        }
    }

});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(160);



var load = __WEBPACK_IMPORTED_MODULE_0__common__["a" /* default */].load;

var api = {
  verifyCustom: function verifyCustom(params, callback) {
    var url = 'custom/verify';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  verifyUser: function verifyUser(params, callback) {
    var url = 'user/verify';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  bindDevice: function bindDevice(params, callback) {
    var url = '/customers' + (params.customerId ? '/' + params.customerId : '') + '/bind_device';
    load(url, params, function (data) {
      callback(data);
    }, 'POST');
  },
  loadDevice: function loadDevice(params, callback) {
    var url = '/devices' + (params.device_id ? '/' + params.device_id : '');
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  loadDeviceData: function loadDeviceData(params, callback) {
    var url = '/devices/' + params.device_id + '/data';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  loadDeviceConf: function loadDeviceConf(params, callback) {
    var url = '/devices/' + params.device_id + '/conf';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  setDeviceConf: function setDeviceConf(params, callback) {
    var url = '/devices/' + params.device_id + '/conf';
    load(url, params, function (data) {
      callback(data);
    }, 'post');
  },
  loadDeviceSetting: function loadDeviceSetting(params, callback) {
    var url = '/devices/' + params.device_id + '/settings';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  setDeviceSetting: function setDeviceSetting(params, callback) {
    var url = '/devices/' + params.device_id + '/settings';
    load(url, params, function (data) {
      callback(data);
    }, 'post');
  },
  loadDeviceName: function loadDeviceName(params, callback) {
    var url = '/devices/' + params.device_id + '/name';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  setDeviceName: function setDeviceName(params, callback) {
    var url = '/devices/' + params.device_id + '/name';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  setDeviceMsg: function setDeviceMsg(params, callback) {
    var url = '/devices/' + params.device_id + '/setinfo ';
    load(url, params, function (data) {
      callback(data);
    }, 'post');
  },
  exportProExcel: function exportProExcel(params, callback) {
    var url = '/devices/' + params.device_id + '/pro_export';
    load(url, params, function (data) {
      callback(data);
    }, 'get');
  },
  logout: function logout(params, callback) {
    var url = 'auth/logout';
    load(url, params, function (data) {
      callback(data);
    }, 'post');
  },
  wxGetAuthToken: function wxGetAuthToken(params, callback) {
    var url = 'wechat_authorize/code';
    console.log(params);
    load(url, params, function (data) {
      callback(data);
    }, 'GET');
  },
  setFrequency: function setFrequency(params, callback) {
    var url = 'devices/' + params.device_sn + '/frequency';
    console.log(params);
    load(url, params, function (data) {
      callback(data);
    }, 'POST');
  }
};
/* harmony default export */ __webpack_exports__["a"] = (api);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_css__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_store_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_lib__ = __webpack_require__(7);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = true;
function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';

  var name = vm._isVue ? vm.$options.name || vm.$options._componentTag : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options.__file ? ' at ' + vm.$options.__file : '');
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_8__store_store_js__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__ = __webpack_require__(64);



var actions = {
  setLoading: function setLoading(_ref, platform) {
    var commit = _ref.commit;

    commit('SET_LOADING', platform);
  },
  setIsMobile: function setIsMobile(_ref2, payload) {
    var commit = _ref2.commit;

    commit('SET_IS_MOBILE', payload);
  },
  toggleSide: function toggleSide(_ref3, data) {
    var commit = _ref3.commit,
        state = _ref3.state;

    var payload = {};
    payload.siderbarOpen = data ? data : !state.siderbarOpen;
    console.log(state.isMobile);
    if (state.isMobile) {} else {
      commit('TOGGLE_SILDER', payload);
    }
  },
  setUserInfo: function setUserInfo(_ref4, data) {
    var commit = _ref4.commit,
        state = _ref4.state;

    var payload = state.userInfo;
    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.assign(payload, data);
    __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].setItem("userInfo", payload);
    commit('SET_USER_INFO', payload);
  },
  setDeviceInfo: function setDeviceInfo(_ref5, data) {
    var commit = _ref5.commit,
        state = _ref5.state;

    var payload = data;
    if (payload.device_id && payload.device_id.$oid) {
      payload.device_id = payload.device_id.$oid;
    }
    __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].setItem("deviceInfo", payload);
    commit('SET_DEVICE_INFO', payload);
  },
  setDeviceListType: function setDeviceListType(_ref6, payload) {
    var commit = _ref6.commit;

    __WEBPACK_IMPORTED_MODULE_1__lib_LSstore__["a" /* default */].setItem("deviceListType", payload);
    commit('SET_DEVICE_LIST_TYPE', payload);
  },
  setStandData: function setStandData(_ref7, payload) {
    var commit = _ref7.commit;

    commit('SET_STAND_DATA', payload);
  },
  setPlayerData: function setPlayerData(_ref8, payload) {
    var commit = _ref8.commit;

    commit('SET_PLAYER_DATA', payload);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
    SET_LOADING: function SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    TOGGLE_SILDER: function TOGGLE_SILDER(state, payload) {
        state.siderbarOpen = payload.siderbarOpen;
    },
    SET_IS_MOBILE: function SET_IS_MOBILE(state, payload) {
        state.isMobile = payload;
    },
    SET_USER_INFO: function SET_USER_INFO(state, payload) {
        state.userInfo = payload;
    },
    SET_DEVICE_INFO: function SET_DEVICE_INFO(state, payload) {
        state.deviceInfo = payload;
    },
    SET_DEVICE_LIST_TYPE: function SET_DEVICE_LIST_TYPE(state, payload) {
        state.deviceListType = payload;
    },
    SET_STAND_DATA: function SET_STAND_DATA(state, payload) {
        state.standTempData = payload;
    },
    SET_PLAYER_DATA: function SET_PLAYER_DATA(state, payload) {
        state.playerData = payload;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var states = {
    config: {
        refreshInterval: 120000
    },

    isMobile: false,

    isLoading: false,

    siderbarOpen: true,

    userInfo: {
        token: "",
        identity: "",
        role: "" },

    deviceInfo: {},

    deviceListType: '',

    standTempData: [],

    playerData: []

};
/* harmony default export */ __webpack_exports__["a"] = (states);

/***/ }),
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */,
/* 848 */,
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 232,
	"./af.js": 232,
	"./ar": 239,
	"./ar-dz": 233,
	"./ar-dz.js": 233,
	"./ar-kw": 234,
	"./ar-kw.js": 234,
	"./ar-ly": 235,
	"./ar-ly.js": 235,
	"./ar-ma": 236,
	"./ar-ma.js": 236,
	"./ar-sa": 237,
	"./ar-sa.js": 237,
	"./ar-tn": 238,
	"./ar-tn.js": 238,
	"./ar.js": 239,
	"./az": 240,
	"./az.js": 240,
	"./be": 241,
	"./be.js": 241,
	"./bg": 242,
	"./bg.js": 242,
	"./bm": 243,
	"./bm.js": 243,
	"./bn": 245,
	"./bn-bd": 244,
	"./bn-bd.js": 244,
	"./bn.js": 245,
	"./bo": 246,
	"./bo.js": 246,
	"./br": 247,
	"./br.js": 247,
	"./bs": 248,
	"./bs.js": 248,
	"./ca": 249,
	"./ca.js": 249,
	"./cs": 250,
	"./cs.js": 250,
	"./cv": 251,
	"./cv.js": 251,
	"./cy": 252,
	"./cy.js": 252,
	"./da": 253,
	"./da.js": 253,
	"./de": 256,
	"./de-at": 254,
	"./de-at.js": 254,
	"./de-ch": 255,
	"./de-ch.js": 255,
	"./de.js": 256,
	"./dv": 257,
	"./dv.js": 257,
	"./el": 258,
	"./el.js": 258,
	"./en-au": 259,
	"./en-au.js": 259,
	"./en-ca": 260,
	"./en-ca.js": 260,
	"./en-gb": 261,
	"./en-gb.js": 261,
	"./en-ie": 262,
	"./en-ie.js": 262,
	"./en-il": 263,
	"./en-il.js": 263,
	"./en-in": 264,
	"./en-in.js": 264,
	"./en-nz": 265,
	"./en-nz.js": 265,
	"./en-sg": 266,
	"./en-sg.js": 266,
	"./eo": 267,
	"./eo.js": 267,
	"./es": 271,
	"./es-do": 268,
	"./es-do.js": 268,
	"./es-mx": 269,
	"./es-mx.js": 269,
	"./es-us": 270,
	"./es-us.js": 270,
	"./es.js": 271,
	"./et": 272,
	"./et.js": 272,
	"./eu": 273,
	"./eu.js": 273,
	"./fa": 274,
	"./fa.js": 274,
	"./fi": 275,
	"./fi.js": 275,
	"./fil": 276,
	"./fil.js": 276,
	"./fo": 277,
	"./fo.js": 277,
	"./fr": 280,
	"./fr-ca": 278,
	"./fr-ca.js": 278,
	"./fr-ch": 279,
	"./fr-ch.js": 279,
	"./fr.js": 280,
	"./fy": 281,
	"./fy.js": 281,
	"./ga": 282,
	"./ga.js": 282,
	"./gd": 283,
	"./gd.js": 283,
	"./gl": 284,
	"./gl.js": 284,
	"./gom-deva": 285,
	"./gom-deva.js": 285,
	"./gom-latn": 286,
	"./gom-latn.js": 286,
	"./gu": 287,
	"./gu.js": 287,
	"./he": 288,
	"./he.js": 288,
	"./hi": 289,
	"./hi.js": 289,
	"./hr": 290,
	"./hr.js": 290,
	"./hu": 291,
	"./hu.js": 291,
	"./hy-am": 292,
	"./hy-am.js": 292,
	"./id": 293,
	"./id.js": 293,
	"./is": 294,
	"./is.js": 294,
	"./it": 296,
	"./it-ch": 295,
	"./it-ch.js": 295,
	"./it.js": 296,
	"./ja": 297,
	"./ja.js": 297,
	"./jv": 298,
	"./jv.js": 298,
	"./ka": 299,
	"./ka.js": 299,
	"./kk": 300,
	"./kk.js": 300,
	"./km": 301,
	"./km.js": 301,
	"./kn": 302,
	"./kn.js": 302,
	"./ko": 303,
	"./ko.js": 303,
	"./ku": 304,
	"./ku.js": 304,
	"./ky": 305,
	"./ky.js": 305,
	"./lb": 306,
	"./lb.js": 306,
	"./lo": 307,
	"./lo.js": 307,
	"./lt": 308,
	"./lt.js": 308,
	"./lv": 309,
	"./lv.js": 309,
	"./me": 310,
	"./me.js": 310,
	"./mi": 311,
	"./mi.js": 311,
	"./mk": 312,
	"./mk.js": 312,
	"./ml": 313,
	"./ml.js": 313,
	"./mn": 314,
	"./mn.js": 314,
	"./mr": 315,
	"./mr.js": 315,
	"./ms": 317,
	"./ms-my": 316,
	"./ms-my.js": 316,
	"./ms.js": 317,
	"./mt": 318,
	"./mt.js": 318,
	"./my": 319,
	"./my.js": 319,
	"./nb": 320,
	"./nb.js": 320,
	"./ne": 321,
	"./ne.js": 321,
	"./nl": 323,
	"./nl-be": 322,
	"./nl-be.js": 322,
	"./nl.js": 323,
	"./nn": 324,
	"./nn.js": 324,
	"./oc-lnc": 325,
	"./oc-lnc.js": 325,
	"./pa-in": 326,
	"./pa-in.js": 326,
	"./pl": 327,
	"./pl.js": 327,
	"./pt": 329,
	"./pt-br": 328,
	"./pt-br.js": 328,
	"./pt.js": 329,
	"./ro": 330,
	"./ro.js": 330,
	"./ru": 331,
	"./ru.js": 331,
	"./sd": 332,
	"./sd.js": 332,
	"./se": 333,
	"./se.js": 333,
	"./si": 334,
	"./si.js": 334,
	"./sk": 335,
	"./sk.js": 335,
	"./sl": 336,
	"./sl.js": 336,
	"./sq": 337,
	"./sq.js": 337,
	"./sr": 339,
	"./sr-cyrl": 338,
	"./sr-cyrl.js": 338,
	"./sr.js": 339,
	"./ss": 340,
	"./ss.js": 340,
	"./sv": 341,
	"./sv.js": 341,
	"./sw": 342,
	"./sw.js": 342,
	"./ta": 343,
	"./ta.js": 343,
	"./te": 344,
	"./te.js": 344,
	"./tet": 345,
	"./tet.js": 345,
	"./tg": 346,
	"./tg.js": 346,
	"./th": 347,
	"./th.js": 347,
	"./tk": 348,
	"./tk.js": 348,
	"./tl-ph": 349,
	"./tl-ph.js": 349,
	"./tlh": 350,
	"./tlh.js": 350,
	"./tr": 351,
	"./tr.js": 351,
	"./tzl": 352,
	"./tzl.js": 352,
	"./tzm": 354,
	"./tzm-latn": 353,
	"./tzm-latn.js": 353,
	"./tzm.js": 354,
	"./ug-cn": 355,
	"./ug-cn.js": 355,
	"./uk": 356,
	"./uk.js": 356,
	"./ur": 357,
	"./ur.js": 357,
	"./uz": 359,
	"./uz-latn": 358,
	"./uz-latn.js": 358,
	"./uz.js": 359,
	"./vi": 360,
	"./vi.js": 360,
	"./x-pseudo": 361,
	"./x-pseudo.js": 361,
	"./yo": 362,
	"./yo.js": 362,
	"./zh-cn": 363,
	"./zh-cn.js": 363,
	"./zh-hk": 364,
	"./zh-hk.js": 364,
	"./zh-mo": 365,
	"./zh-mo.js": 365,
	"./zh-tw": 366,
	"./zh-tw.js": 366
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 849;

/***/ }),
/* 850 */,
/* 851 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAzCAYAAAD7JnqGAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1REZGMDI3QTIwNEYxMUU4QTRGQjgyRTRBNkE0NDIyMCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1REZGMDI3QjIwNEYxMUU4QTRGQjgyRTRBNkE0NDIyMCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVERkYwMjc4MjA0RjExRThBNEZCODJFNEE2QTQ0MjIwIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVERkYwMjc5MjA0RjExRThBNEZCODJFNEE2QTQ0MjIwIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+LjRJTgAAAXZJREFUeNrsmTFLA0EQhSeXIAgJljZ2doJVrGwtVES08R9YiFYprLQXBFvRykobq2gR/A1iZxorQRBsIqJgdbe+gxyEcW/cu0MQeQPfwc3uvv3gUmXEOSegBc7AK4h/4AF0hudCOABPAbnP4Cg7lz7GQN8Vr/0AqYsSuVeZ2KYrX5OGVLtC7npDRNryvS7BQPVmwbzqzYAX8Zcv9wY8qt4UWFG9uVQsUc0tcJpzWQ8sjbzXJL+cej8GOzl7D8Hu6NkIj1ht6hqX9dR7YuzVudfGXr0WR55NE0bAuJSvprHW0g2fWGQERBXECuVWuehXi2IUoxjFKEYxilGMYhSjGMUoRjGKUYxiFKMYxf6pmPUXeVLhrkK5PrE3I+CzgtiHsfbuE6ur3poRsFzgp6BzV429eq3e8ISfgAUJmyU54zI9ztkG0xI2S6qlYnee0I3Az9M31ny5i4G5t9m88r7E6G4vYF55XiK3m80rU5rDCe/gr0x4vwQYAGxt2wBUSVd2AAAAAElFTkSuQmCC"

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(924),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(846)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(932),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e9266872",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(921),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-603d3fd8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(793)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(889),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04ced10d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(908),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32300071",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(825)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(914),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-44ba38a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(808)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(902),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-251366eb",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(816)
  __webpack_require__(815)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(906),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30e42811",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(814)
  __webpack_require__(813)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(905),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f16141c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(812)
  __webpack_require__(811)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(904),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c8fc1f9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(801)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(896),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1cb5fbd9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(909),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-34f80642",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(843)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(929),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9c67f188",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(820)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(910),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-37ad8c1d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(794)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(890),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(797)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(892),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f197275",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(836)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-652ad812",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(817)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(907),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3142f332",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(803)
  __webpack_require__(802)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(897),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1d60ee61",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(900),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-226b69d6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(810)
  __webpack_require__(809)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(903),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2656df16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(796)
  __webpack_require__(795)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(891),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d6404e8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(829)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4888d000",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-634c7ab2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(920),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-508d70fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(832)
  __webpack_require__(831)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(919),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4be15328",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(827)
  __webpack_require__(826)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-483e5760",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(842)
  __webpack_require__(841)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-9711c76c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(838)
  __webpack_require__(837)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(925),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bdb261a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(807)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(901),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-24e80b0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(822)
  __webpack_require__(821)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(911),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-384aa077",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(799)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(894),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-130bda88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "wx-loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.content))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "standardSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.aliasNo),
      callback: function($$v) {
        _vm.option.aliasNo = $$v
      },
      expression: "option.aliasNo"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), (_vm.stand.list && _vm.stand.list.length) ? _c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "请选择砖类型"
    },
    on: {
      "change": _vm.changeStandType
    },
    model: {
      value: (_vm.stand.type),
      callback: function($$v) {
        _vm.stand.type = $$v
      },
      expression: "stand.type"
    }
  }, [_c('div', {
    staticClass: "set-stand-type-name",
    on: {
      "click": _vm.openSetStandType
    }
  }, [_vm._v("\n                            设置砖类型名称\n                        ")]), _vm._v(" "), _vm._l((_vm.stand.list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": index + ':' + item[index],
        "value": index
      }
    })
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "charts-input"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.loadStandConf(false)
      }
    }
  }, [_vm._v("刷新数据")])], 1)])], 1), _vm._v(" "), [(_vm.loading.standard) ? _c('div', {
    staticClass: "box-card m-card css-margin-top no-padding"
  }, [_c('loading')], 1) : _vm._l((_vm.standConf), function(itemType, key) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (itemType && itemType.length && (key === 'shaojie' || key === 'honggan')),
        expression: "itemType&&itemType.length&&(key==='shaojie'||key==='honggan')"
      }],
      key: key,
      staticClass: "m-card"
    }, [_c('div', {
      staticClass: "clearfix chars-header"
    }, [_c('span', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(_vm.confTypeName[key]) + "\n                "), _c('span', [_vm._v("（单位：℃)")])]), _vm._v(" "), _c('div', [(!_vm.isEdit) ? _c('el-button', {
      attrs: {
        "type": "success",
        "size": "small",
        "plain": ""
      },
      on: {
        "click": _vm.openEdit
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "loading": _vm.loading.standard,
        "type": "success",
        "plain": ""
      },
      on: {
        "click": function($event) {
          _vm.saveStandConf(true)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.loading.standard ? '正在加载' : '同步设置至设备') + "\n                    ")])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "card-body"
    }, [_c('div', {
      staticClass: "m-table"
    }, _vm._l((itemType), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "m-table-tr"
      }, [_c('div', {
        staticClass: "m-table-th"
      }, [_vm._v("\n                            " + _vm._s(item.key) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "m-table-td"
      }, [(!_vm.isEdit) ? _c('p', [_vm._v(_vm._s(item.data))]) : _c('el-input', {
        model: {
          value: (item.data),
          callback: function($$v) {
            item.data = $$v
          },
          expression: "item.data"
        }
      })], 1)])
    }))])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.echarts),
      expression: "!loading.echarts"
    }],
    staticClass: "box-card  css-margin-top quxian m-card"
  }, [_vm._m(0), _vm._v(" "), (!_vm.oldConf) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', [_c('div', {
    staticClass: "table-time"
  }, [_vm._v("\n                    " + _vm._s(_vm.option.time_stamp && _vm.option.time_stamp) + "\n                ")]), _vm._v(" "), _c('div', {
    ref: "charts"
  })])])], _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "砖类型设置",
      "visible": _vm.dialog.standType,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog.standType = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "label-width": "30px"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": index.toString()
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "砖类型"
      },
      model: {
        value: (item[index]),
        callback: function($$v) {
          var $$exp = item,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            item[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "item[index]"
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.saveStandType
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.standType = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('Mconfirm', {
    attrs: {
      "show": _vm.isEdit && !_vm.loading.standard
    },
    on: {
      "cancel": _vm.closeEdit,
      "define": _vm.openEdit
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("标准参数对比曲线\n\n                ")])])
}]}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeOption('true')
        }
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "charts-input"
    }, [_c('el-button', {
      attrs: {
        "loading": _vm.loading,
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.changeOption(false)
        }
      }
    }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '刷新数据'))])], 1)
  ], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('div', {
    staticClass: "box-card m-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数列表")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                    " + _vm._s(_vm.timeShow) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "m-table"
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      staticClass: "m-table-li"
    }, [_c('div', {
      staticClass: "m-table-label"
    }, [_vm._v("\n                                " + _vm._s(item.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "m-table-input"
    }, [_c('div', {
      staticClass: "edit-input"
    }, [_c('p', [_vm._v(_vm._s(item.data))])])])])
  }))])]], 2)])])
},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "msg-menu"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        通知与公告\n    ")]), _vm._v(" "), _vm._l((_vm.msgList), function(msg) {
    return _c('div', {
      staticClass: "msg-item"
    }, [_c('i', {
      staticClass: "iconfont",
      class: {
        'icon-warning1': msg.type === 'warning', 'icon-remind1': msg.type === 'remind1', 'icon-information': msg.type === 'information',
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(msg.msg))]), _vm._v(" "), _c('p', {
      staticClass: "time"
    }, [_vm._v(_vm._s(msg.time))])])
  }), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/user/msgList"
    }
  }, [_vm._v("查看更多")])], 1)], 2)
},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "setting"
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.userInfo.loading),
      expression: "userInfo.loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix card-heard"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("个人信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.userInfo.isEdit ? "完成" : "编辑") + "\n                ")])], 1), _vm._v(" "), (_vm.userInfo.isEdit) ? _c('div', {
    staticClass: "user-info"
  }, [_c('el-form', {
    attrs: {
      "label-position": "right",
      "label-width": "80px",
      "model": _vm.userInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userInfo.name),
      callback: function($$v) {
        _vm.userInfo.name = $$v
      },
      expression: "userInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userInfo.email),
      callback: function($$v) {
        _vm.userInfo.email = $$v
      },
      expression: "userInfo.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.userInfo.phone),
      callback: function($$v) {
        _vm.userInfo.phone = $$v
      },
      expression: "userInfo.phone"
    }
  })], 1)], 1)], 1) : _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 姓名")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.userInfo.name))])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 邮箱")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.userInfo.email))])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 联系电话")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.userInfo.phone))])])])]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix card-heard"
  }, [_c('span', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("\n                    编辑\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 旧密码:")]), _vm._v(" "), _c('span', [_vm._v(" 13213132")])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 密码:")]), _vm._v(" "), _c('span', [_vm._v(" 13213132")])]), _vm._v(" "), _c('div', {
    staticClass: "display-input"
  }, [_c('span', [_vm._v(" 验证密码:")]), _vm._v(" "), _c('span', [_vm._v(" 13213132")])])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aside content"
  }, [_c('div', [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.isMobile ? _vm.image_logo_64 : _vm.image_logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "side-list"
  }, [_vm._l((_vm.sideList.tempControl), function(item) {
    return (_vm.router === 'TEMP' && item.show) ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.sideList.MtempControl), function(item) {
    return (_vm.router === 'MTEMP' && item.show) ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.sideList.allocateWater), function(item) {
    return (_vm.router === 'WATER' && item.show) ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }), _vm._v(" "), (_vm.router === 'USER') ? _vm._l((_vm.sideList.user), function(item) {
    return _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom-menu"
  }, [(_vm.userInfo.identity === 'CUSTOMER') ? _vm._l((_vm.sideList.bottom), function(item) {
    return ((item.path !== '/user?sider=true' || _vm.router !== 'USER') && item.identity === 'CUSTOMER') ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }) : _vm._e(), _vm._v(" "), (_vm.userInfo.identity === 'USER') ? _vm._l((_vm.sideList.bottom), function(item) {
    return (item.identity === 'USER') ? _c('div', {
      key: item.path,
      staticClass: "side-item",
      class: {
        'is-active': _vm.$route.path == item.path
      },
      on: {
        "click": function($event) {
          _vm.handleSelect(item.path)
        }
      }
    }, [_c('p', [(!_vm.isMobile) ? _c('i', {
      staticClass: "iconfont",
      class: item.icon
    }) : _vm._e(), _vm._v(_vm._s(item.name))])]) : _vm._e()
  }) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [void 0, _vm._v(" "), _c('div', {
    staticClass: "charts-input"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.loadControlConf(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '手动刷新'))])], 1)], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数设置")]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                        " + _vm._s(_vm.option.time_stamp) + "\n                    ")]), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.option.isEdit),
      expression: "!option.isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.isEdit),
      expression: "option.isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.isEdit),
      expression: "option.isEdit"
    }],
    attrs: {
      "loading": _vm.loading,
      "type": "success"
    },
    on: {
      "click": _vm.saveDeviceConf
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.loading ? '正在加载' : '保存并写入设备') + "\n                        ")])], 1)]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.confData.slice(0, Math.round(_vm.confData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.data))]) : _c('el-input-number', {
            attrs: {
              "disabled": !_vm.option.isEdit,
              "precision": scope.row.precision,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": _vm.checkInputNumber
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          })], 1)]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.confData.slice(Math.round(_vm.confData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.data))]) : _c('el-input-number', {
            attrs: {
              "precision": scope.row.precision,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": _vm.checkInputNumber
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          })], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.confData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', {
            staticStyle: {
              "font-size": "14px"
            }
          }, [_vm._v(_vm._s(scope.row.name))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.data))]) : _c('el-input-number', {
            attrs: {
              "size": "small",
              "precision": scope.row.precision,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": _vm.checkInputNumber
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          })], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "his-data"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.loadHisData
    },
    model: {
      value: (_vm.option.sys_alias),
      callback: function($$v) {
        _vm.option.sys_alias = $$v
      },
      expression: "option.sys_alias"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.hisData.timeType),
      callback: function($$v) {
        _vm.hisData.timeType = $$v
      },
      expression: "hisData.timeType"
    }
  }, _vm._l((_vm.timeOpt), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  })), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin": "0 10px",
      "border-radius": "4px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading.table
    },
    on: {
      "click": function($event) {
        _vm.loadHisData()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.loading.table ? '正在加载' : '刷新数据') + "\n                  ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.chartsData.xData.length > 0) ? _c('div', {
    staticClass: "box-card m-card css-margin-top"
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("产量图表")])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.chart),
      expression: "loading.chart"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.chart),
      expression: "!loading.chart"
    }]
  }, [(_vm.chartsData.xData.length == 0) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', {
    ref: "charts"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-card box-card  css-margin-top no-padding"
  }, [_c('div', {
    staticClass: "clearfix chars-header",
    slot: "header"
  }, [_c('div', {
    staticStyle: {
      "align-items": "baseline",
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("产量报表")]), _vm._v(" "), _c('data-picker', {
    attrs: {
      "type": _vm.option.dateType === 'date' ? 'day' : _vm.option.dateType
    },
    on: {
      "input": _vm.changeOption
    },
    model: {
      value: (_vm.option.date),
      callback: function($$v) {
        _vm.option.date = $$v
      },
      expression: "option.date"
    }
  })], 1), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "success",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.clickExcel
    }
  }, [_vm._v("下载Excel")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0",
      "position": "relative"
    }
  }, [(_vm.loading.table) ? _c('div', [_c('loading')], 1) : _c('div', {
    ref: "hisTable",
    staticClass: "table-responsive"
  }, [(_vm.hisData.data.length) ? _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableHeader), function(th) {
    return _c('th', {
      key: th.id
    }, [_vm._v(_vm._s(th.name))])
  }))]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hisData.data), function(td, index) {
    return _c('tr', {
      key: td.id
    }, _vm._l((_vm.tableHeader), function(th) {
      return _c('td', {
        key: th.id
      }, [(th.key === "leiji") ? _c('span', [_vm._v(_vm._s(index + 1))]) : (th.key === "startDate") ? _c('span', [_vm._v(_vm._s(_vm.momentDay(td[th.key])))]) : (th.key === "date" && _vm.hisData.timeType !== "by_month") ? _c('span', [_vm._v(_vm._s(_vm.momentYear(td[th.key])))]) : (th.key === "rate" || th.key === "heat" || th.key === "interval") ? _c('span', [_vm._v(_vm._s(td[th.key] ? (td[th.key].toFixed(0)) : 0))]) : _c('span', [_vm._v(_vm._s(td[th.key] ? td[th.key] : 0))])])
    }))
  }), _vm._v(" "), (_vm.hisData.timeType !== "by_day") ? _c('tr', [_c('td', [_vm._v("平均")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.hisData.average.interval ? _vm.hisData.average.interval.toFixed(0) : 0) + "\n                                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.hisData.average.counter ? _vm.hisData.average.counter.toFixed(0) : 0) + "\n                                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.hisData.average.heat ? _vm.hisData.average.heat.toFixed(2) : 0) + "\n                                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                                      " + _vm._s(_vm.hisData.average.rate ? _vm.hisData.average.rate.toFixed(2) : 0) + "\n                                  ")])]) : _vm._e()], 2)]) : _c('div', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("\n                              暂无数据\n                          ")])]), _vm._v(" "), (_vm.isMobile && _vm.hisData.data.length) ? _c('div', {
    staticClass: "arrow"
  }) : _vm._e()])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "size": "large",
      "visible": _vm.excelModal.show
    },
    on: {
      "update:visible": function($event) {
        _vm.excelModal.show = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("微信端无法下载文件，请到电脑端下载。")]), _vm._v(" "), _c('p', [_vm._v("或者提供我们有效的邮箱号码，\n                  届时文件将发送至您的邮箱。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "max-width": "250px",
      "padding-top": "10px",
      "text-align": "center",
      "margin": "0 auto"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入邮箱"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.excelModal.show = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.excelModal.show = false
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "loading"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
}]}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input",
    on: {
      "click": _vm.initShowType
    }
  }, [_vm._v("\n    " + _vm._s(_vm.inputTime) + "\n  ")]), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "picker-mask"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "picker-content",
    class: {
      active: _vm.isShow
    }
  }, [_c('div', {
    staticClass: "picker-header"
  }, [_c('p', {
    on: {
      "click": function($event) {
        _vm.isShow = false
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.sureDate
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    staticClass: "picker-nav"
  }, [(_vm.showType.year) ? _c('div', [_vm._v("年")]) : _vm._e(), _vm._v(" "), (_vm.showType.month) ? _c('div', [_vm._v("月")]) : _vm._e(), _vm._v(" "), (_vm.showType.day) ? _c('div', [_vm._v("日")]) : _vm._e(), _vm._v(" "), (_vm.showType.hour) ? _c('div', [_vm._v("时")]) : _vm._e(), _vm._v(" "), (_vm.showType.minute) ? _c('div', [_vm._v("分")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "picker-body"
  }, [(_vm.showType.year) ? _c('div', {
    staticClass: "picker year",
    on: {
      "touchend": function($event) {
        _vm.touchend('year', $event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.touchStart('year', $event)
      },
      "touchmove": function($event) {
        _vm.touchMove('year', $event)
      }
    }
  }, [_c('div', {
    staticClass: "picker-selected"
  }), _vm._v(" "), _c('div', {
    staticClass: "picker-list",
    style: (_vm.touchArgv.year)
  }, _vm._l((_vm.year), function(m) {
    return _c('div', {
      key: m
    }, [_vm._v(_vm._s(m))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showType.month) ? _c('div', {
    staticClass: "picker month",
    on: {
      "touchend": function($event) {
        _vm.touchend('month', $event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.touchStart('month', $event)
      },
      "touchmove": function($event) {
        _vm.touchMove('month', $event)
      }
    }
  }, [_c('div', {
    staticClass: "picker-selected"
  }), _vm._v(" "), _c('div', {
    staticClass: "picker-list",
    style: (_vm.touchArgv.month)
  }, _vm._l((_vm.month), function(m) {
    return _c('div', {
      key: m
    }, [_vm._v(_vm._s(m))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showType.day) ? _c('div', {
    staticClass: "picker day",
    on: {
      "touchend": function($event) {
        _vm.touchend('day', $event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.touchStart('day', $event)
      },
      "touchmove": function($event) {
        _vm.touchMove('day', $event)
      }
    }
  }, [_c('div', {
    staticClass: "picker-selected"
  }), _vm._v(" "), _c('div', {
    staticClass: "picker-list",
    style: (_vm.touchArgv.day)
  }, _vm._l((_vm.day), function(m) {
    return _c('div', {
      key: m
    }, [_vm._v(_vm._s(m))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showType.hour) ? _c('div', {
    staticClass: "picker hour",
    on: {
      "touchend": function($event) {
        _vm.touchend('hour', $event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.touchStart('hour', $event)
      },
      "touchmove": function($event) {
        _vm.touchMove('hour', $event)
      }
    }
  }, [_c('div', {
    staticClass: "picker-selected"
  }), _vm._v(" "), _c('div', {
    staticClass: "picker-list",
    style: (_vm.touchArgv.hour)
  }, _vm._l((_vm.hour), function(m) {
    return _c('div', {
      key: m
    }, [_vm._v(_vm._s(m))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showType.minute) ? _c('div', {
    staticClass: "picker minuer",
    on: {
      "touchend": function($event) {
        _vm.touchend('minute', $event)
      },
      "touchstart": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.touchStart('minute', $event)
      },
      "touchmove": function($event) {
        _vm.touchMove('minute', $event)
      }
    }
  }, [_c('div', {
    staticClass: "picker-selected"
  }), _vm._v(" "), _c('div', {
    staticClass: "picker-list",
    style: (_vm.touchArgv.minute)
  }, _vm._l((_vm.minute), function(m) {
    return _c('div', {
      key: m
    }, [_vm._v(_vm._s(m))])
  }))]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tempControl"
    }
  }, [_c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [_c('page-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }]
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('page-footer', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-header'), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    staticClass: "device-list"
  }, [_vm._l((_vm.deviceList), function(item, index) {
    return _c('div', {
      key: item.device_id.$oid,
      staticClass: "device-item",
      on: {
        "click": function($event) {
          _vm.intoDevice(index)
        }
      }
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix card-heard"
    }, [_c('span', {
      staticStyle: {
        "line-height": "36px"
      }
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', {
      staticClass: "device-info"
    }, [_c('div', [_c('p', [_c('span', {
      staticClass: "s-label"
    }, [_vm._v("DTU号")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.device_sn))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s-label"
    }, [_vm._v("状态 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.device_status))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "s-label"
    }, [_vm._v("类型 ")]), _vm._v(" "), _c('span', [(item.category === '温控') ? _c('el-tag', {
      attrs: {
        "type": "danger"
      }
    }, [_vm._v(_vm._s(item.category))]) : _vm._e(), _vm._v(" "), (item.category === '配煤') ? _c('el-tag', {
      attrs: {
        "type": "info"
      }
    }, [_vm._v(_vm._s(item.category))]) : _vm._e(), _vm._v(" "), (item.category === '配水') ? _c('el-tag', [_vm._v(_vm._s(item.category))]) : _vm._e()], 1)])]), _vm._v(" "), _c('img', {
      attrs: {
        "src": _vm.image1,
        "alt": ""
      }
    })])])], 1)
  }), _vm._v(" "), (_vm.deviceList && _vm.deviceList.length) ? _c('div', {
    staticClass: "device-item"
  }, [_c('div', {
    staticClass: "add-new-device",
    on: {
      "click": function($event) {
        _vm.openBindDevice('device')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-dms-add_dashed"
  }), _vm._v(" "), _c('p', [_vm._v("添加新设备")])])]) : _vm._e()], 2), _vm._v(" "), (!_vm.loading && _vm.deviceList.length <= 0) ? _c('div', {
    staticClass: "no-device"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_devices,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noItem-button-group"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('device')
      }
    }
  }, [_vm._v("绑定设备")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('account')
      }
    }
  }, [_vm._v("绑定已有账号")])], 1)]) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": _vm.isMobile ? "large" : "small",
      "title": _vm.dialog.method === 'account' ? '绑定账号' : '添加设备',
      "visible": _vm.dialog.show
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog.show = $event
      }
    }
  }, [_c('el-form', {
    ref: "dialog",
    attrs: {
      "model": _vm.dialog
    }
  }, [(_vm.dialog.method === 'account') ? _c('el-form-item', {
    attrs: {
      "label": "原平台账号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "services.leemma.com账号"
    },
    model: {
      value: (_vm.dialog.name),
      callback: function($$v) {
        _vm.dialog.name = $$v
      },
      expression: "dialog.name"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialog.adminShow),
      expression: "dialog.adminShow"
    }],
    staticClass: "input-tips"
  }, [_vm._v("利马管理人员请登录"), _c('a', {
    attrs: {
      "href": "https://services.leemma.com"
    }
  }, [_vm._v("https://services.leemma.com")])])], 1) : _vm._e(), _vm._v(" "), (_vm.dialog.method === 'account') ? _c('el-form-item', {
    attrs: {
      "label": "密码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "services.leemma.com密码"
    },
    model: {
      value: (_vm.dialog.password),
      callback: function($$v) {
        _vm.dialog.password = $$v
      },
      expression: "dialog.password"
    }
  })], 1) : [_c('el-form-item', {
    attrs: {
      "label": "设备激活码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.dialog.uuid),
      callback: function($$v) {
        _vm.dialog.uuid = $$v
      },
      expression: "dialog.uuid"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v("联系利马客服获取您的设备激活码 "), _c('a', {
    attrs: {
      "href": "tel:18030536882"
    }
  }, [_vm._v("18030536882(周星)")])])], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [(_vm.dialog.method === 'account') ? _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('device')
      }
    }
  }, [_vm._v("没有账号？绑定新设备")]) : _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.openBindDevice('account')
      }
    }
  }, [_vm._v("绑定已有账号")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.customerBinding
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deviceConf"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', {
    staticClass: "charts-input"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.loadDeviceConf(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '手动刷新'))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top controlSet"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": ""
    }
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("设备配置表")]), _vm._v(" "), _c('span', {
    staticClass: "time-show"
  }, [_vm._v(_vm._s(_vm.deviceConf.time_stamp))]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.loading) ? _c('div', [(!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.deviceConf.data.slice(0, Math.round(_vm.deviceConf.data.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', [_vm._v(_vm._s(_vm.deviceConfName[scope.row.name]))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.isEdit) ? _c('el-input', {
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.deviceConf.data.slice(Math.round(_vm.deviceConf.data.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', [_vm._v(_vm._s(_vm.deviceConfName[scope.row.name]))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.isEdit) ? _c('el-input', {
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.deviceConf.data
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', [_vm._v(_vm._s(_vm.deviceConfName[scope.row.name]))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]) : _c('loading')], 1)], 1), _vm._v(" "), (_vm.deviceName.data.length) ? _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": ""
    }
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("设备名称表")])]), _vm._v(" "), _c('div', _vm._l((_vm.deviceName.data), function(name) {
    return _c('div', {
      staticClass: "device-name-item"
    }, [_vm._v("\n                    " + _vm._s(name) + "\n                ")])
  }))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "realData"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "mobile-top-bar"
  }, [_c('div', {
    staticClass: "option-select"
  }, [_c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.sys_alias),
      callback: function($$v) {
        _vm.option.sys_alias = $$v
      },
      expression: "option.sys_alias"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "charts-input",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.loading.realData,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.loadRealDataFn('show')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.loading.realData ? '加载中' : '刷新数据') + "\n                    ")])], 1)])])], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card  quxian"
  }, [_c('div', [_c('div', {
    staticClass: "clearfix real-charts-header drop-header"
  }, [_c('span', [_vm._v("\n                    工艺曲线\n                    "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openPlayer
    }
  }, [_vm._v("播放24小时温度数据")])], 1), _vm._v(" "), (!_vm.loading.realData && _vm.isMobile) ? _c('p', {
    staticClass: "time-show-mobile-xl"
  }, [_vm._v("\n                    " + _vm._s(_vm.tableData && _vm.tableData.time_stamp) + _vm._s(_vm.stand.list.length &&
    _vm.stand.list[_vm.stand.type][_vm.stand.type]) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.openTimePicker
    }
  }, [_vm._v(_vm._s(_vm.timeLineData.show ? '关闭' : '历史数据') + "\n                ")])], 1), _vm._v(" "), _c('div', [_c('drop-time-picker', {
    attrs: {
      "show": _vm.timeLineData.show,
      "loading": _vm.loading.hisData,
      "data": _vm.hisData
    },
    on: {
      "selectDate": _vm.changeDate,
      "selectItem": _vm.selectHisData,
      "selectButtonChartsFn": _vm.selectButtonChartsFn
    }
  })], 1), _vm._v(" "), (_vm.loading.realData) ? _c('div', [_c('loading')], 1) : (!_vm.hisData.length && !_vm.tableData && !_vm.loading.realData) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.loading.realData && _vm.isMobile) ? _c('p', {
    staticClass: "time-show-mobile"
  }, [_vm._v("\n                    " + _vm._s(_vm.tableData && _vm.tableData.time_stamp) + _vm._s(_vm.stand.list.length &&
    _vm.stand.list[_vm.stand.type][_vm.stand.type]) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "charts",
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "name": "charts",
      "id": "charts"
    }
  }, [_c('div', {
    ref: "shaojie"
  }), _vm._v(" "), _c('div', {
    ref: "honggan"
  })]), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "edit-stand-mobile"
  }, [(!_vm.stand.edit && _vm.userInfo.identity == 'USER') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.openStandEdit
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#charts"
    }
  }, [_vm._v("开始修改标准参数")])]) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-list"
  }, [_c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.stand.edit) ? _c('div', {
    staticClass: "vfor-list"
  }, [_vm._l((_vm.stand.data), function(itemType, key) {
    return (key === 'shaojie' || key === 'honggan') ? [_c('div', {
      key: key,
      staticClass: "m-card"
    }, [_c('div', {
      staticClass: "clearfix chars-header"
    }, [_c('span', {
      staticClass: "card-header-title"
    }, [_vm._v("设置标准参数-" + _vm._s(_vm.tableTypeName[key]))]), _vm._v(" "), (!_vm.isMobile) ? _c('div', [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": _vm.openStandEdit
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "loading": _vm.loading.standConf,
        "type": "success"
      },
      on: {
        "click": _vm.setStandConf
      }
    }, [_vm._v("保存\n                                ")])], 1) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
      staticClass: "card-body table-responsive "
    }, [_c('div', {
      staticClass: "m-table"
    }, [_vm._l((itemType), function(item) {
      return _c('div', {
        key: item.id,
        staticClass: "m-table-tr"
      }, [_c('div', {
        staticClass: "m-table-th"
      }, [_vm._v("\n                                        " + _vm._s(item.key) + "\n                                    ")]), _vm._v(" "), _c('div', {
        staticClass: "m-table-td"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.data),
          expression: "item.data"
        }],
        staticStyle: {
          "width": "89%",
          "text-align": "center"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.data)
        },
        on: {
          "change": _vm.editStandInput,
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.data = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      })])])
    }), _vm._v(" "), (itemType.length % 2 !== 0) ? _c('div', {
      staticClass: "m-table-tr"
    }, [_c('div', {
      staticClass: "m-table-th"
    }), _vm._v(" "), _c('div', {
      staticClass: "m-table-td"
    })]) : _vm._e()], 2)])])] : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.tableData) ? _c('div', {
    staticClass: "vfor-list"
  }, [
    [_c('div', {
      staticClass: "m-card"
    }, [_c('div', {
      staticClass: "card-body table-responsive "
    }, [_c('div', {
      staticClass: "m-leemma-table"
    }, [_vm._l((_vm.tableData), function(itemType, key) {
      return (itemType && itemType.length && key !== 'time_stamp') ? [_c('div', {
        key: key,
        staticClass: "m-leemma-table-tr m-leemma-table-title"
      }, [(key === 'fengji') ? _c('div', {
        staticClass: "fengji"
      }, [_c('span', [_vm._v(_vm._s(_vm.tableTypeName[key]))]), _vm._v(" "), _c('span', {
        on: {
          "click": _vm.openFengjiEdit
        }
      }, [_c('el-button', {
        attrs: {
          "type": "text"
        }
      }, [_vm._v("修改")])], 1)]) : _c('div', {}, [_vm._v(_vm._s(_vm.tableTypeName[key]))])]), _vm._v(" "), _vm._l((itemType), function(item) {
        return _c('div', {
          key: item.id,
          staticClass: "m-leemma-table-tr"
        }, [_c('div', {
          staticClass: "m-leemma-table-th"
        }, [_vm._v("\n                                        " + _vm._s(_vm.dealTableKeyName(item.key)) + "\n\n                                    ")]), _vm._v(" "), _c('div', {
          staticClass: "m-leemma-table-td",
          class: {
            'font-red': item.data > 800
          }
        }, [_vm._v("\n                                        " + _vm._s((item.data > 1200 || item.data < -500) ? "----" : item.data) + "\n                                    ")])])
      })] : _vm._e()
    })], 2)])])]
  ], 2) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改风机频率",
      "visible": _vm.fengji.show,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.fengji.show = $event
      }
    }
  }, [_c('div', {
    staticClass: "fengji-dialog"
  }, [_c('div', [_c('p', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("选择风机")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "选择风机"
    },
    on: {
      "change": _vm.selectFenji
    },
    model: {
      value: (_vm.fengji.selected),
      callback: function($$v) {
        _vm.fengji.selected = $$v
      },
      expression: "fengji.selected"
    }
  }, _vm._l((_vm.realData.fengji), function(opt, index) {
    return _c('el-option', {
      key: opt.key,
      attrs: {
        "label": opt.key,
        "value": index
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('p', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("设置频率")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.fengji.payload.fjPl),
      callback: function($$v) {
        _vm.fengji.payload.fjPl = _vm._n($$v)
      },
      expression: "fengji.payload.fjPl"
    }
  })], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.fengji.payload.flag),
      callback: function($$v) {
        _vm.fengji.payload.flag = $$v
      },
      expression: "fengji.payload.flag"
    }
  }, [_vm._v("软手动")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFenji
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('Mconfirm', {
    attrs: {
      "show": _vm.stand.edit
    },
    on: {
      "cancel": _vm.openStandEdit,
      "define": _vm.setStandConf
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-realData",
    class: {
      'pc-realData': !_vm.isMobile
    }
  }, [_c('div', {
    staticClass: "realData"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          实时数据\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "state",
    class: {
      'state-off': _vm.deviceInfo.device_status !== '在线'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "device-statue"
  }, [_vm._v("\n          " + _vm._s(_vm.deviceInfo.device_status) + "\n        ")]), _vm._v(" "), (_vm.realData.alarm) ? [_c('div', {
    staticClass: "state state-error"
  }), _vm._v(" "), _c('div', {
    staticClass: "device-statue",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.realData.alarm) + "\n          ")])] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', {
    staticClass: "charts-input"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.realData
    },
    on: {
      "click": function($event) {
        _vm.loadFreashData()
      }
    }
  }, [_vm._v("刷新数据")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', {
    staticClass: "his-data"
  }, [_c('el-button', {
    on: {
      "click": _vm.toogleDrop
    }
  }, [_vm._v(_vm._s(_vm.dropList.show ? '关闭' : '展开历史数据列表'))]), _vm._v(" "), _c('div', {
    staticClass: "data-time"
  }, [_vm._v("\n          " + _vm._s(_vm.tableData.time_stamp) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "drop-list"
  }, [_c('dropList', {
    attrs: {
      "show": _vm.dropList.show,
      "data": _vm.hisDataList,
      "type": "ALLOCATE"
    },
    on: {
      "selectItem": _vm.selectItem,
      "selectDate": _vm.selectDate
    }
  })], 1)]), _vm._v(" "), _c('WxLoading', {
    attrs: {
      "show": _vm.loading.auto
    }
  }), _vm._v(" "), (_vm.loading.realData) ? _c('div', {
    staticClass: "vfor-list"
  }, [_c('el-card', {
    staticClass: "box-card vfor-card no-padding"
  }, [_c('loading')], 1)], 1) : _c('div', {
    staticClass: "m-card"
  }, [_c('div', {
    staticClass: "card-body water-table"
  }, [_c('div', [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "setting-th"
  }, [_c('span', [_vm._v("设定值")]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? _c('div', [(_vm.edit.type === 'CLOSE') ? _c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "size": _vm.isMobile ? 'mini' : 'small'
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v("编辑\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.edit.type === 'OPEN') ? _c('el-button', {
    attrs: {
      "loading": _vm.loading.confData,
      "type": "success",
      "size": _vm.isMobile ? 'mini' : 'small'
    },
    on: {
      "click": _vm.saveConf
    }
  }, [_vm._v(_vm._s(_vm.loading.confData ? '正在通信' : '保存') + "\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.edit.type === 'OPEN') ? _c('el-button', {
    attrs: {
      "type": "text",
      "size": _vm.isMobile ? 'mini' : 'small'
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("取消\n                    ")]) : _vm._e()], 1) : _vm._e()])])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("原料/煤料")]), _vm._v(" "), (_vm.loading.confData) ? _c('td', [_vm._v("正在通信")]) : (_vm.edit.type === 'CLOSE') ? _c('td', [_vm._v(_vm._s(_vm.confData['煤料设定标准份数']))]) : _c('td', [_c('el-input', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.confData['煤料设定标准份数']),
      callback: function($$v) {
        var $$exp = _vm.confData,
          $$idx = '煤料设定标准份数';
        if (!Array.isArray($$exp)) {
          _vm.confData['煤料设定标准份数'] = _vm._n($$v)
        } else {
          $$exp.splice($$idx, 1, _vm._n($$v))
        }
      },
      expression: "confData['煤料设定标准份数']"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("--")]), _vm._v(" "), _c('td', [_vm._v("--")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("--")]), _vm._v(" "), _c('td', [_vm._v("--")])])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_vm._l((_vm.tableData.sdz), function(item) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])]
  })] : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("运行状态")])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("原料带")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.yxzt['原料带']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤皮秤")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.yxzt['煤皮秤']))])])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_vm._l((_vm.tableData.yxzt), function(value, key) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value))])])]
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("实时值")])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("原料Kg/s")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fAi['原料流量Kg/s']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤料Kg/s")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fAi['煤料流量Kg/s']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料/煤料")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fhb['原煤时累计比']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤秤电机Hz")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fAi['煤料电机Hz']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("煤秤Kg")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fmc['煤秤重量KG']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("  ")]), _vm._v(" "), _c('td')])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_vm._l((_vm.tableData.fAi), function(item) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.value))])])]
  })] : _vm._e()], 2)]), _vm._v(" "), _c('div', [_c('table', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("时累计")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fHour['原料时累计T']))])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? _c('tr', [_c('td', [_vm._v("煤料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fHour['煤料时累计T']))])]) : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? _c('tr', [_c('td', [_vm._v("加水比例%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fhb['加水时比例%']))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("日累计")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fDay['原料日累计T']))])]), _vm._v(" "), (_vm.deviceInfo.category === '配煤') ? [_c('tr', [_c('td', [_vm._v("煤料T")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fDay['煤料日累计T']))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料/煤料%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fdb['原煤日累计比']))])])] : _vm._e(), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? [_c('tr', [_c('td', [_vm._v("加水比例%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tableData.fdb['加水日比例%']))])])] : _vm._e()], 2)])])])], 1), _vm._v(" "), (_vm.isMobile) ? _c('Mconfirm', {
    attrs: {
      "loading": _vm.loading.confData,
      "show": _vm.edit.type === 'OPEN'
    },
    on: {
      "define": _vm.saveConf,
      "cancel": _vm.closeEdit
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "his-data"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', {
    staticClass: "charts-input"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.table
    },
    on: {
      "click": function($event) {
        _vm.loadHisData()
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.loading.table ? '正在加载' : '刷新数据') + "\n                ")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.chartsData.material) ? _c('el-card', {
    staticClass: "box-card  css-margin-top"
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("产量图表")])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.chart),
      expression: "loading.chart"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.chart),
      expression: "!loading.chart"
    }]
  }, [(!_vm.chartsData) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', {
    ref: "charts"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    staticClass: "box-card  css-margin-top no-padding"
  }, [_c('div', {
    staticClass: "clearfix chars-header",
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("产量报表")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0",
      "position": "relative"
    }
  }, [(_vm.loading.table) ? _c('div', [_c('loading')], 1) : _c('div', {
    ref: "hisTable",
    staticClass: "table-responsive"
  }, [(_vm.hisData.data && _vm.hisData.data.monData) ? _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', [_c('th'), _c('th', [_vm._v("当前月")]), _vm._l((12), function(mon) {
    return _c('th', {
      key: mon
    }, [_vm._v(_vm._s(mon) + "月")])
  })], 2)]), _vm._v(" "), _c('tbody', [(_vm.deviceInfo.category === '配煤') ? _c('tr', [_c('td', [_vm._v("煤料")]), _vm._v(" "), _vm._l((_vm.hisData.data.monData), function(item) {
    return _c('td', [_vm._v("\n                                    " + _vm._s(item.煤料) + "\n                                ")])
  })], 2) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("原料")]), _vm._v(" "), _vm._l((_vm.hisData.data.monData), function(item) {
    return _c('td', [_vm._v("\n                                    " + _vm._s(item.原料) + "\n                                ")])
  })], 2), _vm._v(" "), (_vm.deviceInfo.category === '配水') ? _c('tr', [_c('td', [_vm._v("加水")]), _vm._v(" "), _vm._l((_vm.hisData.data.monData), function(item) {
    return _c('td', [_vm._v("\n                                    " + _vm._s(item.加水) + "\n                                ")])
  })], 2) : _vm._e()])]) : _c('div', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("\n                            暂无数据\n                        ")])]), _vm._v(" "), (_vm.isMobile && _vm.hisData.data && _vm.hisData.data.monData) ? _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": _vm.img_arrow,
      "alt": ""
    },
    on: {
      "touchstart": function($event) {
        _vm.setScroll('left')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img_arrow,
      "alt": ""
    },
    on: {
      "touchstart": function($event) {
        _vm.setScroll('right')
      }
    }
  })]) : _vm._e()])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'not-mobile': !_vm.isMobile
    },
    attrs: {
      "id": "allocateWater"
    }
  }, [(_vm.isMobile) ? [_c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [_c('Mpage-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "index-sider"
  })], 1)] : [_c('page-head'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [_c('page-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "index-sider",
    staticStyle: {
      "position": "fixed"
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen,
    },
    attrs: {
      "id": "main-router"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('page-footer', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    },
    attrs: {
      "id": "main-footer"
    }
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deviceConf"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeOption(true)
        }
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "charts-input"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.changeOption(false)
        }
      }
    }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '手动刷新'))])], 1)
  ], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top controlSet"
  }, [_c('div', {
    staticClass: "box-card m-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数列表")]), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                    " + _vm._s(_vm.deviceConf.time_stamp) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "m-table"
  }, _vm._l((_vm.deviceConf.data), function(item, index) {
    return _c('div', {
      staticClass: "m-table-li"
    }, [_c('div', {
      staticClass: "m-table-label"
    }, [_vm._v("\n                                " + _vm._s(_vm.deviceConfName[item.name]) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "m-table-input"
    }, [_c('div', {
      staticClass: "edit-input"
    }, [_c('p', [_vm._v(_vm._s(item.data))])])])])
  }))])]], 2)]), _vm._v(" "), (_vm.deviceName.data.length) ? _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": ""
    }
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("设备名称表")])]), _vm._v(" "), _c('div', _vm._l((_vm.deviceName.data), function(name) {
    return _c('div', {
      staticClass: "device-name-item"
    }, [_vm._v("\n                    " + _vm._s(name) + "\n                ")])
  }))])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "set-option"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.loadControlConf(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '刷新数据'))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数列表")]), _vm._v(" "), _c('span', {
    staticClass: "time-show"
  }, [_vm._v(_vm._s(_vm.timeShow))]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.tableData.slice(0, Math.round(_vm.tableData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.tableData.slice(Math.round(_vm.tableData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.tableData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', {
            staticStyle: {
              "font-size": "14px"
            }
          }, [_vm._v(_vm._s(scope.row.name))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Mconfirm', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "cancel": _vm.cancel,
      "define": _vm.define
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.open
    }
  }, [_vm._v("confirm")]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "hide-on-click": false
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n          下拉菜单"), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_c('div', [_vm._v("螺蛳粉 "), _c('span', [_vm._v("编辑")])])]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("黄金糕")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("狮子头")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("双皮奶")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_vm._v("蚵仔煎")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  })
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'ismobile': _vm.isMobile
    }
  }, [_c('page-header'), _vm._v(" "), _c('el-card', {
    staticClass: "msg-card"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "alert"
    }
  }, [_c('span', {
    staticClass: "header-label",
    slot: "label"
  }, [_vm._v(" 报警")])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "notice"
    }
  }, [_c('span', {
    staticClass: "header-label",
    slot: "label"
  }, [_vm._v(" 通知")])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "announcement"
    }
  }, [_c('span', {
    staticClass: "header-label",
    slot: "label"
  }, [_vm._v(" 公告")])])], 1), _vm._v(" "), _c('div', _vm._l((_vm.msgList), function(msgItem) {
    return _c('div', {
      staticClass: "msg-item"
    }, [_c('div', {
      staticStyle: {
        "align-self": "flex-start"
      }
    }, [_c('el-checkbox', {
      model: {
        value: (_vm.checked),
        callback: function($$v) {
          _vm.checked = $$v
        },
        expression: "checked"
      }
    })], 1), _vm._v(" "), _c('p', [_vm._v("这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab) + "这是一条长长的" + _vm._s(_vm.activeTab))]), _vm._v(" "), _c('p', [_vm._v("2011-11-05 05:11:11")])])
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checked),
      expression: "checked"
    }],
    staticClass: "tool-bar"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "size": "large",
      "type": "danger"
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "large"
    }
  }, [_vm._v("取消")])], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('p', [_vm._v("成都市高新区科园二路一号201室 028-85192910 028-66052899 13880586898（范小林）18980535778(李)")]), _vm._v(" "), _c('p', [_vm._v("copyright © 2013 成都利马高科有限公司 川ICP备09000473号")])])
}]}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header xxx"
  }, [_c('div', [_c('div', [_c('i', {
    staticClass: "iconfont icon-fanhui1",
    on: {
      "click": _vm.goTodevicesList
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo "
  }, [(_vm.router === 'temp') ? _c('p', [_vm._v(_vm._s(("" + (_vm.deviceInfo.name) + (_vm.dtuID?_vm.dtuID:''))) + " ")]) : _vm._e(), _vm._v(" "), (_vm.router === 'user') ? _c('p', [_vm._v(_vm._s("设备列表") + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "iconfont"
  }, [_c('div', {
    staticClass: "user-info tool-tip",
    staticStyle: {
      "display": "flex"
    }
  }, [(_vm.userInfo.identity === 'USER') ? _c('div', {
    staticClass: "msg-tool-button"
  }, [(!_vm.isMobile) ? _c('div', {
    staticClass: "toggleMsgTool",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.toggleMsgTool
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.msgTool.show ? '关闭' : '发送短消息') + "\n                    ")]) : _c('i', {
    staticClass: "iconfont icon-youjian",
    staticStyle: {
      "font-size": "25px"
    },
    on: {
      "click": _vm.toggleMsgTool
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.msgTool.show) ? _c('div', {
    staticClass: "msg-tool"
  }, [_c('div', {
    staticClass: "msg-tool-input"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入内容",
      "maxlength": 64
    },
    model: {
      value: (_vm.msgTool.msg),
      callback: function($$v) {
        _vm.msgTool.msg = $$v
      },
      expression: "msgTool.msg"
    }
  })], 1), _vm._v(" "), _c('div', [_c('p', {
    on: {
      "click": _vm.setDeviceMsg
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.msgTool.loading,
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.msgTool.loading ? '正在发送' : '发送'))])], 1)])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.userInfo.identity !== 'USER') ? void 0 : _vm._e()], 2)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msgMenu.show),
      expression: "msgMenu.show"
    }],
    staticClass: "msg-menu"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [_c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.loadControlConf(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '手动刷新'))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数设置")]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                        " + _vm._s(_vm.option.time_stamp) + "\n                    ")]), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.option.isEdit),
      expression: "!option.isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.isEdit),
      expression: "option.isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.isEdit),
      expression: "option.isEdit"
    }],
    attrs: {
      "loading": _vm.loading,
      "type": "success"
    },
    on: {
      "click": _vm.saveDeviceConf
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.loading ? '正在加载' : '保存并写入设备') + "\n                        ")])], 1)]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.confData.slice(0, Math.round(_vm.confData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.option.isEdit && _vm.option.canEdit) ? _c('el-input-number', {
            attrs: {
              "disabled": !_vm.option.canEdit,
              "precision": scope.row.precision,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": _vm.checkInputNumber
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.confData.slice(Math.round(_vm.confData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.option.isEdit && _vm.option.canEdit) ? _c('el-input-number', {
            attrs: {
              "precision": scope.row.precision,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": _vm.checkInputNumber
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.confData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', {
            staticStyle: {
              "font-size": "14px"
            }
          }, [_vm._v(_vm._s(scope.row.name))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.option.isEdit && _vm.option.canEdit) ? _c('el-input-number', {
            attrs: {
              "size": "small",
              "precision": scope.row.precision,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": _vm.checkInputNumber
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]], 2)], 1)])
},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tempControl"
    }
  }, [_c('page-head'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [(!_vm.isMobile) ? _c('page-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "index-sider"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('page-footer', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "set-option"
  }, [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeOption('true')
        }
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "charts-input"
    }, [_c('el-button', {
      attrs: {
        "loading": _vm.loading,
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.changeOption(false)
        }
      }
    }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '刷新数据'))])], 1)
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数列表")]), _vm._v(" "), _c('span', {
    staticClass: "time-show"
  }, [_vm._v(_vm._s(_vm.timeShow))]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.tableData.slice(0, Math.round(_vm.tableData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.tableData.slice(Math.round(_vm.tableData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.confData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', {
            staticStyle: {
              "font-size": "14px"
            }
          }, [_vm._v(_vm._s(scope.row.name))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [_c('p', [_vm._v(_vm._s(scope.row.data))])])]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-bg"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('el-button', {
    on: {
      "click": _vm.clickCancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": _vm.clickDefine
    }
  }, [_vm._v(_vm._s(_vm.loading ? '正在通信' : '确认'))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "his-data"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "his-data-option set-option"
  }, [_c('div', [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": _vm.loadHisData
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.val,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.hisData.timeType),
        callback: function($$v) {
          _vm.hisData.timeType = $$v
        },
        expression: "hisData.timeType"
      }
    }, _vm._l((_vm.timeOpt), function(item) {
      return _c('el-option', {
        key: item.val,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))]
  ], 2), _vm._v(" "), _c('div', [
    [_c('el-date-picker', {
      attrs: {
        "type": _vm.option.dateType,
        "placeholder": "选择日期时间",
        "align": "right"
      },
      on: {
        "change": _vm.changeOption
      },
      model: {
        value: (_vm.option.date),
        callback: function($$v) {
          _vm.option.date = $$v
        },
        expression: "option.date"
      }
    })]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "charts-input",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.table
    },
    on: {
      "click": function($event) {
        _vm.loadHisData()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loading.table ? '正在加载' : '刷新数据') + "\n            ")])], 1)]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.chartsData.xData.length > 0) ? _c('el-card', {
    staticClass: "box-card  css-margin-top"
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("产量图表")])]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.chart),
      expression: "loading.chart"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.chart),
      expression: "!loading.chart"
    }]
  }, [(_vm.chartsData.xData.length == 0) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', {
    ref: "charts"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    staticClass: "box-card  css-margin-top no-padding"
  }, [_c('div', {
    staticClass: "clearfix chars-header",
    slot: "header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("产量报表")]), _vm._v(" "), _c('div', [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.exportExcelFn
    }
  }, [_vm._v("下载Excel")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0",
      "position": "relative"
    }
  }, [(_vm.loading.table) ? _c('div', [_c('loading')], 1) : _c('div', {
    ref: "hisTable",
    staticClass: "table-responsive"
  }, [(_vm.hisData.data.length) ? _c('table', {
    staticClass: "table table-responsive"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableHeader), function(th) {
    return _c('th', {
      key: th.id
    }, [_vm._v(_vm._s(th.name))])
  }))]), _vm._v(" "), _c('tbody', [_vm._l((_vm.hisData.data), function(td, index) {
    return _c('tr', {
      key: td.id
    }, _vm._l((_vm.tableHeader), function(th) {
      return _c('td', {
        key: th.id
      }, [(th.key === "leiji") ? _c('span', [_vm._v(_vm._s(index + 1))]) : (th.key === "date" && _vm.hisData.timeType !== "by_month") ? _c('span', [_vm._v(_vm._s(_vm.momentYear(td[th.key])))]) : (th.key === "rate" || th.key === "heat" || th.key === "interval") ? _c('span', [_vm._v(_vm._s(td[th.key] ? (td[th.key].toFixed(0)) : 0))]) : _c('span', [_vm._v(_vm._s(td[th.key] ? td[th.key] : 0))])])
    }))
  }), _vm._v(" "), (_vm.hisData.timeType !== "by_day") ? _c('tr', [_c('td', [_vm._v("平均")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.hisData.average.interval ? _vm.hisData.average.interval.toFixed(0) : 0) + "\n                                ")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.hisData.average.counter ? _vm.hisData.average.counter.toFixed(0) : 0) + "\n                                ")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.hisData.average.heat ? _vm.hisData.average.heat.toFixed(2) : 0) + "\n                                ")]), _vm._v(" "), _c('td', [_vm._v("\n                                    " + _vm._s(_vm.hisData.average.rate ? _vm.hisData.average.rate.toFixed(2) : 0) + "\n                                ")])]) : _vm._e()], 2)]) : _c('div', {
    staticStyle: {
      "line-height": "40px"
    }
  }, [_vm._v("\n                            暂无数据\n                        ")])]), _vm._v(" "), (_vm.isMobile && _vm.hisData.data.length) ? _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    staticStyle: {
      "transform": "rotate(180deg)"
    },
    attrs: {
      "src": _vm.img_arrow,
      "alt": ""
    },
    on: {
      "touchstart": function($event) {
        _vm.setScroll('left')
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.img_arrow,
      "alt": ""
    },
    on: {
      "touchstart": function($event) {
        _vm.setScroll('right')
      }
    }
  })]) : _vm._e()])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deviceConf"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "set-option"
  }, [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeOption(true)
        }
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "charts-input"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.changeOption(false)
        }
      }
    }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '手动刷新'))])], 1)
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top controlSet"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": ""
    }
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("设备配置表")]), _vm._v(" "), _c('span', {
    staticClass: "time-show"
  }, [_vm._v(_vm._s(_vm.deviceConf.time_stamp))]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.loading) ? _c('div', [(!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.deviceConf.data.slice(0, Math.round(_vm.deviceConf.data.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', [_vm._v(_vm._s(_vm.deviceConfName[scope.row.name]))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.isEdit) ? _c('el-input', {
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.deviceConf.data.slice(Math.round(_vm.deviceConf.data.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', [_vm._v(_vm._s(_vm.deviceConfName[scope.row.name]))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.isEdit) ? _c('el-input', {
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.tableData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            model: {
              value: (scope.row.name),
              callback: function($$v) {
                scope.row.name = $$v
              },
              expression: "scope.row.name"
            }
          })]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(_vm.isEdit) ? _c('el-input', {
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          }) : _c('p', [_vm._v(_vm._s(scope.row.data))])], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]) : _c('loading')], 1)], 1), _vm._v(" "), (_vm.deviceName.data.length) ? _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": ""
    }
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("设备名称表")])]), _vm._v(" "), _c('div', _vm._l((_vm.deviceName.data), function(name) {
    return _c('div', {
      staticClass: "device-name-item"
    }, [_vm._v("\n                    " + _vm._s(name) + "\n                ")])
  }))])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "player",
    staticClass: "chartsPlayer",
    on: {
      "touchmove": _vm.noScoll
    }
  }, [_c('div', {
    staticClass: "player-bg",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "charts",
    on: {
      "click": _vm.toggleFloat
    }
  }, [_c('div', {
    ref: "shaojie",
    staticClass: "shaojie"
  }), _vm._v(" "), _c('div', {
    ref: "honggan",
    staticClass: "honggan"
  })]), _vm._v(" "), _c('div', {
    staticClass: "floats"
  }, [(_vm.float.show) ? _c('div', {
    staticClass: "close-button",
    on: {
      "click": _vm.closePlayer
    }
  }, [_c('i', {
    staticClass: "iconfont icon-close"
  })]) : _vm._e(), _vm._v(" "), (_vm.float.show) ? _c('div', {
    staticClass: "table-data"
  }, [_c('div', {
    staticClass: "table-data-float"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "touchstart": function($event) {
        _vm.scrollTable('left')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "touchstart": function($event) {
        _vm.scrollTable('right')
      }
    }
  })]), _vm._v(" "), _c('div', {
    ref: "tableList",
    staticClass: "table-data-list"
  }, [_c('div', {
    staticClass: "list-header"
  }, [_vm._v("\n            烧结\n          ")]), _vm._v(" "), _vm._l((_vm.tableData.shaojie), function(item) {
    return _c('div', {
      staticClass: "list-data"
    }, [_c('div', {
      staticClass: "list-th"
    }, [_vm._v("\n              " + _vm._s(item.th) + "车位\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "list-td"
    }, [_vm._v("\n              " + _vm._s(item.data) + "\n            ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "list-header"
  }, [_vm._v("\n            烘干\n          ")]), _vm._v(" "), _vm._l((_vm.tableData.honggan), function(item) {
    return _c('div', {
      staticClass: "list-data"
    }, [_c('div', {
      staticClass: "list-th"
    }, [_vm._v("\n              " + _vm._s(item.th) + "车位\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "list-td"
    }, [_vm._v("\n              " + _vm._s(item.data) + "\n            ")])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "floats-view",
    on: {
      "click": _vm.toggleFloat
    }
  }), _vm._v(" "), (_vm.float.show) ? _c('div', {
    staticClass: "player-console"
  }, [_c('div', {
    staticClass: "player-progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.progress.width + '%'
    })
  }, [_c('div', {
    staticClass: "progress-block",
    on: {
      "touchstart": _vm.touchStart,
      "touchmove": _vm.touchMove,
      "touchend": _vm.touchEnd
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.tableData.time_stamp))])])])]), _vm._v(" "), _c('div', {
    staticClass: "player-button"
  }, [_c('img', {
    staticClass: "iconfont icon-kuaitui",
    attrs: {
      "src": __webpack_require__(855)
    },
    on: {
      "click": function($event) {
        _vm.clickButton('PRE')
      }
    }
  }), _vm._v(" "), (_vm.player.status === 'PAUSE') ? _c('img', {
    staticClass: "iconfont icon-bofang",
    attrs: {
      "src": __webpack_require__(370)
    },
    on: {
      "click": function($event) {
        _vm.clickButton('PLAY')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.player.status === 'STOP') ? _c('img', {
    staticClass: "iconfont icon-zhongxinbofang",
    attrs: {
      "src": __webpack_require__(370)
    },
    on: {
      "click": function($event) {
        _vm.clickButton('REPLAY')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.player.status === 'PLAY') ? _c('img', {
    staticClass: "iconfont icon-zanting",
    attrs: {
      "src": __webpack_require__(854)
    },
    on: {
      "click": function($event) {
        _vm.clickButton('PAUSE')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "iconfont icon-kuaijin",
    attrs: {
      "src": __webpack_require__(852)
    },
    on: {
      "click": function($event) {
        _vm.clickButton('NEXT')
      }
    }
  })])]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "set-option"
  }, [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeOption(true)
        }
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "charts-input"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.changeOption(false)
        }
      }
    }, [_vm._v(_vm._s(_vm.loading ? '正在加载' : '手动刷新'))])], 1)
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('el-card', {
    staticClass: "box-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数设置")]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                        " + _vm._s(_vm.option.time_stamp) + "\n                    ")]), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.option.isEdit),
      expression: "!option.isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.isEdit),
      expression: "option.isEdit"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.closeEdit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.option.isEdit),
      expression: "option.isEdit"
    }],
    attrs: {
      "loading": _vm.loading,
      "type": "success"
    },
    on: {
      "click": _vm.saveDeviceConf
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.loading ? '正在加载' : '保存并写入设备') + "\n                        ")])], 1)]), _vm._v(" "), (!_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.confData.slice(0, Math.round(_vm.confData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.data))]) : _c('el-input-number', {
            attrs: {
              "disabled": !_vm.option.isEdit,
              "precision": scope.row.prec,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": function($event) {
                _vm.checkInputNumber(scope.row.data, scope.$index)
              }
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          })], 1)]
        }
      }])
    })], 1)], _vm._v(" "), [_c('el-table', {
      staticClass: "val-table",
      attrs: {
        "data": _vm.confData.slice(Math.round(_vm.confData.length / 2))
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.data))]) : _c('el-input-number', {
            attrs: {
              "min": scope.row.min,
              "precision": scope.row.prec,
              "step": scope.row.step,
              "max": scope.row.max
            },
            on: {
              "change": function($event) {
                _vm.checkInputNumber(scope.row.data, scope.$index)
              }
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          })], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "table-list"
  }, [
    [_c('el-table', {
      staticClass: "mobile-val-table",
      attrs: {
        "data": _vm.confData
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "name",
        "label": "参数名"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('p', {
            staticStyle: {
              "font-size": "14px"
            }
          }, [_vm._v(_vm._s(scope.row.name))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "data",
        "label": "参数值"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "edit-input"
          }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(scope.row.data))]) : _c('el-input', {
            attrs: {
              "size": "small",
              "precision": scope.row.prec,
              "step": scope.row.step,
              "min": scope.row.min,
              "max": scope.row.max
            },
            on: {
              "change": function($event) {
                _vm.checkInputNumber(scope.row.data, scope.$index)
              }
            },
            model: {
              value: (scope.row.data),
              callback: function($$v) {
                scope.row.data = $$v
              },
              expression: "scope.row.data"
            }
          })], 1)]
        }
      }])
    })], 1)]
  ], 2) : _vm._e()]], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "controlSet"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "option-select"
  }, [
    [_c('el-select', {
      staticClass: "charts-input",
      attrs: {
        "placeholder": "请选择"
      },
      on: {
        "change": function($event) {
          _vm.changeOption(true)
        }
      },
      model: {
        value: (_vm.option.sys_alias),
        callback: function($$v) {
          _vm.option.sys_alias = $$v
        },
        expression: "option.sys_alias"
      }
    }, _vm._l((_vm.sys_alias), function(item) {
      return _c('el-option', {
        key: item.id,
        attrs: {
          "label": item.label,
          "value": item.val
        }
      })
    }))], _vm._v(" "), _c('div', {
      staticClass: "charts-input"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "loading": _vm.loading
      },
      on: {
        "click": function($event) {
          _vm.changeOption(false)
        }
      }
    }, [_vm._v(_vm._s(_vm.loading ? '正在加载' :
      '手动刷新') + "\n                ")])], 1)
  ], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "css-margin-top"
  }, [_c('div', {
    staticClass: "box-card m-card",
    attrs: {
      "body-style": "{min-height:'300px'}"
    }
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("参数设置")]), _vm._v(" "), _c('div', [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.option.isEdit),
      expression: "!option.isEdit"
    }],
    attrs: {
      "type": "success",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.openEdit
    }
  }, [_vm._v("编辑\n                        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                    " + _vm._s(_vm.option.time_stamp) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "m-table"
  }, _vm._l((_vm.confData), function(item, index) {
    return _c('div', {
      staticClass: "m-table-li"
    }, [_c('div', {
      staticClass: "m-table-label"
    }, [_vm._v("\n                                   " + _vm._s(item.name) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "m-table-input"
    }, [_c('div', {
      staticClass: "edit-input"
    }, [(!_vm.option.isEdit) ? _c('p', [_vm._v(_vm._s(item.data))]) : _c('el-input', {
      attrs: {
        "size": "small"
      },
      on: {
        "change": function($event) {
          _vm.checkInputNumber(item.data, index)
        }
      },
      model: {
        value: (item.data),
        callback: function($$v) {
          item.data = $$v
        },
        expression: "item.data"
      }
    })], 1)])])
  }))])]], 2)]), _vm._v(" "), _c('Mconfirm', {
    attrs: {
      "loading": _vm.loading,
      "show": _vm.option.isEdit && !_vm.loading
    },
    on: {
      "cancel": _vm.closeEdit,
      "define": _vm.saveDeviceConf
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "el-button",
    class: [
      _vm.type ? 'el-button--' + _vm.type : '',
      _vm.size ? 'el-button--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain
      }
    ],
    attrs: {
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('i', {
    class: 'el-icon-' + _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "realData"
  }, [_c('page-header'), _vm._v(" "), (!_vm.isMobile) ? _c('el-row', {
    staticClass: "set-option",
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.aliasNo),
      callback: function($$v) {
        _vm.option.aliasNo = $$v
      },
      expression: "option.aliasNo"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "类型"
    },
    model: {
      value: (_vm.option.selectType),
      callback: function($$v) {
        _vm.option.selectType = $$v
      },
      expression: "option.selectType"
    }
  }, _vm._l((_vm.chartsType), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), (_vm.stand.list && _vm.stand.list.length) ? _c('el-col', {
    staticClass: "chars-title",
    attrs: {
      "span": 12
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "请选择砖类型"
    },
    on: {
      "change": _vm.changeStandType
    },
    model: {
      value: (_vm.stand.type),
      callback: function($$v) {
        _vm.stand.type = $$v
      },
      expression: "stand.type"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": index + ':' + item[index],
        "value": index
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.openSetStandType
    }
  }, [_vm._v("砖类型设置")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.saveStandConf(true)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.loading.standard ? '正在加载' : '同步设置至设备') + "\n                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.loadStandConf(false)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.loading.standard ? '正在加载' : '刷新数据') + "\n                ")])], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.isMobile) ? _c('div', {
    staticClass: "mobile-top-bar"
  }, [_c('div', [_c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "size": "small",
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.aliasNo),
      callback: function($$v) {
        _vm.option.aliasNo = $$v
      },
      expression: "option.aliasNo"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), (_vm.stand.list && _vm.stand.list.length) ? _c('div', [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "size": "small",
      "placeholder": "请选择砖类型"
    },
    on: {
      "change": _vm.changeStandType
    },
    model: {
      value: (_vm.stand.type),
      callback: function($$v) {
        _vm.stand.type = $$v
      },
      expression: "stand.type"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return (item[index]) ? _c('el-option', {
      key: index,
      attrs: {
        "label": item[index],
        "value": index
      }
    }) : _vm._e()
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "size": "small",
      "placeholder": "类型"
    },
    model: {
      value: (_vm.option.selectType),
      callback: function($$v) {
        _vm.option.selectType = $$v
      },
      expression: "option.selectType"
    }
  }, _vm._l((_vm.chartsType), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', [_c('el-button', {
    on: {
      "click": _vm.openSetStandType
    }
  }, [_vm._v("砖类型设置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading.standard
    },
    on: {
      "click": function($event) {
        _vm.saveStandConf(true)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loading.standard ? '正在加载' : '同步设置至设备') + "\n            ")])], 1)]) : _vm._e(), _vm._v(" "), [(_vm.loading.standard) ? _c('el-card', {
    staticClass: "box-card  css-margin-top no-padding"
  }, [_c('loading')], 1) : _vm._l((_vm.standConf), function(itemType, key) {
    return _c('el-card', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (itemType && itemType.length && _vm.option.selectType === key),
        expression: "itemType&&itemType.length&&option.selectType===key"
      }],
      key: key,
      staticClass: "box-card  css-margin-top no-padding"
    }, [_c('div', {
      staticClass: "clearfix chars-header"
    }, [_c('span', {
      staticClass: "card-header-title"
    }, [_vm._v(_vm._s(_vm.confTypeName[key]) + "\n        "), _c('span', [_vm._v("（单位：℃)")])]), _vm._v(" "), (!_vm.isMobile) ? _c('div', [(_vm.isEdit) ? _c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.isEdit = false
        }
      }
    }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": _vm.isEdit ? 'success' : 'text'
      },
      on: {
        "click": _vm.openEdit
      }
    }, [_vm._v(_vm._s(_vm.isEdit ? "保存并写入设备" : "编辑") + "\n                    ")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "card-body "
    }, [_c('div', {
      staticClass: "leemma-table"
    }, _vm._l((itemType), function(item) {
      return _c('div', {
        key: item.id
      }, [_c('div', {
        staticClass: "leemma-table-th"
      }, [_vm._v("\n                            " + _vm._s(item.key) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "leemma-table-td"
      }, [(!_vm.isEdit) ? _c('p', [_vm._v(_vm._s(item.data))]) : _c('el-input', {
        model: {
          value: (item.data),
          callback: function($$v) {
            item.data = $$v
          },
          expression: "item.data"
        }
      })], 1)])
    }))])])
  }), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading.echarts),
      expression: "!loading.echarts"
    }],
    staticClass: "box-card  css-margin-top quxian"
  }, [_c('div', {
    staticClass: "clearfix chars-header"
  }, [_c('span', {
    staticClass: "card-header-title"
  }, [_vm._v("标准参数对比曲线\n                    "), _c('span', [_vm._v("（单位：℃)")])]), _vm._v(" "), _c('div', {
    staticClass: "time-show"
  }, [_vm._v("\n                    " + _vm._s(_vm.option.time_stamp) + "\n\n                ")]), _vm._v(" "), _c('span')]), _vm._v(" "), (!_vm.oldConf) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', [_c('div', {
    ref: "charts"
  })])])], _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "砖类型设置",
      "visible": _vm.dialog.standType,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog.standType = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-body"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "label-width": "30px"
    }
  }, _vm._l((_vm.stand.list), function(item, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": index.toString()
      }
    }, [_c('el-input', {
      attrs: {
        "maxlength": 20,
        "placeholder": "砖类型"
      },
      model: {
        value: (item[index]),
        callback: function($$v) {
          var $$exp = item,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            item[index] = $$v
          } else {
            $$exp.splice($$idx, 1, $$v)
          }
        },
        expression: "item[index]"
      }
    })], 1)
  }))], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.saveStandType
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog.standType = false
      }
    }
  }, [_vm._v("关闭")])], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "drop-time-picker"
    }
  }, [_c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropBox1.show),
      expression: "dropBox1.show"
    }]
  }, [_c('div', {
    staticClass: "drop-container"
  }, [_c('div', {
    staticClass: "drop-box day-list"
  }, [_c('p', {
    staticClass: "th-header"
  }, [_vm._v(" 日期")]), _vm._v(" "), _c('div', {
    ref: "scrollDay",
    staticClass: "scrollbar"
  }, [_vm._l((_vm.dayList), function(day) {
    return _c('div', {
      key: day.id,
      staticClass: "label",
      class: {
        'label-selected': _vm.selected.day === day.value
      },
      on: {
        "click": function($event) {
          _vm.selectDay(day.value)
        }
      }
    }, [_vm._v("\n              " + _vm._s(day.label) + "\n            ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "label",
    on: {
      "click": function($event) {
        _vm.selectDay('more')
      }
    }
  }, [_c('span', [_vm._v("\n                               更多\n                          ")]), _vm._v(" "), _c('div', {
    ref: "datePicker",
    staticStyle: {
      "position": "absolute",
      "z-index": "-1",
      "top": "0"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "align": "left",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.addDayfn
    },
    model: {
      value: (_vm.selected.addDay),
      callback: function($$v) {
        _vm.selected.addDay = $$v
      },
      expression: "selected.addDay"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "label"
  })], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.selected.day) ? _c('div', {
    staticClass: "drop-box hour-list"
  }, [_c('p', {
    staticClass: "th-header"
  }, [_vm._v(" 小时")]), _vm._v(" "), _c('div', {
    ref: "scrollHour",
    staticClass: "scrollbar"
  }, [_vm._l((24), function(one, index) {
    return _c('div', {
      key: one.id,
      staticClass: "label hour-col",
      class: {
        'label-selected': _vm.selected.hourIndex == index, 'no-data-hour': !_vm.oneDayData[index]
      },
      attrs: {
        "asdasd": _vm.oneDayData[index] && !_vm.oneDayData[index].length
      },
      on: {
        "click": function($event) {
          _vm.selectHour(index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(index >= 10 ? index : ('0' + index)) + "\n              ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  })], 2)]) : _vm._e()]), _vm._v(" "), (_vm.listData.length || _vm.loading) ? _c('div', {
    staticClass: "drop-box item-list"
  }, [(_vm.loading) ? _c('loading') : _c('div', {
    ref: "scrollItem",
    staticClass: "scrollbar"
  }, [_c('table', {
    ref: "floatTable",
    staticClass: "table"
  }, [_c('thead', [(_vm.type === 'ALLOCATE') ? _c('tr', [_c('th', [_vm._v("时间(分)")]), _vm._v(" "), _vm._l((_vm.listData[0]), function(data, dataKey) {
    return (dataKey !== 'time_stamp') ? [_vm._l((data), function(value, key) {
      return [_c('th', {
        key: key
      }, [_vm._v("\n                        " + _vm._s(key) + "\n                      ")])]
    })] : _vm._e()
  })], 2) : _c('tr', [_c('th', [_vm._v("时间(分)")]), _vm._v(" "), _vm._l((_vm.listData[0] && _vm.listData[0].shaojie.concat(_vm.listData[0].cewen)), function(th) {
    return _c('th', {
      key: th.id
    }, [_vm._v("\n                    " + _vm._s(th.th.length > 3 ? th.th : (th.th + '车位')) + "\n                  ")])
  })], 2)]), _vm._v(" "), (_vm.type === 'ALLOCATE') ? _c('tbody', [_vm._l((_vm.listData), function(tr, $index) {
    return _c('tr', {
      key: tr.id,
      class: {
        selected: _vm.selected.itemIndex === $index
      },
      on: {
        "click": function($event) {
          _vm.selectItem($index)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.moment(tr && tr.time_stamp).format("mm")))]), _vm._v(" "), _vm._l((_vm.listData[$index]), function(data, dataKey) {
      return (dataKey !== 'time_stamp') ? [_vm._l((data), function(value, key) {
        return [_c('td', {
          key: key
        }, [_vm._v("\n                        " + _vm._s(value) + "\n                      ")])]
      })] : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('tr', [_c('td')])], 2) : _c('tbody', [_vm._l((_vm.listData), function(tr, $index) {
    return _c('tr', {
      key: tr.id,
      class: {
        selected: _vm.selected.itemIndex === $index
      },
      on: {
        "click": function($event) {
          _vm.selectItem($index)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(_vm.moment(tr && tr.time_stamp).format("mm")))]), _vm._v(" "), _vm._l((tr && tr.shaojie.concat(tr.cewen)), function(td) {
      return _c('td', {
        key: td.id
      }, [_vm._v("\n                  " + _vm._s(td.data) + "\n                ")])
    })], 2)
  }), _vm._v(" "), _c('tr', [_c('td')])], 2)])])], 1) : _c('div', {
    staticClass: "item-list"
  }, [_c('p', {
    staticStyle: {
      "margin": "50px auto",
      "text-align": "center"
    }
  }, [_vm._v("暂无数据")])])], 1), _vm._v(" "), (_vm.control) ? _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    on: {
      "mousedown": function($event) {
        _vm.selectButtonDown('PRE')
      },
      "mouseup": _vm.selectButtonUp
    }
  }, [_c('div', {
    staticClass: "player-button"
  }, [_c('i', {
    staticClass: "iconfont icon-kuaitui"
  })])]), _vm._v(" "), _c('div', {
    on: {
      "mousedown": function($event) {
        _vm.selectButtonDown('NEXT')
      },
      "mouseup": _vm.selectButtonUp
    }
  }, [_c('div', {
    staticClass: "player-button"
  }, [_c('i', {
    staticClass: "iconfont icon-kuaijin"
  })])])]) : _vm._e()])])], 1)
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header xxx",
    style: ({
      width: (_vm.isOpen ? _vm.openWidth : _vm.clientWidth) + 'px',
      left: _vm.openLeft + 'px'
    })
  }, [_c('div', [(!_vm.isMobile) ? _c('div', {
    staticClass: "logo"
  }, [_c('i', {
    staticClass: "iconfont icon-tubiaozhizuomoban-copy",
    on: {
      "click": _vm.toggleSide
    }
  })]) : _c('div'), _vm._v(" "), _c('div', {
    staticClass: "logo "
  }, [(_vm.router === 'temp') ? _c('p', [_vm._v(_vm._s(("" + (_vm.deviceInfo.name) + (_vm.dtuID?_vm.dtuID:''))) + " ")]) : _vm._e(), _vm._v(" "), (_vm.router === 'user') ? _c('p', [_vm._v(_vm._s("设备列表") + " ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "iconfont"
  }, [_c('div', {
    staticClass: "user-info tool-tip",
    staticStyle: {
      "display": "flex"
    }
  }, [(!_vm.isMobile) ? _c('div', {
    staticClass: "msg-tool-button"
  }, [(!_vm.isMobile) ? _c('div', {
    staticClass: "toggleMsgTool",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.toggleMsgTool
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.msgTool.show ? '关闭' : '发送短消息') + "\n                    ")]) : _c('i', {
    staticClass: "iconfont icon-youjian",
    staticStyle: {
      "font-size": "25px"
    },
    on: {
      "click": _vm.toggleMsgTool
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.msgTool.show) ? _c('div', {
    staticClass: "msg-tool"
  }, [_c('div', {
    staticClass: "msg-tool-input"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入内容",
      "maxlength": 64
    },
    model: {
      value: (_vm.msgTool.msg),
      callback: function($$v) {
        _vm.msgTool.msg = $$v
      },
      expression: "msgTool.msg"
    }
  })], 1), _vm._v(" "), _c('div', [_c('p', {
    on: {
      "click": _vm.setDeviceMsg
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.msgTool.loading,
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.msgTool.loading ? '正在发送' : '发送'))])], 1)])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', [_c('p', {
    staticClass: "user-avatar"
  }, [(!_vm.userInfo.avatar) ? _c('i', {
    staticClass: "iconfont icon-yonghu",
    staticStyle: {
      "border": "2px solid",
      "border-radius": "50%",
      "font-size": "21px",
      "padding": "2px",
      "margin-right": "5px"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }), _vm._v("\n                        " + _vm._s(_vm.userInfo.name))])]) : _vm._e()])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.msgMenu.show),
      expression: "msgMenu.show"
    }],
    staticClass: "msg-menu"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "realData"
  }, [_c('page-header'), _vm._v(" "), (!_vm.isMobile) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "窑号"
    },
    on: {
      "change": _vm.loadBrick
    },
    model: {
      value: (_vm.option.sys_alias),
      callback: function($$v) {
        _vm.option.sys_alias = $$v
      },
      expression: "option.sys_alias"
    }
  }, _vm._l((_vm.sys_alias), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "charts-input",
    attrs: {
      "placeholder": "类型"
    },
    on: {
      "change": _vm.dealChartsData
    },
    model: {
      value: (_vm.option.chartsType),
      callback: function($$v) {
        _vm.option.chartsType = $$v
      },
      expression: "option.chartsType"
    }
  }, _vm._l((_vm.chartsType), function(item) {
    return _c('el-option', {
      key: item.val,
      attrs: {
        "label": item.label,
        "value": item.val
      }
    })
  }))], 1), _vm._v(" "), _c('el-col', {
    staticClass: "chars-title",
    attrs: {
      "siderOpen": _vm.siderbarOpen,
      "span": 12
    }
  }), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    },
    attrs: {
      "offset": 3,
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.loading.realData,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.loadRealDataFn('show')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.loading.realData ? '正在加载' : '刷新实时数据') + "\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-card', {
    staticClass: "box-card  quxian"
  }, [_c('div', [_c('div', {
    staticClass: "clearfix real-charts-header drop-header"
  }, [_c('span', [_vm._v("\n                    曲线时间 "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.openTimePicker
    }
  }, [_vm._v(_vm._s(_vm.timeLineData.show ? '关闭' : '历史数据'))])], 1), _vm._v(" "), (!_vm.loading.realData && !_vm.isMobile) ? _c('span', {
    staticClass: "time-show"
  }, [_vm._v("\n                    " + _vm._s(_vm.tableData && _vm.tableData.time_stamp) + "  " + _vm._s(_vm.stand.list.length && _vm.stand.list[_vm.stand.type][_vm.stand.type]) + "\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.isMobile) ? _c('div', [(!_vm.stand.edit && _vm.userInfo.identity == 'USER') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.openStandEdit
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#charts"
    }
  }, [_vm._v("开始修改标准参数")])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('drop-time-picker', {
    attrs: {
      "show": _vm.timeLineData.show,
      "loading": _vm.loading.hisData,
      "data": _vm.hisData
    },
    on: {
      "selectDate": _vm.changeDate,
      "selectItem": _vm.selectHisData,
      "selectButtonChartsFn": _vm.selectButtonChartsFn
    }
  })], 1), _vm._v(" "), (_vm.loading.realData) ? _c('div', [_c('loading')], 1) : (!_vm.hisData.length && !_vm.tableData && !_vm.loading.realData) ? _c('div', {
    staticClass: "img-no-data"
  }, [_c('img', {
    attrs: {
      "src": _vm.img_no_data,
      "alt": "暂无数据"
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂无数据")])]) : _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.isMobile) ? _c('div', {
    staticClass: "edit-stand-mobile"
  }, [(!_vm.stand.edit && _vm.userInfo.identity == 'USER') ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.openStandEdit
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "href": "#charts"
    }
  }, [_vm._v("开始修改标准参数")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.loading.realData && _vm.isMobile) ? _c('span', {
    staticClass: "time-show-mobile"
  }, [_vm._v("\n                    " + _vm._s(_vm.tableData && _vm.tableData.time_stamp) + _vm._s(_vm.stand.list.length && _vm.stand.list[_vm.stand.type][_vm.stand.type]) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "charts",
    staticStyle: {
      "min-height": "200px"
    },
    attrs: {
      "name": "charts",
      "id": "charts"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "table-list"
  }, [_c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.stand.edit) ? _c('div', {
    staticClass: "vfor-list"
  }, [_vm._l((_vm.stand.data), function(itemType, key) {
    return (key === _vm.option.chartsType) ? [_c('el-card', {
      key: key,
      staticClass: "box-card vfor-card no-padding"
    }, [_c('div', {
      staticClass: "clearfix chars-header"
    }, [_c('span', {
      staticClass: "card-header-title"
    }, [_vm._v("设置标准参数-" + _vm._s(_vm.tableTypeName[key]))]), _vm._v(" "), (!_vm.isMobile) ? _c('div', [_c('el-button', {
      attrs: {
        "type": "text"
      },
      on: {
        "click": _vm.openStandEdit
      }
    }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "loading": _vm.loading.standConf,
        "type": "success"
      },
      on: {
        "click": _vm.setStandConf
      }
    }, [_vm._v("保存\n                                ")])], 1) : _vm._e()]), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
      staticClass: "card-body table-responsive "
    }, [_c('div', {
      staticClass: "leemma-table"
    }, _vm._l((itemType), function(item) {
      return _c('div', {
        key: item.id
      }, [_c('div', {
        staticClass: "leemma-table-th"
      }, [_vm._v("\n                                        " + _vm._s(item.key) + "\n                                    ")]), _vm._v(" "), _c('div', {
        staticClass: "leemma-table-td"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.data),
          expression: "item.data"
        }],
        staticStyle: {
          "width": "80px",
          "text-align": "center"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.data)
        },
        on: {
          "change": _vm.editStandInput,
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.data = $event.target.value
          },
          "blur": function($event) {
            _vm.$forceUpdate()
          }
        }
      })])])
    }))])])] : _vm._e()
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.tableData) ? _c('el-card', [
    [_c('div', [_c('div', {
      staticClass: "card-body table-responsive "
    }, [_c('div', {
      staticClass: "m-leemma-table"
    }, [_vm._l((_vm.tableData), function(itemType, key) {
      return (itemType && itemType.length && key !== 'time_stamp') ? [_c('div', {
        key: key,
        staticClass: "m-leemma-table-tr m-leemma-table-title"
      }, [(key === 'fengji') ? _c('div', {
        staticClass: "fengji"
      }, [_c('span', [_vm._v(_vm._s(_vm.tableTypeName[key]))]), _c('span', {
        on: {
          "click": _vm.openFengjiEdit
        }
      }, [_c('el-button', {
        attrs: {
          "type": "text"
        }
      }, [_vm._v("修改")])], 1)]) : _c('div', {}, [_vm._v(_vm._s(_vm.tableTypeName[key]))])]), _vm._v(" "), _vm._l((itemType), function(item) {
        return _c('div', {
          key: item.id,
          staticClass: "m-leemma-table-tr"
        }, [_c('div', {
          staticClass: "m-leemma-table-th"
        }, [_vm._v("\n                                        " + _vm._s(item.key) + "\n                                    ")]), _vm._v(" "), _c('div', {
          staticClass: "m-leemma-table-td",
          class: {
            'font-red': item.data > 800
          }
        }, [_vm._v("\n                                        " + _vm._s((item.data > 1200 || item.data < -500) ? "----" : item.data) + "\n                                    ")])])
      })] : _vm._e()
    })], 2)])])]
  ], 2) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "修改风机频率",
      "visible": _vm.fengji.show,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.fengji.show = $event
      }
    }
  }, [_c('div', {
    staticClass: "fengji-dialog"
  }, [_c('div', [_c('p', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("选择风机")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "选择风机"
    },
    on: {
      "change": _vm.selectFenji
    },
    model: {
      value: (_vm.fengji.selected),
      callback: function($$v) {
        _vm.fengji.selected = $$v
      },
      expression: "fengji.selected"
    }
  }, _vm._l((_vm.realData.fengji), function(opt, index) {
    return _c('el-option', {
      key: opt.key,
      attrs: {
        "label": opt.key,
        "value": index
      }
    })
  }))], 1), _vm._v(" "), _c('div', [_c('p', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("设置频率")]), _vm._v(" "), _c('el-input', {
    model: {
      value: (_vm.fengji.payload.fjPl),
      callback: function($$v) {
        _vm.fengji.payload.fjPl = _vm._n($$v)
      },
      expression: "fengji.payload.fjPl"
    }
  })], 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.fengji.payload.flag),
      callback: function($$v) {
        _vm.fengji.payload.flag = $$v
      },
      expression: "fengji.payload.flag"
    }
  }, [_vm._v("软手动")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveFenji
    }
  }, [_vm._v("确 定")])], 1)])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": _vm.errorImg,
      "alt": "error"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "err-msg"
  }, [_c('h3', {
    staticClass: "err-title"
  }, [_vm._v(_vm._s(_vm.title) + "!")]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    attrs: {
      "href": _vm.config.adminHost + 'login'
    }
  }, [_c('span', [_c('i', {
    staticClass: "iconfont icon-refresh"
  }), _c('a', {
    attrs: {
      "href": _vm.config.adminHost + 'leemmaCustomer'
    }
  }, [_vm._v("重新登陆")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "err-body"
  }, [_c('p', [_vm._v("可能原因")]), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_vm._v("网络信号弱")]), _vm._v(" "), _c('li', [_vm._v("权限不足")]), _vm._v(" "), _c('li', [_vm._v("网站维护")])])])])
}]}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aside content"
  }, [_c('div', [_c('div', {
    staticClass: "side-list"
  }, [
    [(_vm.userInfo.identity === 'CUSTOMER') ? _c('div', {
      staticClass: "side-back",
      on: {
        "click": function($event) {
          _vm.handleSelect('/user?sider=true')
        }
      }
    }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.userInfo.identity === 'USER') ? _c('div', {
      staticClass: "side-back",
      on: {
        "click": function($event) {
          _vm.handleSelect('services.leemma.com')
        }
      }
    }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.sideList.MtempControl), function(item, index) {
      return (_vm.router === 'MTEMP' && item.show) ? _c('div', {
        key: item.path,
        staticClass: "side-item",
        class: {
          'is-active': _vm.$route.path == item.path
        },
        on: {
          "click": function($event) {
            _vm.handleSelect(item.path)
          }
        }
      }, [_c('p', [_c('i', {
        staticClass: "iconfont",
        class: item.icon
      }), _vm._v(_vm._s(item.name))])]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.sideList.allocateWater), function(item, index) {
      return (_vm.router === 'WATER' && item.show) ? _c('div', {
        key: item.path,
        staticClass: "side-item",
        class: {
          'is-active': _vm.$route.path == item.path
        },
        on: {
          "click": function($event) {
            _vm.handleSelect(item.path)
          }
        }
      }, [_c('p', [_c('i', {
        staticClass: "iconfont",
        class: item.icon
      }), _vm._v(_vm._s(item.name))])]) : _vm._e()
    })], _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "15px"
      }
    }, [_vm._v("\n                 \n            ")])
  ], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [(_vm.msgTool.show) ? _c('div', {
    staticClass: "msg-tool"
  }, [_c('div', {
    staticClass: "msg-tool-input"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入内容",
      "maxlength": 64
    },
    model: {
      value: (_vm.msgTool.msg),
      callback: function($$v) {
        _vm.msgTool.msg = $$v
      },
      expression: "msgTool.msg"
    }
  })], 1), _vm._v(" "), _c('div', [_c('p', {
    on: {
      "click": _vm.setDeviceMsg
    }
  }, [_c('el-button', {
    attrs: {
      "loading": _vm.msgTool.loading,
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.msgTool.loading ? '' : '发送'))])], 1)])]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "iconfont icon-fanhui1"
  }), _vm._v("返回列表")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "iconfont icon-fanhui1"
  }), _vm._v("返回后台")])
}]}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header css-margin-top"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.title === '工艺曲线') ? _c('div', {
    staticClass: "state",
    class: {
      'state-off': _vm.deviceInfo.device_status !== '在线'
    }
  }) : _vm._e(), _vm._v(" "), (_vm.title === '工艺曲线') ? _c('div', {
    staticClass: "device-statue"
  }, [_vm._v("\n      " + _vm._s(_vm.deviceInfo.device_status) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index-slider"
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.percentage + '%'
    })
  })])])
},staticRenderFns: []}

/***/ })
],[484]);


// WEBPACK FOOTER //
// static/js/app.39b6663421334f29aed5.js